import React from 'react';
import { appMethod as app } from '@utils/app';
import { convertStyleData } from '@utils/tools';
import { Carousel } from 'antd-mobile';
import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';
import { RequestStatus } from 'src/common/request-status/RequestStatus';

import './DrinkVerticalListCustomComponent.less';
let price = {
  price: function(a, b) {
    var c = (a - b).toFixed(2);
    return c
  },
  shopScore: function(a, b) {
    var c = ((1 - (b - a) / b).toFixed(2)) * 100;
    return c;
  },
  pxToRpx: function(size) {
    return parseInt(size) * 2.34375 / 100 + 'rem';
  },
  parseStyle: function(style) {
    var styleArr1 = ["width", "font-size",'margin-left'];
    var styleArr2 = ["background-color", 'color','font-style','font-weight','text-decoration'];
    var s = '';
    for (var i = 0; i < styleArr1.length; i++) {
      var idx = styleArr1[i];
      if(style[idx]){
        s += idx + ':' + (parseInt(style[idx]) * 2.34375 / 100) + 'rem;'
        if(idx == "height"){
          s += 'line-height:' + (parseInt(style[idx]) * 2.34375 / 100) + 'rem;'
        }
      }
    }
    for (var i = 0; i < styleArr2.length; i++) {
      var idx = styleArr2[i];
      if(style[idx]){
        s += idx + ':' + style[idx] + ';'
      }
    }
    return s;
  },
  hasPickUp: function(pick_up_arr, pick_up_type) {
    if(pick_up_arr && pick_up_arr.length){
      return pick_up_arr.indexOf(pick_up_type)
    }
    return -1;
  },
  getNumber: function(string) {
    return parseInt(string);
  }
}

export default class DrinkVerticalListCustomComponent extends React.Component {

  constructor(props) {
    super(props);
    let compindex = props.index;
    let pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance, true);
  }

  drinkVerticalListChangeEvaluate = (e) => {
    this.verticalListChangeEvaluate(e)
  }

  drinkVerticalListShowGoodsSearch = (e) => {
    this.verticalListShowGoodsSearch(e);
  }

  drinkVerticalListHideGoodsSearch = (e) => {
    this.verticalListHideGoodsSearch(e);
  }

  drinkVerticalListBindSearchTitle = (e) => {
    this.verticalListBindSearchTitle(e);
  }

  drinkVerticalListSearchByTitle = (e) => {
    this.verticalListSearchByTitle(e);
  }

  drinkVerticalListClickCategory = (e) => {
    this.verticalListClickCategory(e);
  }

  drinkVerticalListStyleScrollFunc = (e) => {
    this.verticalListStyleScrollFunc(e);
  }

  drinkVerticalListStyleScrollTop = (e) => {
    this.verticalListStyleScrollTop(e);
  }

  drinkSortVerticalList = (e) => {
    this.sortVerticalList(e);
  }

  showDrinkVerticalListGoodsDetail = (e) => {
    this.showVerticalListGoodsDetail(e);
  }

  drinkAddModelNum = (e) => {
    this.addModelNum(e);
  }

  drinkMinusModelNum = (e) => {
    this.minusModelNum(e);
  }

  drinkVerticalListListMinus = (e) => {
    this.verticalListListMinus(e);
  }

  drinkVerticalListListPlus = (e) => {
    this.verticalListListPlus(e);
  }

  drinkVerticalListSearchScrollFunc = (e) => {
    this.verticalListSearchScrollFunc(e);
  }

  drinkShowShoppingCartPop = (e) => {
    this.verticalListShowShoppingCartPop(e);
  }

  drinkChangeAssessType = (e) => {
    this.verticalListChangeAssessType(e);
  }

  drinkGetMoreAssess = (e) => {
    this.verticalListGetMoreAssess(e);
  }

  openDrinkLocation = (e) => {
    this.openVerticalListLocation(e);
  }

  drinkHideDetailPop = (e) => {
    this.verticalListHideDetailPop(e);
  }

  drinkGetMoreGoodsAssess = (e) => {
    this.verticalListGetMoreGoodsAssess(e);
  }

  drinkHideModelPop = (e) => {
    this.verticalListHideModelPop(e);
  }

  drinkChooseModel = (e) => {
    this.verticalListChooseModel(e);
  }

  drinkSureChooseModel = (e) => {
    this.verticalListSureChooseModel(e);
  }

  drinkMinuModel = (e) => {
    this.verticalListMinuModel(e);
  }

  drinkHideShoppingCart = (e) => {
    this.verticalListHideShoppingCart(e);
  }

  drinkDeleteAllCarts = (e) => {
    this.verticalListDeleteAllCarts(e);
  }

  drinkCartListMinus = (e) => {
    this.verticalListCartListMinus(e);
  }

  drinkCartListPlus = (e) => {
    this.verticalListCartListPlus(e);
  }

  drinkHideCouponsList = (e) => {
    this.verticalListHideCouponsList(e);
  }

  drinkDeleteSingleCarts = (e) => {
    this.deleteSingleCarts(e);
  }

  drinkSelectGoodsSameJourney = (e, compindex) => {
    this.vlSelectGoodsSameJourney(e, compindex)
  }

  drinkSelectSettlement = (e) => {
    this.verticalListSettlement(e);
  }

  drinkCloseVipDialog = (e) => {
    this.verticalListCloseVipDialog(e);
  }

  drinkDeleteBuyerCarts = (e) => {
    this.verticalListDeleteBuyerCarts(e);
  }

  drinkToSetMeal = (e) => {
    this.toSetMeal(e);
  }

  drinkMealDetailTab = (e) => {
    this.mealDetailTab(e);
  }

  drinkChooseAttr = (e) => {
    this.verticalListChooseAttr(e);
  }

  drinkAddAttrGoods = (e) => {
    this.addAttrGoods(e);
  }

  drinkMinuAttrGoods = (e) => {
    this.minuAttrGoods(e);
  }

  drinkCheckedPickRadioFn = (event) => {
    this.checkedPickRadioFn(event);
  }

  drinkConfirmGoodsPick = (event) => {
    this.confirmGoodsPick(event);
  }

  drinkStopMove = () => {
    return;
  }

  drinkTurnToChainStoreList = () => {
    this.drinkTurnToChainStoreList();
  }

  selectPickUpType = (event) => {
    this.selectPickUpType(event);
  }

  drinkAddCartAnimation = (pageInstance, compindex) => {
    this.addCartAnimation(pageInstance, compindex);
  }

  tapEventCommonHandler = (e) => {
    app.tapEventCommonHandler(e)
  }
  
  previewImage = (e) => {
    const { src, imgarr } = e.currentTarget.dataset;
    app.previewImage({
      current: src,
      urls: JSON.parse(imgarr)
    })
  }

  init = (compindex, pageInstance, show) => {
    let compData = pageInstance.data.eles[compindex];
    let customFeature = compData.customFeature;
    let param = {};
    let that = this;
    let pick_up_type_new = [];
    param['pick_up_type'] = [];
    if (customFeature.pickUpArr) {
      if (customFeature.pickUpArr.sameJourney) {
        param.pick_up_type.push(2);
      }
      if (customFeature.pickUpArr.selfLifting) {
        param.pick_up_type.push(3);
      }
      if (customFeature.pickUpArr.dining) {
        param.pick_up_type.push(4);
      }
    }
    if (param.pick_up_type.length === 0) {
      param.pick_up_type.push(0);
    }
    param.form = 'goods';
    param.is_count = 0;
    if (param.pick_up_type.indexOf(3) >= 0) { pick_up_type_new.push(3) }
    if (param.pick_up_type.indexOf(4) >= 0) { pick_up_type_new.push(4) }
    if (param.pick_up_type.indexOf(2) >= 0) { pick_up_type_new.push(2) }
    pageInstance.setData({
      ['eles[' + compindex + '].pick_up_type']: param.pick_up_type,
      ['eles[' + compindex + '].pick_up_type_new']: pick_up_type_new,
      ['eles[' + compindex + '].buyer_info']: [],
      ['eles[' + compindex + '].user_list']: [],
    });
    if (show) {
      let pick_up_type = param.pick_up_type[0];
      if (param.pick_up_type.indexOf(3) >= 0) pick_up_type = 3;
      if (param.pick_up_type.indexOf(4) >= 0 && pick_up_type != 3) pick_up_type = 4;
      pageInstance.setData({
        ['eles[' + compindex + '].pick_up_select']: pick_up_type
      });
      pick_up_type = null;
      that._getPickUpLeft(compindex)
    }
    compData.timer = null;     //轮询定时器
    compData.loopRequest = true;  //轮询接口是否完成
    compData.is_init = true;  //首次需要重新渲染购物车
    compData.addCartComplete = true; //加购物车  成功后才拿到cart_id
    let franchisee_id = app.getPageFranchiseeId();
    if (franchisee_id) {
      compData.location_id = app.globalData[franchisee_id] ? app.globalData[franchisee_id].ec_location_id : '';
    } else {
      compData.location_id = app.globalData.ec_location_id || '';
    }
    if (customFeature.multipleMerchants) {
      this.getMainStoreInfo()
    }
    this.verticalListCompsInit(compindex, pageInstance, param);
    pick_up_type_new = null;
  }

  verticalListCompsInit = (compindex, pageInstance, par) => {
    let that = this;
    let param = par;
    pageInstance.returnToVerticalFlag = 0;
    let compData = pageInstance.data.eles[compindex];
    compData.heightFlag = true;   //显示隐藏店铺信息是否完成
    compData.flag = true;   //获取购物车数据并转换数据完成后才允许加商品
    clearInterval(compData.timer);
    let newData = {};
    newData['eles[' + compindex + '].goodsDetailShow'] = false;
    newData['eles[' + compindex + '].goodsModelShow'] = false;
    newData['eles[' + compindex + '].goodsAttrShow'] = false;
    newData['eles[' + compindex + '].hideSearchInput'] = false;

    if (pageInstance.data.eles.page_hasNavBar) {
      newData['eles[' + compindex + '].heightPx'] = app.returnListHeight(compData.customFeature.showShopInfo, 2, pageInstance.data.eles[compindex].customFeature.mode) - app.globalData.topNavBarHeight + (compData.customFeature.pickUpArr.sameJourney ? 0 : 40);
      newData['eles[' + compindex + '].searchHeight'] = app.getSystemInfoSync().windowHeight - 100 - app.globalData.topNavBarHeight;
    } else {
      newData['eles[' + compindex + '].heightPx'] = app.returnListHeight(compData.customFeature.showShopInfo, 2, pageInstance.data.eles[compindex].customFeature.mode) + (compData.customFeature.pickUpArr.sameJourney ? 0 : 40);
      newData['eles[' + compindex + '].searchHeight'] = app.getSystemInfoSync().windowHeight - 100;
    }
    newData['eles[' + compindex + '].selected'] = 1;
    newData['eles[' + compindex + '].customFeature.selected'] = 0;
    if (compData.TotalNum == undefined) {
      newData['eles[' + compindex + '].TotalNum'] = 0;
      newData['eles[' + compindex + '].TotalPrice'] = 0.00;
    }
    newData['eles[' + compindex + '].cartList'] = [{}];
    newData['eles[' + compindex + '].cartGoodsIdList'] = [];
    newData['eles[' + compindex + '].loading'] = true;
    newData['eles[' + compindex + '].loadingFail'] = false;
    if (compData.goods_data_list) {
      newData['eles[' + compindex + '].show_goods_data'] = {};
      newData['eles[' + compindex + '].goods_data_list'] = {};
    }
    newData['eles[' + compindex + '].categorySort'] = {};
    newData['eles[' + compindex + '].showSearch'] = false;
    newData['eles[' + compindex + '].goodsCateHeight'] = {}; // 每个分类的商品列表高度
    newData['eles[' + compindex + '].requestNum'] = 0;
    newData['eles[' + compindex + '].isChangeTab'] = 0;
    newData['eles[' + compindex + '].showSettlementMask'] = false;
    newData['eles[' + compindex + '].showGoodDetailMask'] = false;
    newData['eles[' + compindex + '].franchiseeId'] = app.getPageFranchiseeId() || '';
    pageInstance.setData(newData);
    pageInstance[compindex] || (pageInstance[compindex] = {});
    param['sort_key'] = '';
    param['sort_direction'] = 0;
    param['page'] = 1;
    param['page_size'] = 10;
    param['take_out_style'] = 1;
    if (!(compData.pick_up_type.length == 1 && compData.pick_up_type[0] == 4)) {
      !compData.currentLocationData && !compData.selectSameJourney ? this.getCurrentLocation(compindex, pageInstance) : '';
    }
    let sub_shop_app_id = app.getPageFranchiseeId();
    app.sendRequest({
      url: '/index.php?r=AppEcommerce/getPickUpGoodsTypeSetting',
      data: {
        pick_up_type: 2,
        sub_shop_app_id: sub_shop_app_id || ''
      },
      success: function (res) {
        res.data ? res.data : res.data = {};
        res.data ? res.data : res.data = {};
        let shopInfoData = res.data;
        if (!shopInfoData.app_store_data) {
          app.sendRequest({
            url: '/index.php?r=AppEcommerce/getPickUpGoodsTypeSetting',
            data: {
              pick_up_type: 4,
              sub_shop_app_id: sub_shop_app_id || ''
            },
            success: function (res) {
              res.data ? res.data : res.data = {};
              let shopInfoData = res.data;
              that.setShopInfo(pageInstance, compindex, shopInfoData);
            }
          })
        } else {
          that.setShopInfo(pageInstance, compindex, shopInfoData);
        }
      }
    });

    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/getGoodsCategory',
      method: 'post',
      data: {
        filter_null: 1,
        goods_type: 0,
        pick_up_type: compData.pick_up_type,
        sub_shop_app_id: app.getPageFranchiseeId() || ''
      },
      success: function (res) {
        let content = [];
        for (let i = 0; i < res.data.length; i++) {
          content.push({
            text: res.data[i].name,
            source: res.data[i].id,
            pic: res.data[i].logo,
          })
        }
        let cateData = {};
        cateData['eles[' + compindex + '].content'] = content;
        pageInstance.setData(cateData);
        if (content.length === 0) return;
        that.getGoodListByCate(pageInstance, compindex, content, param);
      }
    })
  }

  setShopInfo = (pageInstance, compindex, shopInfoData) => {
    let newdata = {};
    newdata['eles[' + compindex + '].shopInfo'] = shopInfoData.app_store_data || {};
    newdata['eles[' + compindex + '].config_data'] = shopInfoData.config_data || {};
    newdata['eles[' + compindex + '].infoHeight'] = 0;
    pageInstance.setData(newdata, function () {
      app.getBoundingClientRect('.shopInfoHeight', function (rects) {
        let animationData = {};
        pageInstance[compindex]['shopInfoHeight'] || (pageInstance[compindex]['shopInfoHeight'] = rects[0] != undefined ? rects[0].height : 0);
        // TODO
        // let animation = app.createAnimation({
        //   duration: 200,
        //   timingFunction: 'linear'
        // })
        // animation.height(pageInstance[compindex]['shopInfoHeight']).step();
        // animationData['eles[' + compindex + '].shopInfoHeight'] = animation.export();
        animationData['eles[' + compindex + '].shopHeight'] = pageInstance[compindex]['shopInfoHeight'];
        pageInstance.setData(animationData);
      })
    });
    this.getShopAdvancedSetting(pageInstance, compindex);
  }

  getGoodListByCate = (pageInstance, compindex, content, param) => {
    let cateData = {};
    let compData = pageInstance.data.eles[compindex];
    let that = this;
    for (let j in content) {
      let cateParam = {};
      cateParam.param = {};
      Object.assign(cateParam.param, param);
      cateParam.param.idx_arr = {
        idx: 'category',
        idx_value: content[j].source == 'all' ? '' : content[j].source
      };
      cateData['eles[' + compindex + '].pagination.category' + content[j].source] = cateParam;
    }
    if (pageInstance.data.eles.page_hasNavBar) {
      cateData['eles[' + compindex + '].heightPx'] = app.returnListHeight(compData.customFeature.showShopInfo, 2, pageInstance.data.eles[compindex].customFeature.mode) - app.globalData.topNavBarHeight + (compData.customFeature.pickUpArr.sameJourney ? 0 : 40);
      cateData['eles[' + compindex + '].searchHeight'] = app.getSystemInfoSync().windowHeight - 100 - app.globalData.topNavBarHeight;
    } else {
      cateData['eles[' + compindex + '].heightPx'] = app.returnListHeight(compData.customFeature.showShopInfo, 2, pageInstance.data.eles[compindex].customFeature.mode) + (compData.customFeature.pickUpArr.sameJourney ? 0 : 40);
      cateData['eles[' + compindex + '].searchHeight'] = app.getSystemInfoSync().windowHeight - 100;
    }
    cateData['eles[' + compindex + '].route'] = pageInstance.route;
    pageInstance.setData(cateData);
    //分类加载（先加载第一个分类前十条数据）
    param.page = 1;
    param.page_size = 10;
    param.idx_arr = {
      idx: 'category',
      idx_value: content[0].source == 'all' ? '' : content[0].source
    };
    compData['loading'] = true;
    that._getTakeoutStyleGoodsList(param, pageInstance, compindex, 1);
  }

  verticalListChangeEvaluate = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let newdata = {};
    let compindex = event.currentTarget.dataset.compindex;
    if (event.currentTarget.dataset.index == 2) {
      pageInstance.hasRequireAssess = true;
      this._getAssessList(pageInstance, compindex);
    }
    newdata['eles[' + compindex + '].selected'] = event.currentTarget.dataset.index;
    pageInstance.setData(newdata);
  }

  verticalListTouchstart = (event) => {
    let newdata = {};
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let startPoint = {
      x: event.touches[0].pageX,
      y: event.touches[0].pageY
    }
    newdata['eles[' + compindex + '].startPoint'] = startPoint;
    pageInstance.setData(newdata);
  }

  verticalListTouchmove = (event) => {
    let newdata = {};
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    if (compData['showSearch']) return;
    if (compData.customFeature.selected > 0) return;
    if (compData.customFeature.loadAllData == '1') return;
    if (!compData.shopInfo || !pageInstance[compindex] || (pageInstance[compindex] && pageInstance[compindex]['shopInfoHeight'] == undefined)) {
      return;
    }
    let animation = app.createAnimation({
      duration: 400,
      timingFunction: 'linear'
    })
    if (compData.startPoint.y - event.touches[0].pageY > 40 && compData.heightFlag && compData['infoHeight'] === 0) {
      app.getBoundingClientRect('.shopInfoHeight', function (rects) {
        compData.heightFlag = false;
        pageInstance[compindex]['shopInfoHeight'] = rects[0] != undefined ? rects[0].height : 0;
        animation.translateY(-pageInstance[compindex]['shopInfoHeight']).height(0).step();
        newdata['eles[' + compindex + '].shopInfoHeight'] = animation.export();
        newdata['eles[' + compindex + '].infoHeight'] = pageInstance[compindex]['shopInfoHeight'];
        pageInstance.setData(newdata);
      })
    }
    if (event.touches[0].pageY - compData.startPoint.y > 40 && compData.heightFlag && compData['infoHeight'] !== 0) {
      compData.heightFlag = false;
      animation.translateY(0).height(pageInstance[compindex]['shopInfoHeight']).step();
      newdata['eles[' + compindex + '].shopInfoHeight'] = animation.export();
      newdata['eles[' + compindex + '].infoHeight'] = 0;
      pageInstance.setData(newdata);
    }
  }

  stopAnimation = (event) => {}

  verticalListShowGoodsSearch = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let data = {};
    data['eles[' + compindex + '].showSearch'] = true;
    if (!compData.shopInfo || !pageInstance[compindex] || (pageInstance[compindex] && pageInstance[compindex]['shopInfoHeight'] == undefined)) {
      return;
    }
    if (compData['show_goods_data'] && compData['show_goods_data']['searchResult']) {
      data['eles[' + compindex + '].show_goods_data.searchResult'] = [];
    }
    // TODO
    // let animation = app.createAnimation({
    //   duration: 300,
    //   timingFunction: 'linear'
    // })
    // animation.translateY(-pageInstance[compindex]['shopInfoHeight']).height(0).step();
    // data['eles[' + compindex + '].shopInfoHeight'] = animation.export();
    data['eles[' + compindex + '].infoHeight'] = pageInstance[compindex]['shopInfoHeight'];
    pageInstance.setData(data);
  }

  verticalListHideGoodsSearch = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let data = {};
    data['eles[' + compindex + '].showSearch'] = false;
    // TODO
    // let animation = app.createAnimation({
    //   duration: 300,
    //   timingFunction: 'linear'
    // })
    // animation.translateY(0).height(pageInstance[compindex]['shopInfoHeight']).step();
    // data['eles[' + compindex + '].shopInfoHeight'] = animation.export();
    data['eles[' + compindex + '].infoHeight'] = 0;
    pageInstance.data.eles[compindex].heightFlag = true;
    pageInstance.setData(data);
  }

  verticalListBindSearchTitle = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let newdata = {};
    newdata['eles[' + compindex + '].searchTitle'] = event.target.value;
    pageInstance.setData(newdata);
  }

  verticalListSearchByTitle = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let newdata = {};
    let pagination = {};
    if (compData.pagination['searchResult']) {
      pagination = compData.pagination['searchResult'];
    } else {
      pagination = compData.pagination['category' + compData.content[0].source];
    }
    let param = JSON.parse(JSON.stringify(pagination.param));
    let category_arr = [];
    let hasAll = false;
    for (let i = 0; i < compData.content.length; i++) {
      if (compData.content[i].source == 'all') {
        hasAll = true;
        break;
      } else {
        category_arr.push(compData.content[i].source);
      }
    }
    hasAll ? '' : param['category_arr'] = category_arr;
    param.idx_arr['idx'] = 'title';
    param.idx_arr['idx_value'] = compData.searchTitle;
    param.page = 1;
    newdata['eles[' + compindex + '].pagination.searchResult.param'] = param;
    newdata['eles[' + compindex + '].pagination.searchResult.requesting'] = false;
    pageInstance.setData(newdata);
    this._getVerticalListListByTitle(param, pageInstance, compindex, 1);
  }

  verticalListClickCategory = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let index = dataset.index;
    let id = dataset.id;
    let newdata = {};
    let param = JSON.parse(dataset.param);
    let compData = pageInstance.data.eles[compindex];
    let cateIndex = dataset.cateindex;
    if (compData['loading'] || (pageInstance[compindex] && pageInstance[compindex]['shopInfoHeight'] == undefined)) {
      return;
    }
    if (!(compData.show_goods_data && compData.show_goods_data['category' + id])) {
      newdata['eles[' + compindex + '].loading'] = true;
      this._getTakeoutStyleGoodsList(param, pageInstance, compindex, 0);
    }
    newdata['eles[' + compindex + '].scrollTopLoading'] = false;
    newdata['eles[' + compindex + '].scrollTop'] = '2rpx';
    newdata['eles[' + compindex + '].customFeature.selected'] = index;
    newdata['eles[' + compindex + '].loadingFail'] = false;

    if (index > 0) {
      // let animation = app.createAnimation({
      //   duration: 400,
      //   timingFunction: 'linear'
      // })
      // animation.height(0).step();
      // newdata['eles[' + compindex + '].shopInfoHeight'] = animation.export();
      newdata['eles[' + compindex + '].infoHeight'] = pageInstance[compindex]['shopInfoHeight'];
    }
    pageInstance.setData(newdata);
    compData['isChangeTab'] = true;
  }

  verticalListStyleScrollFunc = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let categoryId = compData.content[compData.customFeature.selected].source;
    let newdata = {};
    let pagination = compData.pagination['category' + categoryId];
    let param = pagination.param;
    let that = this;
    if ((pagination.requesting || pagination.is_more === 0 || compData['loading']) && !compData.loadingFail) {
      if (pagination.requesting) {
        return;
      }
      if (compData.customFeature.selected < compData.content.length - 1) {
        compData['scrollTo'] = 'bottom';
      }
      return;
    }
    newdata['eles[' + compindex + '].pagination.category' + categoryId + '.requesting'] = true;
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newdata)
    that._getTakeoutStyleGoodsList(param, pageInstance, compindex, 0);
  }

  verticalListStyleScrollTop = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let categoryId = compData.content[compData.customFeature.selected].source;
    let pagination = compData.pagination['category' + categoryId];
    let that = this;
    if (pagination.requesting) {
      return;
    }
    if (compData.customFeature.selected > 0) {
      compData['scrollTo'] = 'top';
    }
  }

  sortVerticalList(event) {}

  addModelNum = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let goodsid = dataset.id || dataset.goodsid;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let thisGoodsInfo = compData.goods_data_list[goodsid];
    let newdata = {};
    let addNum = 1;
    if (!compData['hasAddNum'] && !compData['modelNum']) {
      addNum = thisGoodsInfo.min_sales_nums || 1;
    }
    if ((+compData['hasAddNum'] || 0) + (+compData["modelNum"] || 0) + addNum > thisGoodsInfo.stock) {
      app.showModal({
        content: '商品库存不足'
      })
      return;
    }
    newdata['eles[' + compindex + '].hasAddNum'] = (+compData.hasAddNum || 0) + addNum;
    pageInstance.setData(newdata);
  }

  minusModelNum = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let goodsid = dataset.id || dataset.goodsid;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let thisGoodsInfo = compData.goods_data_list[goodsid];
    let newdata = {};
    let minusNum = -1;
    if ((+compData['hasAddNum'] || 1) + minusNum < (thisGoodsInfo.min_sales_nums || 1)) {
      return;
    }
    newdata['eles[' + compindex + '].hasAddNum'] = (+compData.hasAddNum || 0) + minusNum;
    pageInstance.setData(newdata);
  }

  showVerticalListGoodsDetail = (event) => {
    let that = this;
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let model = dataset.model;
    let attributes = dataset.attributes;
    let id = dataset.id || dataset.goodsid;
    let index = dataset.index;
    let compindex = dataset.compindex;
    let category = dataset.category;
    let is_search = dataset.is_search || '';
    let compData = pageInstance.data.eles[compindex];
    let showGoodsData;
    if (is_search == 'search') {
      showGoodsData = compData.show_goods_data['searchResult'][index];
    } else {
      showGoodsData = compData.show_goods_data['category' + category][index];
    }
    let businessTime = showGoodsData.business_time ? showGoodsData.business_time.business_time : '';
    if (businessTime) {
      let business_time = '';
      for (let key in businessTime) {
        business_time += businessTime[key].start_time.slice(0, 2) + ':' + businessTime[key].start_time.slice(2, 4) + '-' + businessTime[key].end_time.slice(0, 2) + ':' + businessTime[key].end_time.slice(2, 4) + ' ';
      }
      showGoodsData.businessTime = business_time;
    }
    showGoodsData.des = app.getWxParseResult(showGoodsData.description);
    let sub_shop_app_id = app.getPageFranchiseeId();
    app.sendRequest({
      url: '/index.php?r=AppShop/getAssessList',
      method: 'post',
      data: {
        goods_id: id,
        "idx_arr[0][idx]": 'level',
        "idx_arr[0][idx_value]": 0,
        page: 1,
        page_size: 20,
        sub_shop_app_id: sub_shop_app_id || ''
      },
      success: function (res) {
        let newdata = {};
        // 默认选中规格
        let modelData = compData.goods_data_list[id]['model'].modelData;
        let modelChoose = [], modelIdArr = [], modelLength = 0;
        modelData && modelData.map(item => {
          if (item.subModelName && item.subModelName.length) { modelChoose.push(item.subModelName[0]) }
          if (item.subModelId && item.subModelId.length) { modelIdArr.push(item.subModelId[0]) }
        })
        modelLength = modelIdArr.length;
        newdata['eles[' + compindex + '].modelChoose'] = modelChoose || [];
        newdata['eles[' + compindex + '].modelIdArr'] = modelIdArr;
        newdata['eles[' + compindex + '].modelLength'] = modelLength;

        if (modelLength) {
          that._ModelPirce({ goodsid: id, compindex: compindex }, [].concat(newdata['eles[' + compindex + '].modelIdArr']));
        }

        if (!!+model || attributes) {
          newdata['eles[' + compindex + '].hideSearchInput'] = true;
          if (model) {
            let goods_model = pageInstance[compindex].goods_model_list[id].goods_model;
            for (let i in goods_model) {
              if (goods_model[i].model.split(',').sort().join(',') == modelIdArr.sort().join(',')) {
                newdata['eles[' + compindex + '].hasAddNum'] = goods_model[i].min_sales_nums || 1;// 初始化弹窗里的商品数量 最小起卖数
              }
            }
            newdata['eles[' + compindex + '].goodsDetailShow'] = true;
            newdata['eles[' + compindex + '].showGoodDetailMask'] = true;
          } else {
            newdata['eles[' + compindex + '].modelPrice'] = Number(Number(compData.goods_data_list[id].price)).toFixed(2);
            newdata['eles[' + compindex + '].modelNum'] = compData.goods_data_list[id] && compData.goods_data_list[id].num || 0;
            newdata['eles[' + compindex + '].hasAddNum'] = compData.goods_data_list[id] && compData.goods_data_list[id].min_sales_nums || 1;// 初始化弹窗里的商品数量 最小起卖数
            newdata['eles[' + compindex + '].goodsAttrShow'] = true;
          }
          pageInstance.setData(newdata);
        }
        newdata['eles[' + compindex + '].modelVipPrice'] = compData.goods_data_list[id].calculationPrice;
        newdata['eles[' + compindex + '].goodsDetail'] = showGoodsData;
        newdata['eles[' + compindex + '].goodsDetail']['goodsData'] = compData.goods_data_list[id];
        newdata['eles[' + compindex + '].goodsDetail']['goodsAssess'] = res;
        newdata['eles[' + compindex + '].modelGoodsId'] = id;
        pageInstance.setData(newdata);
        app.sendRequest({
          hideLoading: true,
          url: '/index.php?r=AppShop/GoodsView',
          data: {
            goods_id: id
          },
          success: function () {
          }
        })
      }
    });
  }

  verticalListListMinus = (event) => {
    clearTimeout(this.takeoutTimeout);
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.target.dataset;
    let goodsid = dataset.goodsid;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let that = this;
    let totalNum = +compData.TotalNum;
    let totalPrice = +compData.TotalPrice;
    let newdata = {};
    let model = dataset.model;
    let isInBusiness = dataset.isInBusiness;
    let isPackage = dataset.package;
    let isAttributes = dataset.attributes && dataset.attributes.length > 0;
    if (isInBusiness == 0) {
      app.showModal({
        content: '该商品不在出售时间',
      });
      return;
    }
    if (!!+model) {
      app.showModal({
        content: '多规格商品只能去购物车操作',
      });
      return;
    }
    if (!!+isPackage) {
      app.showModal({
        content: '套餐商品只能去购物车操作',
      });
      return;
    }
    if (isAttributes) {
      app.showModal({
        content: '属性商品只能去购物车操作',
      });
      return;
    }
    // if (compData.cartList[0][goodsid][0].attrObj['0'].num == 0) {
    //   return;
    // }
    let minusNum = 1; //最小起卖数
    if (compData.goods_data_list[goodsid].totalNum <= compData.goods_data_list[goodsid].min_sales_nums) {
      minusNum = compData.goods_data_list[goodsid].totalNum;
    }
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = compData.goods_data_list[goodsid];
    newdata['eles[' + compindex + '].cartList[0].' + goodsid] = compData.cartList[0][goodsid];
    newdata['eles[' + compindex + '].TotalNum'] = totalNum - minusNum;
    newdata['eles[' + compindex + '].TotalPrice'] = (+totalPrice - Number(newdata['eles[' + compindex + '].goods_data_list.' + goodsid].calculationPrice) * minusNum).toFixed(2);
    newdata['eles[' + compindex + '].isDeliver'] = (+compData.shopInfo.min_deliver_price - newdata['eles[' + compindex + '].TotalPrice']).toFixed(2);
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum -= minusNum;
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].num -= minusNum;
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].totalPrice = Number(newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].num * newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].calculationPrice).toFixed(2);
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].attrObj[0].num -= minusNum;
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].totalPrice = Number(newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].attrObj[0].num * newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].calculationPrice).toFixed(2);
    pageInstance.setData(newdata, function () {
      that.takeoutTimeout = setTimeout(() => {
        let options = {
          goods_type: 0,
          cartListData: compData.cartList,
          thisPage: pageInstance,
          compindex: compindex
        }
        that._addTakeoutCart(options, that.eachCartList(options), null, goodsid);
      }, 300);
    });
  }

  verticalListListPlus = (event) => {
    clearTimeout(this.takeoutTimeout);
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.target.dataset;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let goodsid = dataset.goodsid || compData.modelGoodsId;
    let that = this;
    if (compData.flag) {
      return;
    }
    compData.addCartComplete = false;
    let model = dataset.model;
    let attributes = dataset.attributes;
    let goodsInfo = compData.goods_data_list[goodsid];
    let totalNum = compData.TotalNum;
    let totalPrice = +compData.TotalPrice;
    let is_in_business = dataset.isInBusiness;
    let newdata = {};
    newdata['eles[' + compindex + '].modelPrice'] = 0;
    newdata['eles[' + compindex + '].attrPrice'] = 0;
    newdata['eles[' + compindex + '].attrData'] = null;
    compData.cartAttrId = '0';
    let userCart = compData.cartList[0];
    let myCartNum = 0;
    for (let k in userCart) {
      for (let j in userCart[k]) {
        for (let o in userCart[k][j].attrObj) {
          myCartNum += userCart[k][j].attrObj[o].num;
        }
      }
    }
    if (is_in_business == 0) {
      app.showModal({
        content: '该商品不在出售时间'
      })
      return;
    }

    if (!!+model || attributes) {
      newdata['eles[' + compindex + '].hideSearchInput'] = true;
      newdata['eles[' + compindex + '].modelGoodsId'] = goodsid;
      if (model) {
        newdata['eles[' + compindex + '].modelIdArr'] = [];
        newdata['eles[' + compindex + '].goodsModelShow'] = true; //选规格弹窗
        // for (let index = 0; index < compData.goods_data_list[goodsid]['model'].modelData.length; index++) {
        //   newdata['eles[' + compindex + '].modelIdArr'].push(0)
        // }
      } else {
        newdata['eles[' + compindex + '].modelPrice'] = Number(Number(compData.goods_data_list[goodsid].price)).toFixed(2);
        newdata['eles[' + compindex + '].modelNum'] = 0;
        newdata['eles[' + compindex + '].goodsAttrShow'] = true;
      }
      pageInstance.setData(newdata);
    } else {
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = goodsInfo;
      newdata['eles[' + compindex + '].cartList[0].' + goodsid] = compData.cartList[0][goodsid] || {};
      let newNum = compData.goods_data_list[goodsid].min_sales_nums || 1;
      let addNum = 1; //最小起卖数
      if (compData.goods_data_list[goodsid].totalNum == 0) {
        addNum = compData.goods_data_list[goodsid].min_sales_nums || 1;
      }
      if (addNum > compData.goods_data_list[goodsid].stock) {
        app.showModal({
          content: '库存不足'
        })
        return;
      }
      newdata['eles[' + compindex + '].TotalNum'] = +totalNum + addNum;
      newdata['eles[' + compindex + '].TotalPrice'] = (+totalPrice + (+goodsInfo.calculationPrice) * addNum).toFixed(2);
      newdata['eles[' + compindex + '].isDeliver'] = (+compData.shopInfo.min_deliver_price - newdata['eles[' + compindex + '].TotalPrice']).toFixed(2);
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum += addNum;
      let attrIdArr = [];
      let attrObj = {};
      let attrNum = 0;
      if (newdata['eles[' + compindex + '].cartList[0].' + goodsid][0]) {
        attrNum = newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].attrObj['0'].num + addNum;
      } else {
        attrNum = addNum;
      }
      attrObj['0'] = {
        num: attrNum,
        price: Number(+goodsInfo.calculationPrice),
        totalPrice: ((attrNum) * Number(+goodsInfo.calculationPrice)).toFixed(2),
        attrIdArr: attrIdArr
      }
      let attrArr = ['0'];
      if (newdata['eles[' + compindex + '].cartList[0].' + goodsid][0]) {
        newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].totalPrice = (+newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].num * goodsInfo.calculationPrice).toFixed(2);
        newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].attrObj = attrObj;
        newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].attrArr = attrArr;
      } else {
        newdata['eles[' + compindex + '].cartList[0].' + goodsid][0] = {
          list: 'list',
          id: goodsid,
          modelId: 0,
          gooodsName: goodsInfo.name,
          totalPrice: (newNum * goodsInfo.calculationPrice).toFixed(2),
          stock: goodsInfo.stock,
          cart_id: 0,
          in_business_time: compData.goods_data_list[goodsid].in_business_time,
          pick_up_type: goodsInfo.pick_up_type,
          is_vip_goods: goodsInfo.is_vip_goods || 0,
          attrObj: attrObj,
          attrArr: attrArr
        };
      }
      if (compData.cartGoodsIdList.indexOf(+goodsid) == -1) {
        newdata['eles[' + compindex + '].cartGoodsIdList'] = compData.cartGoodsIdList
        newdata['eles[' + compindex + '].cartGoodsIdList'].push(+goodsid)
      }
      myCartNum += 1;
      newdata['eles[' + compindex + '].myCartNum'] = myCartNum;
      clearInterval(compData.timer);
      compData.loopRequest = false;
      pageInstance.setData(newdata, function () {
        that.takeoutTimeout = setTimeout(() => {
          let options = {
            goods_type: 0,
            cartListData: compData.cartList,
            thisPage: pageInstance,
            compindex: compindex
          }
          that._addTakeoutCart(options, that.eachCartList(options), null, goodsid)
          that.drinkAddCartAnimation(pageInstance,compindex);
        }, 300);
      });
    }
  }

  verticalListSearchScrollFunc = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let newdata = {};
    let pagination = compData.pagination['searchResult'];
    let param = pagination.param;
    if ((pagination.requesting || pagination.is_more === 0) && !compData.loadingFail) {
      return;
    }
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newdata)
    this._getVerticalListListByTitle(param, pageInstance, compindex, 0);
  }

  _getVerticalListListByTitle = (param, pageInstance, compindex, isOnShow) => {
    let _this = this;
    pageInstance.requesting = true;
    let newdata = {};
    newdata['eles[' + compindex + "].searchLoading"] = true;
    pageInstance.setData(newdata);
    param.form = 'goods';
    param.only_display_common = 0;
    if (pageInstance.data.eles[compindex].customFeature.showSetMeal) {
      param.show_package_goods = 2;
    }
    param.pick_up_type = [pageInstance.data.eles[compindex].pick_up_select];
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/GetGoodsList',
      data: param,
      method: 'post',
      success: function (res) {
        if (res.status == 0) {
          pageInstance.requesting = false;
          newdata['eles[' + compindex + "].searchLoading"] = false;
          let compData = pageInstance.data.eles[compindex],
            isRequireing = {},
            categoryList = {};
          isRequireing['eles[' + compindex + '].pagination.searchResult'] = compData.pagination['searchResult'];
          isRequireing['eles[' + compindex + '].pagination.searchResult'].requesting = false;
          pageInstance.setData(isRequireing);
          if (!compData.show_goods_data || (compData.show_goods_data && !compData.show_goods_data['searchResult']) || isOnShow == 1) {
            categoryList['searchResult'] = []
          } else {
            categoryList['searchResult'] = compData.show_goods_data['searchResult']
          }
          if (compData.goods_data_list) {
            newdata['eles[' + compindex + '].goods_data_list'] = compData.goods_data_list
          } else {
            newdata['eles[' + compindex + '].goods_data_list'] = {}
          }
          if (!pageInstance[compindex]['goods_model_list']) {
            pageInstance[compindex]['goods_model_list'] = {};
          }
          for (let i in res.data) {
            let form_data = res.data[i].form_data
            let goods = _this.returnCateGoods(form_data, compData);
            categoryList['searchResult'].push(goods);
            let goodsDataList = _this.returnGoodsDataList(form_data, compData)
            newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + ''] = goodsDataList;
            if (form_data.goods_model) {
              let new_goods_model = {}
              for (let i in form_data.goods_model) {
                new_goods_model[form_data.goods_model[i].id] = {
                  model: form_data.goods_model[i].model,
                  stock: form_data.goods_model[i].stock,
                  price: form_data.goods_model[i].price,
                  goods_id: form_data.goods_model[i].goods_id,
                  totalNum: 0,
                  vip_price: form_data.goods_model[i].vip_price && form_data.goods_model[i].vip_price !== 0 ? Number(form_data.goods_model[i].vip_price).toFixed(2) : null,
                  calculationPrice: form_data.goods_model[i].vip_price && form_data.goods_model[i].vip_price !== 0 ? Number(form_data.goods_model[i].vip_price).toFixed(2) : form_data.goods_model[i].price,
                  is_vip_goods: form_data.is_vip_goods || 0,
                  min_sales_nums: +form_data.goods_model[i].min_sales_nums || 0
                }
              }
              newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model'] = {
                modelData: [],
                name: form_data.title
              }
              pageInstance[compindex]['goods_model_list'][form_data.id] = {
                goods_model: new_goods_model
              }
              for (let k in form_data.model) {
                newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model']['modelData'].push({
                  name: form_data.model[k].name,
                  subModelName: form_data.model[k].subModelName,
                  subModelId: form_data.model[k].subModelId
                })
              }
            } else {
              newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model'] = {};
              newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model'][0] = {
                price: form_data.price,
                num: 0,
                stock: form_data.stock,
                vip_price: form_data.vip_price && form_data.vip_price !== 0 ? Number(form_data.vip_price).toFixed(2) : null,
                calculationPrice: form_data.vip_price && form_data.vip_price !== 0 ? Number(form_data.vip_price).toFixed(2) : form_data.price,
                is_vip_goods: (form_data.is_vip_goods && form_data.vip_goods_price != form_data.price) || 0
              }
            }
          }
          newdata['eles[' + compindex + '].show_goods_data.searchResult'] = categoryList['searchResult'];
          newdata['eles[' + compindex + '].in_business_time'] = res.in_business_time;
          newdata['eles[' + compindex + '].pagination.searchResult'] = compData.pagination['searchResult'];
          param.page = res.current_page + 1;
          newdata['eles[' + compindex + '].pagination.searchResult'].param = param;
          newdata['eles[' + compindex + '].pagination.searchResult'].is_more = res.is_more;
          newdata['eles[' + compindex + '].pagination.searchResult'].current_page = res.current_page;
          newdata['eles[' + compindex + '].modelChoose'] = [];
          newdata['eles[' + compindex + '].modelLength'] = [];
          newdata['eles[' + compindex + '].modelIdArr'] = [];
          newdata['eles[' + compindex + '].loading'] = false;
          newdata['eles[' + compindex + '].loadingFail'] = false;
          pageInstance.setData(newdata);
          if (compData.customFeature.is_together) {
            compData.loopRequest = true;
            _this.getMultiOrderingVerticalCart(compindex, pageInstance);
          } else {
            _this._getTakeoutStyleCartList(pageInstance, compindex);
          }
        }
      },
      fail: function () {
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + "].searchLoading"] = false;
        pageInstance.setData(newdata);
      },
      complete: function () {
        setTimeout(function () {
          pageInstance.requesting = false;
        }, 300);
      }
    });
  }

  verticalListShowShoppingCartPop = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let isShowShoppingCart = dataset.isshow;
    let newdata = {};
    if (isShowShoppingCart) {
      newdata['eles[' + compindex + '].shoppingCartShow'] = false;
    } else {
      newdata['eles[' + compindex + '].shoppingCartShow'] = true;
    }
    pageInstance.setData(newdata);
  }

  verticalListChooseComplete = (event) => {
    clearTimeout(this.takeoutTimeout);
    let pageInstance = app.getAppCurrentPage();
    let compindex = event.target.dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let that = this;
    if (!compData.TotalNum) {
      return;
    }
    this.takeoutTimeout = setTimeout(() => {
      let options = {
        goods_type: 0,
        cartListData: compData.cartList,
        thisPage: pageInstance,
        compindex: compindex
      }
      that._addTakeoutCart(options, that.eachCartList(options), (idArr) => {
        let franchiseeId = app.getPageFranchiseeId();
        let franchiseeParam = franchiseeId ? ('&franchisee=' + franchiseeId) : '';
        pageInstance.returnToVerticalFlag = 1;
        app.turnToPage('/orderMeal/pages/previewOrderDetail/previewOrderDetail?cart_arr=' + idArr + franchiseeParam);
      })
    }, 300);
  }

  verticalListChangeAssessType = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let newdata = {};
    let assessActive = event.currentTarget.dataset.active;
    let showAssess = [];
    let compindex = event.currentTarget.dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    newdata['eles[' + compindex + '].assessActive'] = assessActive;
    for (let i = 0; i < compData.assessList.length; i++) {
      let alist = compData.assessList[i];
      if (assessActive == 0) {
        alist.assess_info.has_img == 1 ? showAssess.push(alist) : null;
      } else if (alist.assess_info.level == assessActive) {
        showAssess.push(alist);
      }
    }
    newdata['eles[' + compindex + '].showAssess'] = showAssess;
    pageInstance.setData(newdata);
  }

  verticalListGetMoreAssess = (event) => {
    let dataset = event.currentTarget.dataset;
    let page = dataset.nextpage;
    let compindex = dataset.compindex;
    let pageInstance = app.getAppCurrentPage();
    let compData = pageInstance.data.eles[compindex];
    let newdata = {};
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/getAssessList',
      method: 'post',
      data: {
        "idx_arr[0][idx]": 'goods_type',
        "idx_arr[0][idx_value]": 0,
        page: page,
        page_size: 20,
        obj_name: 'app_id'
      },
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function (res) {
        let alist = compData.assessList;
        for (let i in res.data) {
          alist.push(res.data[i]);
        }
        newdata['eles[' + compindex + '].assessList'] = alist;
        let commentNums = [],
          showAssess = [],
          hasImgAssessList = 0,
          goodAssess = 0,
          normalAssess = 0,
          badAssess = 0;
        for (let i = 0; i < alist.length; i++) {
          let listItem = alist[i];
          listItem.assess_info.has_img == 1 ? hasImgAssessList++ : null;
          listItem.assess_info.level == 3 ? goodAssess++ : (listItem.assess_info.level == 1 ? badAssess++ : normalAssess++)
          if (listItem.assess_info.has_img == 1 && compData.assessActive == 0) {
            showAssess.push(listItem);
          } else if (listItem.assess_info.level == 3 && compData.assessActive == 3) {
            showAssess.push(listItem);
          } else if (listItem.assess_info.level == 1 && compData.assessActive == 1) {
            showAssess.push(listItem);
          } else if (listItem.assess_info.level == 2 && compData.assessActive == 2) {
            showAssess.push(listItem);
          }
        }
        commentNums = [hasImgAssessList, goodAssess, normalAssess, badAssess];
        newdata['eles[' + compindex + '].commentNums'] = commentNums;
        newdata['eles[' + compindex + '].assessCurrentPage'] = page;
        newdata['eles[' + compindex + '].showAssess'] = showAssess;
        newdata['eles[' + compindex + '].moreAssess'] = res.is_more;
        pageInstance.setData(newdata);
      }
    })
  }

  openVerticalListLocation = (event) => {
    let dataset = event.currentTarget.dataset;
    app.openLocation({
      latitude: +dataset.lat,
      longitude: +dataset.lng,
      name: dataset.name,
      address: dataset.address
    })
  }

  verticalListHideDetailPop = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let newdata = {};
    newdata['eles[' + compindex + '].goodsDetailShow'] = false;
    newdata['eles[' + compindex + '].hideSearchInput'] = false;
    newdata['eles[' + compindex + '].showGoodDetailMask'] = false;
    // 清空规格信息
    newdata['eles[' + compindex + '].goodsAttrShow'] = false;
    newdata['eles[' + compindex + '].modelPrice'] = 0;
    newdata['eles[' + compindex + '].modelChoose'] = [];
    newdata['eles[' + compindex + '].modelLength'] = [];
    newdata['eles[' + compindex + '].modelIdArr'] = [];
    newdata['eles[' + compindex + '].attrData'] = {};   // 清空属性
    newdata['eles[' + compindex + '].attrName'] = '';   // 清空属性
    newdata['eles[' + compindex + "].modelNum"] = 0;
    newdata['eles[' + compindex + "].attrPrice"] = 0;
    newdata['eles[' + compindex + "].addCartComplete"] = true;
    pageInstance.setData(newdata);
  }

  verticalListGetMoreGoodsAssess = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let sub_shop_app_id = app.getPageFranchiseeId();
    let compData = pageInstance.data.eles[compindex];
    let newdata = {};
    app.sendRequest({
      url: '/index.php?r=AppShop/getAssessList',
      method: 'post',
      data: {
        goods_id: compData.goodsDetail.id,
        "idx_arr[0][idx]": 'level',
        "idx_arr[0][idx_value]": 0,
        page: compData.goodsDetail.goodsAssess.current_page + 1,
        page_size: 20,
        sub_shop_app_id: sub_shop_app_id || ''
      },
      success: function (res) {
        newdata['eles[' + compindex + '].goodsDetail'] = compData['goodsDetail'];
        newdata['eles[' + compindex + '].goodsDetail']['goodsAssess']['data'] = compData['goodsDetail']['goodsAssess']['data'].concat(res.data);
        newdata['eles[' + compindex + '].goodsDetail']['goodsAssess']['is_more'] = res.is_more;
        newdata['eles[' + compindex + '].goodsDetail']['goodsAssess']['current_page'] = res.current_page;
        pageInstance.setData(newdata)
      }
    });
  }

  verticalListHideModelPop = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let newdata = {};
    newdata['eles[' + compindex + '].goodsModelShow'] = false;
    newdata['eles[' + compindex + '].goodsAttrShow'] = false;
    newdata['eles[' + compindex + '].hideSearchInput'] = false;
    newdata['eles[' + compindex + '].modelPrice'] = 0;
    newdata['eles[' + compindex + "].attrPrice"] = 0;
    newdata['eles[' + compindex + '].attrData'] = {};   // 清空属性
    newdata['eles[' + compindex + '].attrName'] = '';   // 清空属性
    newdata['eles[' + compindex + '].modelChoose'] = [];
    newdata['eles[' + compindex + '].modelLength'] = [];
    newdata['eles[' + compindex + '].modelIdArr'] = [];
    newdata['eles[' + compindex + "].modelNum"] = 0;
    newdata['eles[' + compindex + "].addCartComplete"] = true;
    pageInstance.setData(newdata);
  }

  verticalListChooseModel = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let pIndex = dataset.parentindex;
    let index = dataset.index;
    let compindex = dataset.compindex;
    let goodsid = dataset.goodsid;
    let compData = pageInstance.data.eles[compindex];
    let modelData = compData.goods_data_list[goodsid]['model'].modelData;
    let newdata = {};
    newdata['eles[' + compindex + '].modelChoose'] = compData.modelChoose || [];
    newdata['eles[' + compindex + '].modelIdArr'] = compData.modelIdArr;
    newdata['eles[' + compindex + '].modelChoose'][pIndex] = modelData[pIndex].subModelName[index];
    newdata['eles[' + compindex + '].modelIdArr'][pIndex] = modelData[pIndex].subModelId[index];
    let model = compData.modelChoose.filter((s) => {
      return s && s.trim();
    })
    newdata['eles[' + compindex + '].modelLength'] = model.length;
    pageInstance.setData(newdata);
    this._ModelPirce(dataset, [].concat(newdata['eles[' + compindex + '].modelIdArr']));
  }

  _ModelPirce = (dataset, modelNameArr) => {
    let pageInstance = app.getAppCurrentPage();
    let newdata = {};
    let compindex = dataset.compindex;
    let goodsid = dataset.goodsid;
    let goods_model = pageInstance[compindex].goods_model_list[dataset.goodsid].goods_model;
    let compData = pageInstance.data.eles[compindex];
    let attrPrice = 0;
    let attrName = '';
    let tempArr = [];
    if (compData.attrData) {
      for (let i in compData.attrData) {
        if (compData.attrData[i]) {
          attrPrice += Number(compData.attrData[i].price)
          tempArr.push(compData.attrData[i].name);
        }
      }
    }
    attrName = tempArr.join(',');
    newdata['eles[' + compindex + '].attrPrice'] = attrPrice;
    newdata['eles[' + compindex + '].attrName'] = attrName;
    for (let i in goods_model) {
      if (goods_model[i].model.split(',').sort().join(',') == modelNameArr.sort().join(',')) {
        newdata['eles[' + compindex + '].modelChooseId'] = i;
        // 拿多规格的 最小起卖数
        newdata['eles[' + compindex + '].hasAddNum'] = goods_model[i].min_sales_nums || 1;
        newdata['eles[' + compindex + '].goods_data_list.' + goodsid + '.min_sales_nums'] = goods_model[i].min_sales_nums || 1;
        newdata['eles[' + compindex + '].modelVipPrice'] = Number(Number(compData.goods_data_list[goodsid].calculationPrice) + attrPrice).toFixed(2);
        if (goods_model[i].is_vip_goods && !compData.customFeature.is_together) {
          newdata['eles[' + compindex + '].modelPrice'] = Number(Number(goods_model[i].vip_price) + attrPrice).toFixed(2);
          goods_model[i].vip_price != goods_model[i].price ? newdata['eles[' + compindex + '].isModelPrice'] = true : newdata['eles[' + compindex + '].isModelPrice'] = false;
        } else {
          newdata['eles[' + compindex + '].modelPrice'] = Number(Number(goods_model[i].price) + attrPrice).toFixed(2);
          newdata['eles[' + compindex + '].isModelPrice'] = false;
        }
        if (compData.cartList[0][dataset.goodsid] && compData.cartList[0][dataset.goodsid][i] && compData.cartList[0][dataset.goodsid][i].attrObj) {
          let attrId = this.selectedAttrIdStr(compData);
          if (newdata['eles[' + compindex + '].modelNum'] = compData.cartList[0][dataset.goodsid][i].attrObj[attrId]) {
            newdata['eles[' + compindex + '].modelNum'] = compData.cartList[0][dataset.goodsid][i].attrObj[attrId].num;
          } else {
            newdata['eles[' + compindex + '].modelNum'] = 0;
          }
        } else {
          newdata['eles[' + compindex + '].modelNum'] = 0;
        }
      }
    }
    pageInstance.setData(newdata)
  }

  verticalListSureChooseModel = (event) => {
    clearTimeout(this.takeoutTimeout);
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let newdata = {};
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let goodsid = compData.modelGoodsId;
    let price = +compData.modelPrice;
    let modelId = compData.modelChooseId;
    if (!pageInstance[compindex].goods_model_list[goodsid]) {
      this.drinkVerticalListListPlus(event)   // 触发添加商品
      // this.verticalListHideDetailPop(event)   // 关闭详情弹窗
      return
    }
    let thisModelInfo = pageInstance[compindex].goods_model_list[goodsid].goods_model[modelId];
    if (!compData.modelPrice) {
      app.showModal({
        content: '请选择规格'
      });
      return;
    }
    if (thisModelInfo.stock <= thisModelInfo.totalNum) {
      app.showModal({
        content: '该规格库存不足'
      });
      return;
    }
    let attrIdArr = [];
    let attrNameArr = [];
    for (let i in compData.attrData) {
      if (compData.attrData[i]) {
        attrIdArr.push(compData.attrData[i].id);
        attrNameArr.push({
          pName: compData.attrData[i].pName,
          name: compData.attrData[i].name,
          price: compData.attrData[i].price
        });
      }
    }
    let attrIdStr = attrIdArr.sort().join('_');
    let attrObj = {};
    let attrNum = 0;
    attrIdStr || (attrIdStr = '0');
    compData.cartAttrId = attrIdStr || '0';
    let addNum = compData.hasAddNum;
    // if (!(compData.cartList[0][goodsid] && compData.cartList[0][goodsid][modelId] && compData.cartList[0][goodsid][modelId].attrObj && compData.cartList[0][goodsid][modelId].attrObj[attrIdStr] && compData.cartList[0][goodsid][modelId].attrObj[attrIdStr].num > 0)) {
    //   addNum = thisModelInfo.min_sales_nums || 1;
    // }
    if (thisModelInfo.stock < addNum) {
      app.showModal({
        content: '该规格库存不足'
      });
      return;
    }
    newdata['eles[' + compindex + '].mdelInfo'] = thisModelInfo;
    newdata['eles[' + compindex + '].cartGoodsIdList'] = compData.cartGoodsIdList;
    let goods_num = thisModelInfo.totalNum + addNum;
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = compData.goods_data_list[goodsid];
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum = compData.goods_data_list[goodsid].totalNum + addNum;
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid].goods_model[modelId] = thisModelInfo;
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid].goods_model[modelId].totalNum += addNum;
    newdata['eles[' + compindex + '].TotalPrice'] = (Number(compData.TotalPrice) + Number(price) * addNum).toFixed(2);
    newdata['eles[' + compindex + '].isDeliver'] = (+compData.shopInfo.min_deliver_price - newdata['eles[' + compindex + '].TotalPrice']).toFixed(2);
    newdata['eles[' + compindex + '].TotalNum'] = compData.TotalNum + addNum;
    newdata['eles[' + compindex + '].hideSearchInput'] = false;
    newdata['eles[' + compindex + '].cartList[0].' + goodsid] = compData.cartList[0][goodsid] || {};
    if (compData.cartList[0][goodsid] && compData.cartList[0][goodsid][modelId] && compData.cartList[0][goodsid][modelId].attrObj) {
      attrObj = compData.cartList[0][goodsid][modelId].attrObj;
      compData.cartList[0][goodsid][modelId].attrObj[attrIdStr] = compData.cartList[0][goodsid][modelId].attrObj[attrIdStr] || {};
      attrNum = compData.cartList[0][goodsid][modelId].attrObj[attrIdStr].num ? compData.cartList[0][goodsid][modelId].attrObj[attrIdStr].num + addNum : addNum
    } else {
      attrNum = addNum;
    }
    attrObj[attrIdStr] = {
      num: attrNum,
      price: Number(price),
      totalPrice: (attrNum * Number(price)).toFixed(2),
      attrIdArr: attrIdArr,
      attrNameArr: attrNameArr
    };
    let attrArr = [];
    if (compData.cartList[0][goodsid] && compData.cartList[0][goodsid][modelId] && compData.cartList[0][goodsid][modelId].attrArr) {
      attrArr = compData.cartList[0][goodsid][modelId].attrArr;
    }
    if (attrArr.indexOf(attrIdStr) == -1) {
      attrArr.push(attrIdStr);
    }
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelId] = {
      modelName: compData.modelChoose.join(' | '),
      modelId: modelId,
      num: goods_num,
      price: price,
      id: goodsid,
      gooodsName: compData.goods_data_list[goodsid].name,
      totalPrice: (thisModelInfo.totalNum * price).toFixed(2),
      stock: thisModelInfo.stock,
      cart_id: 0,
      pick_up_type: compData.goods_data_list[goodsid].pick_up_type,
      attrObj: attrObj,
      attrArr: attrArr
    }
    if (!compData.customFeature.is_together && compData.goods_data_list[goodsid].is_vip_goods) {
      newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelId].is_vip_goods = 1;
    }
    if (newdata['eles[' + compindex + '].cartGoodsIdList'].indexOf(+goodsid) == -1) {
      newdata['eles[' + compindex + '].cartGoodsIdList'].push(+goodsid);
    }
    if (compData['modelNum']) {
      newdata['eles[' + compindex + '].modelNum'] = +compData['modelNum'] + 1;
    } else {
      newdata['eles[' + compindex + '].modelNum'] = attrNum;
    }
    pageInstance.setData(newdata, function () {
      let userCart = compData.cartList[0];
      let myCartNum = 0;
      for (let k in userCart) {
        for (let j in userCart[k]) {
          for (let o in userCart[k][j].attrObj) {
            myCartNum += userCart[k][j].attrObj[o].num;
          }
        }
      }
      pageInstance.setData({
        ['eles[' + compindex + '].myCartNum']: myCartNum
      })
    });
    this.takeoutTimeout = setTimeout(() => {
      let options = {
        goods_type: 0,
        cartListData: compData.cartList,
        thisPage: pageInstance,
        compindex: compindex
      }
      this._addTakeoutCart(options, this.eachCartList(options), null, goodsid)
      // this.verticalListHideDetailPop(event)   // 关闭详情弹窗
      this.drinkAddCartAnimation(pageInstance,compindex);
    }, 0)

    this.verticalListHideDetailPop(event)   // 关闭详情弹窗
  }
  
  verticalListMinuModel = (event) => {
    clearTimeout(this.takeoutTimeout);
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let newdata = {};
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let goodsid = compData.modelGoodsId;
    let price = +compData.modelPrice;
    let modelid = compData.modelChooseId;
    let attrIdArr = [];
    for (let i in compData.attrData) {
      if (compData.attrData[i]) {
        attrIdArr.push(compData.attrData[i].id);
      }
    }
    let attrIdStr = attrIdArr.sort().join('_');
    attrIdStr || (attrIdStr = '0');
    let thisModelInfo = pageInstance[compindex].goods_model_list[goodsid];
    let minusNum = 1;   //起卖数
    if (compData.cartList[0][goodsid][modelid].attrObj[attrIdStr].num <= thisModelInfo.goods_model[modelid].min_sales_nums) {
      minusNum = compData.cartList[0][goodsid][modelid].attrObj[attrIdStr].num;
    }
    if (thisModelInfo && thisModelInfo.goods_model) {
      thisModelInfo.goods_model[modelid].totalNum -= minusNum;
    }
    newdata['eles[' + compindex + '].cartList[0].' + goodsid] = compData.cartList[0][goodsid];
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = compData.goods_data_list[goodsid];
    newdata['eles[' + compindex + '].TotalNum'] = compData.TotalNum - minusNum;
    newdata['eles[' + compindex + '].TotalPrice'] = (Number(compData.TotalPrice) - Number(price) * minusNum).toFixed(2);
    newdata['eles[' + compindex + '].isDeliver'] = (+compData.shopInfo.min_deliver_price - newdata['eles[' + compindex + '].TotalPrice']).toFixed(2);
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].num -= minusNum;
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].totalPrice = Number(price * newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].num).toFixed(2);
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].attrObj[attrIdStr].num -= minusNum;
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].attrObj[attrIdStr].totalPrice = Number(price * newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].attrObj[attrIdStr].num).toFixed(2);
    newdata['eles[' + compindex + '].modelNum'] = compData.modelNum - minusNum;
    if (newdata['eles[' + compindex + '].goods_data_list.' + goodsid]) {
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum -= minusNum;
    }
    pageInstance.setData(newdata, function () {
      let userCart = compData.cartList[0];
      let myCartNum = 0;
      for (let k in userCart) {
        for (let j in userCart[k]) {
          for (let o in userCart[k][j].attrObj) {
            myCartNum += userCart[k][j].attrObj[o].num;
          }
        }
      }
      pageInstance.setData({
        ['eles[' + compindex + '].myCartNum']: myCartNum
      })
    });
    this.takeoutTimeout = setTimeout(() => {
      let options = {
        goods_type: 0,
        cartListData: pageInstance.data.eles[compindex].cartList,
        thisPage: pageInstance,
        compindex: compindex
      }
      this._addTakeoutCart(options, this.eachCartList(options), null, goodsid)
    }, 300);
  }

  verticalListHideShoppingCart = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let newdata = {};
    newdata['eles[' + compindex + '].shoppingCartShow'] = false;
    pageInstance.setData(newdata);
  }

  verticalListDeleteAllCarts = (event) => {
    let compindex = event.currentTarget.dataset.compindex;
    let pageInstance = app.getAppCurrentPage();
    let compData = pageInstance.data.eles[compindex];
    let cartIds = [];
    cartIds = this.getCartIdArray(compindex, pageInstance);
    if (cartIds.length == 0) {
      app.showModal({
        content: '请先添加商品'
      });
      return;
    }
    app.showModal({
      content: '确认要清空购物车么？',
      showCancel: true,
      confirm: () => {
        this._removeFromCart(cartIds, () => {
          this._removeFromCartCallback({
            compData: compData,
            compindex: compindex,
            thisPage: pageInstance
          })
        }, compindex)
      }
    })
  }

  _removeFromCartCallback = (options) => {
    let n = {};
    let c = options.compindex;
    let goods_data_list = options.compData.goods_data_list;
    let pageInstance = app.getAppCurrentPage();
    let goods_model_list = pageInstance[c]['goods_model_list'];
    n['eles[' + c + '].cartList'] = [{}];
    n['eles[' + c + '].cart_data'] = [];
    for (let i in goods_data_list) {
      goods_data_list[i].totalNum = 0;
    }
    for (let i in goods_model_list) {
      for (let j in goods_model_list[i].goods_model) {
        goods_model_list[i].goods_model[j].totalNum = 0
      }
    }
    n['eles' + c + '].goods_data_list'] = goods_data_list;
    n['eles[' + c + '].cartGoodsIdList'] = [];
    n['eles[' + c + '].TotalNum'] = 0;
    n['eles[' + c + '].TotalPrice'] = 0;
    options.compData.shopInfo.min_deliver_price ? n['eles[' + c + '].isDeliver'] = options.compData.shopInfo.min_deliver_price : '';
    n['eles[' + c + '].shoppingCartShow'] = true;
    options.thisPage.setData(n);
  }

  verticalListCartListMinus = (event) => {
    clearTimeout(this.takeoutTimeout);
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let newdata = {};
    let compindex = dataset.compindex;
    let goodsid = dataset.goodsid;
    let price = dataset.price;
    let modelid = dataset.modelid;
    let compData = pageInstance.data.eles[compindex];
    let index = dataset.index;
    let id = dataset.id;
    let attrId = dataset.attrid;
    compData.isAddCartGoods = true;
    compData.cartAttrId = attrId || '0';
    if (compData.cartList[index][goodsid][modelid].num == 0) {
      return;
    }
    let minusNum = 1; //起卖数
    newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid] = compData.cartList[index][goodsid];
    if (compData.goods_data_list[goodsid]) {
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = compData.goods_data_list[goodsid];
    }
    if (modelid != 0) {
      if (pageInstance[compindex]['goods_model_list'][goodsid] && pageInstance[compindex]['goods_model_list'][goodsid].goods_model) {
        pageInstance[compindex]['goods_model_list'][goodsid].goods_model[modelid].totalNum--;
        if (compData.cartList[index][goodsid][modelid].attrObj[attrId].num <= pageInstance[compindex]['goods_model_list'][goodsid].goods_model[modelid].min_sales_nums) {
          minusNum = compData.cartList[index][goodsid][modelid].attrObj[attrId].num;
        }
      }
    } else {
      if (compData.goods_data_list[goodsid].min_sales_nums && compData.cartList[index][goodsid][modelid].attrObj[attrId].num <= compData.goods_data_list[goodsid].min_sales_nums) {
        minusNum = compData.cartList[index][goodsid][modelid].attrObj[attrId].num;
      }
    }
    newdata['eles[' + compindex + '].TotalNum'] = compData.TotalNum - minusNum;
    newdata['eles[' + compindex + '].TotalPrice'] = (Number(compData.TotalPrice) - Number(price) * minusNum).toFixed(2);
    newdata['eles[' + compindex + '].isDeliver'] = (+compData.shopInfo.min_deliver_price - newdata['eles[' + compindex + '].TotalPrice']).toFixed(2);
    newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][modelid].attrObj[attrId].num -= minusNum;
    newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][modelid].attrObj[attrId].totalPrice = (Number(price) * Number(newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][modelid].attrObj[attrId].num)).toFixed(2);
    if (newdata['eles[' + compindex + '].goods_data_list.' + goodsid]) {
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum -= minusNum;
    }
    if (index === 0) {
      let userCart = compData.cartList[0];
      let myCartNum = 0;
      for (let k in userCart) {
        for (let j in userCart[k]) {
          for (let o in userCart[k][j].attrObj) {
            myCartNum += userCart[k][j].attrObj[o].num;
          }
        }
      }
      newdata['eles[' + compindex + '].myCartNum'] = myCartNum
    }
    clearInterval(compData.timer);
    compData.loopRequest = false;
    pageInstance.setData(newdata);
    this.takeoutTimeout = setTimeout(() => {
      let options = {
        goods_type: 0,
        cartListData: compData.cartList,
        thisPage: pageInstance,
        compindex: compindex,
        index: index || 0
      }
      this._addTakeoutCart(options, this.eachCartList(options), null, goodsid)
    }, 300);
    if (compData.TotalNum == 0) { // 关闭购物车
      this.verticalListHideShoppingCart(event)
    }
  }

  verticalListCartListPlus = (event) => {
    clearTimeout(this.takeoutTimeout);
    let pageInstance = app.getAppCurrentPage();
    let newdata = {};
    let dataset = event.currentTarget.dataset;
    let goodsid = dataset.goodsid;
    let modelid = dataset.modelid;
    let is_in_business = dataset.isInBusiness;
    let num = dataset.num;
    let stock = dataset.stock;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let index = dataset.index;
    let attrId = dataset.attrid;
    compData.isAddCartGoods = true;
    compData.cartAttrId = attrId || '0';
    if (num == stock) {
      app.showModal({
        content: '该商品库存不足'
      });
      return;
    }
    if (is_in_business == 0) {
      app.showModal({
        content: '该商品不在出售时间'
      })
      return;
    }
    if (compData.goods_data_list[goodsid]) {
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = compData.goods_data_list[goodsid]
    }
    newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid] = compData.cartList[index][goodsid];
    newdata['eles[' + compindex + '].TotalNum'] = compData.TotalNum + 1;
    newdata['eles[' + compindex + '].TotalPrice'] = (Number(compData.TotalPrice) + Number(compData.cartList[index][goodsid][modelid].price)).toFixed(2);
    newdata['eles[' + compindex + '].isDeliver'] = (+compData.shopInfo.min_deliver_price - newdata['eles[' + compindex + '].TotalPrice']).toFixed(2);
    if (+modelid) {
      if (compData.goods_data_list[goodsid]) {
        newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum = ++compData.goods_data_list[goodsid].totalNum
      }
      newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][modelid].attrObj[attrId].num = ++compData.cartList[index][goodsid][modelid].attrObj[attrId].num;
      newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][modelid].attrObj[attrId].totalPrice = Number(newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][modelid].attrObj[attrId].num * compData.cartList[index][goodsid][modelid].attrObj[attrId].price).toFixed(2);
      if (pageInstance[compindex]['goods_model_list'][goodsid]) {
        pageInstance[compindex]['goods_model_list'][goodsid].goods_model[modelid].totalNum++;
      }
    } else {
      if (compData.goods_data_list[goodsid] && compData.goods_data_list[goodsid].totalNum) {
        newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum = ++compData.goods_data_list[goodsid].totalNum
        newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].attrObj[attrId].num++;
        newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].attrObj[attrId].totalPrice = Number(newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].attrObj[attrId].num * newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].attrObj[attrId].price).toFixed(2);
      } else {
        newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].attrObj[attrId].num++;
        newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].attrObj[attrId].totalPrice = Number(newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].attrObj[attrId].num * newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].attrObj[attrId].price).toFixed(2);
      }
    }
    clearInterval(compData.timer);
    compData.loopRequest = false;
    pageInstance.setData(newdata);
    this.takeoutTimeout = setTimeout(() => {
      let options = {
        goods_type: 0,
        cartListData: compData.cartList,
        thisPage: pageInstance,
        compindex: compindex,
        index: index || 0
      }
      this._addTakeoutCart(options, this.eachCartList(options), null, goodsid)
    }, 300);
  }

  verticalListHideCouponsList = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let newdata = {};
    newdata['eles[' + compindex + '].shoppingCouponsList'] = false;
    pageInstance.setData(newdata);
  }

  tapVerticalListCoupon = (event) => {
    let coupon_id = event.currentTarget.dataset.id;
    let franchisee = app.getPageFranchiseeId();
    let chainParam = franchisee ? '&franchisee=' + franchisee : '';
    pageInstance.returnToVerticalFlag = 1;
    app.turnToPage('/pages/couponDetail/couponDetail?detail=' + coupon_id + chainParam);
  }

  deleteSingleCarts = (e) => {
    let dataset = e.currentTarget.dataset;
    let pageInstance = app.getAppCurrentPage();
    let compindex = dataset.compindex;
    let goodsid = dataset.goodsid;
    let modelid = dataset.modelid;
    let compData = pageInstance.data.eles[compindex];
    this._removeFromCart([compData.cartList[0][goodsid][modelid].cart_id], () => {
      let newdata = {};
      let num = compData.cartList[0][goodsid][modelid].num;
      let price = (compData.cartList[0][goodsid][modelid].price * num).toFixed(2)
      delete compData.cart_data[goodsid][modelid]
      delete compData.cartList[0][goodsid][modelid]
      if (util.isPlainObject(compData.cart_data[goodsid])) {
        delete compData.cart_data[goodsid]
        delete compData.cartList[0][goodsid]
      }
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid + '.totalNum'] = compData.goods_data_list[goodsid].totalNum - num;
      newdata['eles[' + compindex + '].cart_data'] = compData.cart_data;
      newdata['eles[' + compindex + '].cartList[0]'] = compData.cartList[0];
      newdata['eles[' + compindex + '].TotalNum'] = compData.TotalNum - num;
      newdata['eles[' + compindex + '].TotalPrice'] = (compData.TotalPrice - +price).toFixed(2);
      pageInstance.setData(newdata);
    }, compindex)
  }

  _removeFromCart = (cart_id, callback, compindex) => {
    let pageInstance = app.getAppCurrentPage();
    let compData = pageInstance.data.eles[compindex];
    let that = this;
    let data = {
      cart_id_arr: cart_id,
    }
    let newdata = {};
    compData.location_id ? data.location_id = compData.location_id : data = data;
    compData.loopRequest = false;
    clearInterval(compData.timer);
    app.sendRequest({
      url: '/index.php?r=AppShop/deleteCart',
      method: 'post',
      data: data,
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      hideLoading: true,
      success: function (res) {
        callback && callback()
        newdata['eles[' + compindex + '].shoppingCartShow'] = false;
        pageInstance.setData(newdata);
      },
      fail: function (res) {
        app.showModal({
          content: '清空购物车失败'
        })
      },
      complete: function () {
        compData.loopRequest = true;
        if (compData.customFeature.is_together && compData['location_id']) {
          that.getDiningCart(pageInstance, compindex);
        }
      }
    });
  }

  _getTakeoutStyleGoodsList = (param, pageInstance, compindex, isOnShow) => {
    if (!param.is_integral) {
      param.is_integral = 5
    }
    let _this = this;
    let categoryId = param.idx_arr.idx_value == '' ? 'all' : param.idx_arr.idx_value;
    if (pageInstance.data.eles[compindex].customFeature.showSetMeal) {
      param.show_package_goods = 2;
    }
    param.form = 'goods';
    param.only_display_common = 0;
    param.pick_up_type = [pageInstance.data.eles[compindex].pick_up_select];
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/GetGoodsList',
      data: param,
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function (res) {
        if (res.status == 0) {
          pageInstance.requesting = false;
          let compData = pageInstance.data.eles[compindex],
            newdata = {},
            isRequireing = {},
            categoryList = {};
          isRequireing['eles[' + compindex + '].pagination.category' + categoryId] = compData.pagination['category' + categoryId];
          isRequireing['eles[' + compindex + '].pagination.category' + categoryId].requesting = false;
          pageInstance.setData(isRequireing);
          if (compData.customFeature.loadAllData == '1') {
            let pxRatio = app.globalData.systemInfo.windowWidth ? 750 / app.globalData.systemInfo.windowWidth : 2;
            compData.requestNum++;
            compData.goodsCateHeight[categoryId] = {};
            if (compData.customFeature.listArrange == 1) {
              compData.goodsCateHeight[categoryId] = (Math.ceil(res.data.length / 2) * 474 + 38) / pxRatio;
            } else {
              compData.goodsCateHeight[categoryId] = (res.data.length * 226 + 38) / pxRatio;
            }
          }
          if (!compData.show_goods_data || (compData.show_goods_data && !compData.show_goods_data['category' + categoryId]) || isOnShow == 1) {
            categoryList['category' + categoryId] = []
          } else {
            categoryList['category' + categoryId] = compData.show_goods_data['category' + categoryId]
          }
          if (compData.goods_data_list) {
            newdata['eles[' + compindex + '].goods_data_list'] = compData.goods_data_list
          } else {
            newdata['eles[' + compindex + '].goods_data_list'] = {}
          }
          if (!pageInstance[compindex]['goods_model_list']) {
            pageInstance[compindex]['goods_model_list'] = {};
          }
          for (let i in res.data) {
            let form_data = res.data[i].form_data
            let goods = _this.returnCateGoods(form_data, compData);
            categoryList['category' + categoryId].push(goods);
            let goodsDataList = _this.returnGoodsDataList(form_data, compData)
            newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + ''] = goodsDataList;
            if (form_data.goods_model) {
              let new_goods_model = {}
              for (let i in form_data.goods_model) {
                new_goods_model[form_data.goods_model[i].id] = {
                  model: form_data.goods_model[i].model,
                  stock: form_data.goods_model[i].stock,
                  price: form_data.goods_model[i].price,
                  goods_id: form_data.goods_model[i].goods_id,
                  totalNum: 0,
                  vip_price: form_data.goods_model[i].vip_price && form_data.goods_model[i].vip_price !== 0 ? Number(form_data.goods_model[i].vip_price).toFixed(2) : null,
                  is_vip_goods: form_data.is_vip_goods || 0,
                  min_sales_nums: +form_data.goods_model[i].min_sales_nums || 0
                }
              }
              newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model'] = {
                modelData: [],
                name: form_data.title
              }
              pageInstance[compindex]['goods_model_list'][form_data.id] = {
                goods_model: new_goods_model
              }
              for (let k in form_data.model) {
                newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model']['modelData'].push({
                  name: form_data.model[k].name,
                  subModelName: form_data.model[k].subModelName,
                  subModelId: form_data.model[k].subModelId
                })
              }
            } else {
              newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model'] = {};
              newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model'][0] = {
                price: form_data.price,
                num: 0,
                stock: form_data.stock,
                vip_price: form_data.vip_price && form_data.vip_price !== 0 ? Number(form_data.vip_price).toFixed(2) : null,
                is_vip_goods: (form_data.is_vip_goods && form_data.vip_goods_price != form_data.price) || 0
              }
            }
          }
          newdata['eles[' + compindex + '].show_goods_data.category' + categoryId] = categoryList['category' + categoryId];
          newdata['eles[' + compindex + '].in_business_time'] = res.in_business_time;
          newdata['eles[' + compindex + '].pagination.category' + categoryId] = compData.pagination['category' + categoryId];
          param.page = res.current_page + 1;
          newdata['eles[' + compindex + '].pagination.category' + categoryId].param = param;
          newdata['eles[' + compindex + '].pagination.category' + categoryId].is_more = res.is_more;
          newdata['eles[' + compindex + '].pagination.category' + categoryId].current_page = res.current_page;
          newdata['eles[' + compindex + '].modelChoose'] = [];
          newdata['eles[' + compindex + '].modelLength'] = [];
          newdata['eles[' + compindex + '].modelIdArr'] = [];
          newdata['eles[' + compindex + '].loading'] = false;
          newdata['eles[' + compindex + '].loadingFail'] = false;
          newdata['eles[' + compindex + '].loadFirstCate'] = false;
          pageInstance.setData(newdata);
          if (compData.customFeature.loadAllData == '1') {
            if (compData.requestNum == compData.content.length) {
              if (compData.customFeature.is_together) {
                compData.loopRequest = true;
                _this.getMultiOrderingVerticalCart(compindex, pageInstance, false);
                if (compData.location_id) {
                  _this.getDiningCart(pageInstance, compindex);
                }
              } else {
                _this._getTakeoutStyleCartList(pageInstance, compindex);
              };
            }
          } else {
            if (compData.customFeature.is_together) {
              compData.loopRequest = true;
              _this.getMultiOrderingVerticalCart(compindex, pageInstance, false);
              if (compData.location_id) {
                _this.getDiningCart(pageInstance, compindex);
              }
            } else {
              if (app.globalData.isLogin) {
                _this._getTakeoutStyleCartList(pageInstance, compindex);
              } else {
                _this._parseTakeoutCartListData({ data: [] }, pageInstance, compindex);
              }
            }
          }
        }
      },
      fail: function () {
        let newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      },
      complete: function () {
        setTimeout(function () {
          pageInstance.requesting = false;
        }, 300);
      }
    });
  }

  _getTakeoutStyleCartList = (pageInstance, compindex) => {
    let _this = this;
    let franchiseeId = app.getPageFranchiseeId();
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/cartList',
      data: {
        page: -1,
        page_size: 1000,
        sub_shop_app_id: franchiseeId || '',
        parent_shop_app_id: franchiseeId ? app.getAppId() : '',
        not_get_takeout: 1,
        pick_up_type: pageInstance.data.eles[compindex].pick_up_select
      },
      success: function (cartlist) {
        _this._parseTakeoutCartListData(cartlist, pageInstance, compindex);
      },
      fail: function (res) {
        app.showModal({
          content: '购物车数据请求失败，点击确定重新加载',
          confirm: function () {
            _this._getTakeoutStyleCartList(pageInstance, compindex);
          }
        })
      }
    })
  }

  _parseTakeoutCartListData = (cartlist, pageInstance, compindex) => {
    let newdata = {},
      stockEmpty = false,
      compData = pageInstance.data.eles[compindex],
      totalNum = 0,
      totalPrice = 0.00;
    newdata['eles[' + compindex + '].cart_data'] = {};
    let goodsList = compData.goods_data_list || {};
    newdata['eles[' + compindex + '].goods_data_list'] = goodsList;
    newdata['eles[' + compindex + '].cartGoodsIdList'] = [];
    compData.flag = false;
    if (cartlist.data.length) {
      for (let i in cartlist.data) {
        let item = cartlist.data[i];
        if (goodsList[item.goods_id]) {
          goodsList[item.goods_id].totalNum = 0;
        }
      }
      newdata['eles[' + compindex + '].cartlistData'] = [];
      for (let i in cartlist.data) {
        let item = cartlist.data[i];
        newdata['eles[' + compindex + '].cartlistData'].push(item);
        if (item.goods_type == 0) {
          if (+item.num > +item.stock) {
            item.num = item.stock;
            stockEmpty = true;
          }
          newdata['eles[' + compindex + '].cart_data'][item.goods_id] ? null : newdata['eles[' + compindex + '].cart_data'][item.goods_id] = {};
          newdata['eles[' + compindex + '].cart_data'][item.goods_id][item.model_id] = {
            cart_id: item.id
          };
          if (compData.goods_data_list[item.goods_id]) {
            newdata['eles[' + compindex + '].goods_data_list']['' + item.goods_id].totalNum += +item.num;
            if (pageInstance[compindex]['goods_model_list'][item.goods_id + '']) {
              if (pageInstance[compindex]['goods_model_list'][item.goods_id + ''].goods_model) {
                pageInstance[compindex]['goods_model_list'][item.goods_id + ''].goods_model[item.model_id].totalNum += +item.num
              } else {
                pageInstance[compindex]['goods_model_list'][item.goods_id + ''][0].num += +item.num
              }
            }
          } else {
            newdata['eles[' + compindex + '].goods_data_list']['' + item.goods_id] = item;
          }
          if (!newdata['eles[' + compindex + '].cartList[0].' + item.goods_id]) {
            newdata['eles[' + compindex + '].cartList[0].' + item.goods_id] = {};
          }
          if (newdata['eles[' + compindex + '].cartGoodsIdList'].indexOf(+item.goods_id) == -1) {
            newdata['eles[' + compindex + '].cartGoodsIdList'].push(+item.goods_id);
          }
          newdata['eles[' + compindex + '].cartList[0].' + item.goods_id][item.model_id] || (newdata['eles[' + compindex + '].cartList[0].' + item.goods_id][item.model_id] = {
            list: 'list',
            id: item.goods_id,
            modelName: item.model_value ? item.model_value.join(' | ') : '',
            modelId: item.model_id,
            num: +item.num,
            price: +item.price,
            gooodsName: item.title,
            totalPrice: Number(item.num * item.price).toFixed(2),
            stock: item.stock,
            cart_id: item.id,
            in_business_time: compData.goods_data_list[item.goods_id] && compData.goods_data_list[item.goods_id].in_business_time,
            pick_up_type: item.pick_up_type,
            is_vip_goods: (item.cart_vip_goods && item.original_price != item.price) || 0,
            is_package_goods: item.is_package_goods || 0
          })
          let packageArr = [];
          if (item.is_package_goods) {
            for (let i in item.attributes) {
              packageArr.push(item.attributes[i]);
            }
          }
          let attrIdArr = [];
          let arrtStr = '';
          let attrNameArr = [];
          if (item.form_data && item.form_data.attributes) {
            for (let i = 0; i < item.form_data.attributes.length; i++) {
              attrIdArr.push(item.form_data.attributes[i].id);
            }
            if (!item.is_package_goods) {
              for (let j = 0; j < item.attributes.length; j++) {
                if (item.attributes) {
                  let elem = item.attributes[j].elem;
                  for (let k = 0; k < elem.length; k++) {
                    attrNameArr.push({
                      pName: item.attributes[j].name,
                      name: elem[k].name,
                      price: elem[k].price
                    });
                  }
                }
              }
            }
            arrtStr = attrIdArr.join('_');
            if (item.is_package_goods) {
              arrtStr = item.attributes_id;
              attrIdArr = [item.attributes_id];
              attrNameArr = [];
            }
            newdata['eles[' + compindex + '].cartList[0].' + item.goods_id][item.model_id].attrObj || (newdata['eles[' + compindex + '].cartList[0].' + item.goods_id][item.model_id].attrObj = {});
            newdata['eles[' + compindex + '].cartList[0].' + item.goods_id][item.model_id].attrArr ? newdata['eles[' + compindex + '].cartList[0].' + item.goods_id][item.model_id].attrArr.push(arrtStr) : newdata['eles[' + compindex + '].cartList[0].' + item.goods_id][item.model_id].attrArr = [].concat(arrtStr);
            newdata['eles[' + compindex + '].cartList[0].' + item.goods_id][item.model_id].attrObj[arrtStr] = {
              num: +item.num,
              price: +item.price,
              totalPrice: Number(item.num * item.price).toFixed(2),
              cart_id: item.id,
              attrIdArr: attrIdArr,
              attrNameArr: attrNameArr
            }
            if (item.is_package_goods) {
              for (let a = 0; a < packageArr.length; a++) {
                let goods_id_list = [];
                for (let k in packageArr[a].goods_list) {
                  goods_id_list.push(k);
                }
                packageArr[a].goods_id_list = goods_id_list;
              }
              newdata['eles[' + compindex + '].cartList[0].' + item.goods_id][item.model_id].attrObj[arrtStr].packageArr = packageArr;
            }
          } else {
            newdata['eles[' + compindex + '].cartList[0].' + item.goods_id][item.model_id].attrObj || (newdata['eles[' + compindex + '].cartList[0].' + item.goods_id][item.model_id].attrObj = {});
            newdata['eles[' + compindex + '].cartList[0].' + item.goods_id][item.model_id].attrArr ? newdata['eles[' + compindex + '].cartList[0].' + item.goods_id][item.model_id].attrArr.push('0') : newdata['eles[' + compindex + '].cartList[0].' + item.goods_id][item.model_id].attrArr = [].concat('0');
            newdata['eles[' + compindex + '].cartList[0].' + item.goods_id][item.model_id].attrObj['0'] = {
              num: +item.num,
              price: +item.price,
              totalPrice: Number(item.num * item.price).toFixed(2),
              cart_id: item.id,
              attrIdArr: attrIdArr,
              attrNameArr: attrNameArr
            }
          }
          totalNum += Number(item.num);
          totalPrice += Number(item.price) * item.num;
        }
      }
      newdata['eles[' + compindex + '].TotalNum'] = totalNum;
      newdata['eles[' + compindex + '].TotalPrice'] = Number(+totalPrice).toFixed(2);
      newdata['eles[' + compindex + '].loadFirstCate'] = false;
      pageInstance.setData(newdata);
      if (stockEmpty) {
        app.showModal({
          content: '部分商品库存不足，购物车总数量已修改为最大库存'
        })
        let options = {
          goods_type: 0,
          cartListData: compData.cartList,
          thisPage: pageInstance,
          compindex: compindex
        }
        this._addTakeoutCart(options, this.eachCartList(options))
      }
    } else {
      newdata['eles[' + compindex + '].TotalNum'] = 0;
      newdata['eles[' + compindex + '].TotalPrice'] = 0.00;
      newdata['eles[' + compindex + '].loadFirstCate'] = false;
      pageInstance.setData(newdata);
    }
  }

  _addTakeoutCart = (options, cart_info, callback, goodsid) => {
    let that = this;
    let compindex = options.compindex;
    let compData = options.thisPage.data.eles[compindex];
    let franchiseeId = app.getPageFranchiseeId();
    let pageInstance = app.getAppCurrentPage();
    cart_info.map((item) => {
      if (item.pick_up_type) {
        delete item.pick_up_type;
      }
      if (item.attrObj) {
        delete item.attrObj;
      }
      if (!item.form_data || item.form_data.attributes.length < 1) {
        delete item.form_data;
      }
    })
    let cartInfo = [];
    for (let i = 0; i < cart_info.length; i++) {
      if (goodsid == cart_info[i].goods_id) {
        cartInfo.push(cart_info[i]);
      }
    }
    let data = {
      cart_info: cartInfo,
      goods_type: options.goods_type,
      sub_app_id: franchiseeId || ''
    }
    if (compData['location_id'] && compData.customFeature.is_together) {
      data.location_id = compData['location_id'];
    }
    compData.loopRequest = false;
    compData.addCartComplete = false;
    app.sendRequest({
      url: '/index.php?r=AppShop/addVerticalCart',
      method: 'post',
      hideLoading: true,
      data: data,
      success: function (res) {
        if (res.status === 0) {
          let data = {}
          data['eles[' + compindex + '].cart_data.' + goodsid] = res.data[goodsid] || {};
          let cartIdArr = [];
          let isNotEnouth = true;
          for (let k in cart_info) {
            let item = cart_info[k];
            let goods = res.data[item.goods_id];
            if (goods && goods[item.model_id] && goods[item.model_id].stock < item.num) {
              isNotEnouth = false;
              data['eles[' + compindex + '].cartList[0].' + item.goods_id + '.' + item.model_id + '.attrObj.' + compData.cartAttrId + '.num'] = +goods[item.model_id].stock;
              data['eles[' + compindex + '].cartList[0].' + item.goods_id + '.' + item.model_id + '.attrObj.' + compData.cartAttrId + '.totalPrice'] = (goods[item.model_id].stock * compData.cartList[0][item.goods_id][item.model_id].price).toFixed(2);
              data['eles[' + compindex + '].cartList[0].' + item.goods_id + '.' + item.model_id + '.num'] = +goods[item.model_id].stock;
              data['eles[' + compindex + '].cartList[0].' + item.goods_id + '.' + item.model_id + '.totalPrice'] = (goods[item.model_id].stock * compData.cartList[0][item.goods_id][item.model_id].price).toFixed(2);
              if (!compData.isAddCartGoods) {
                data['eles[' + compindex + '].cartList[0].' + item.goods_id + '.' + item.model_id + '.attrObj.' + compData.cartAttrId + '.cart_id'] = goods[item.model_id].cart_id;
              }
            }
            if (item.num > 0 && goods && goods[item.model_id]) {
              cartIdArr.push(goods[item.model_id].cart_id);
            }
          }
          that.changeStock(res.data, options, compData);
          callback && callback(cartIdArr);
          options.thisPage.setData(data, function () {
            compData.addCartComplete = true;
          });
          if (!isNotEnouth) {
            app.showModal({
              content: '商品库存不足'
            })
            that.updateGoodsListNum(compindex, goodsid)
          }
        }
      },
      successStatusAbnormal: function (res) {
        if (res.status === 1 && res.is_vip_limit === 1) {
          if (compData.customFeature.is_together) {
            compData.loopRequest = true;
            that.getMultiOrderingVerticalCart(compindex, pageInstance, true, 1);
          } else {
            that._getTakeoutStyleCartList(pageInstance, compindex);
          }
          if (goodsid) {
            let newdata = {};
            let goodsInfo = compData.goods_data_list[goodsid];
            newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = goodsInfo;
            newdata['eles[' + compindex + '].cartList[0]'] = compData.cartList[0];
            newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum = 0;
            for (let i in compData.cartList[0]) {
              for (let j in compData.cartList[0][i]) {
                if (compData.cartList[0][i] && compData.cartList[0][i][j].id == goodsid) {
                  newdata['eles[' + compindex + '].modelPrice'] = 0;
                  newdata['eles[' + compindex + '].modelNum'] = 0;
                  newdata['eles[' + compindex + '].goodsModelShow'] = false;
                  newdata['eles[' + compindex + '].goodsAttrShow'] = false;
                  delete newdata['eles[' + compindex + '].cartList[0]'][goodsid]
                }
              }
            }
            that.getGoodsVipCondtionInfo(compindex, goodsid);
            newdata['eles[' + compindex + '].showVipDialog'] = true;
            pageInstance.setData(newdata);
            return false;
          }
        }
      },
      complete: function () {
        compData.loopRequest = true;
        compData.addCartComplete = true;
        compData.isAddCartGoods = false;
        if (compData.customFeature.is_together && compData['location_id']) {
          that.getDiningCart(pageInstance, compindex);
        }
      }
    })
  }

  changeStock = (data, options, compData) => {
    let newdata = {};
    let cartAttrId = compData.cartAttrId || '0';
    for (let i in data) {
      for (let j in data[i]) {
        newdata['eles[' + options.compindex + '].cartList[0].' + i + '.' + j + '.stock'] = data[i][j].stock;
        newdata['eles[' + options.compindex + '].goods_data_list.' + i + '.stock'] = data[i][j].stock;
        newdata['eles[' + options.compindex + '].cartList[0].' + i + '.' + j + '.attrObj.' + cartAttrId + '.cart_id'] = data[i][j].cart_id;
      }
    }
    options.thisPage.setData(newdata);
  }

  updateGoodsListNum = (compindex, goodsid) => {
    let pageInstance = app.getAppCurrentPage();
    let compData = pageInstance.data.eles[compindex];
    let newdata = {};
    let totalprice = 0;
    newdata['eles[' + compindex + '].TotalNum'] = 0;
    newdata['eles[' + compindex + '].TotalPrice'] = 0;
    for (let i in compData.cartList[0]) {
      let num = 0;
      let price = 0;
      for (let j in compData.cartList[0][i]) {
        for (let k in compData.cartList[0][i][j].attrObj) {
          let obj = compData.cartList[0][i][j].attrObj[k];
          num += +obj.num
          price = (obj.num * obj.price).toFixed(2)
        }
      }
      newdata['eles[' + compindex + '].goods_data_list.' + i + '.totalNum'] = num;
      newdata['eles[' + compindex + '].TotalNum'] += num;
      totalprice = (+totalprice + +price).toFixed(2)
      newdata['eles[' + compindex + '].TotalPrice'] = totalprice
    }
    pageInstance.setData(newdata)
    this.takeoutTimeout = setTimeout(() => {
      let options = {
        goods_type: 0,
        cartListData: compData.cartList,
        thisPage: pageInstance,
        compindex: compindex
      }
      this._addTakeoutCart(options, this.eachCartList(options), null, goodsid)
    }, 300);
  }

  eachCartList = (options, callback) => {
    let cart_info = [];
    let cart_index = options.index || 0;
    for (let index in options.cartListData[cart_index]) {
      if (index != undefined) {
        for (let j in options.cartListData[cart_index][index]) {
          if (options.cartListData[cart_index][index][j].attrObj) {
            for (let k in options.cartListData[cart_index][index][j].attrObj) {
              let obj = {
                goods_id: index.replace('goods', ''),
                model_id: options.cartListData[cart_index][index][j].modelId,
                pick_up_type: options.cartListData[cart_index][index][j].pick_up_type
              }
              obj.form_data = {
                attributes: []
              };
              if (options.cartListData[cart_index][index][j].attrObj[k]) {
                let attrIdArr = options.cartListData[cart_index][index][j].attrObj[k].attrIdArr;
                let packageArr = options.cartListData[cart_index][index][j].attrObj[k].packageArr;
                if (packageArr) {
                  for (let i = 0; i < attrIdArr.length; i++) {
                    if (attrIdArr[i] != 0) {
                      for (let j = 0; j < packageArr.length; j++) {
                        for (let q in packageArr[j].goods_list) {
                          let elem = [];
                          if (packageArr[j].goods_list[q]._attributes) {
                            for (let e = 0; e < packageArr[j].goods_list[q]._attributes.length; e++) {
                              for (let a = 0; a < packageArr[j].goods_list[q]._attributes[e].length; a++) {
                                elem.push(packageArr[j].goods_list[q]._attributes[e][a].id);
                              }
                            }
                          }
                          let y = {
                            id: packageArr[j].goods_list[q].goods_id,
                            num: packageArr[j].goods_list[q].selected_num,
                            model_id: packageArr[j].goods_list[q].model_id
                          }
                          if (elem.length) {
                            y.elem = elem;
                          }
                          obj.form_data.attributes.push(y);
                        }
                      }
                    }
                  }
                } else {
                  for (let i = 0; i < attrIdArr.length; i++) {
                    if (attrIdArr[i] != 0) {
                      obj.form_data.attributes.push({
                        id: attrIdArr[i],
                        num: 1
                      })
                    }
                  }
                }
                obj.num = options.cartListData[cart_index][index][j].attrObj[k].num;
                options.cartListData[cart_index][index][j].attrObj[k].cart_id ? obj['id'] = options.cartListData[cart_index][index][j].attrObj[k].cart_id : '';
              }
              cart_info.push(obj);
            }
          } else {
            let obj = {
              goods_id: index.replace('goods', ''),
              model_id: options.cartListData[cart_index][index][j].modelId,
              num: options.cartListData[cart_index][index][j].num,
              pick_up_type: options.cartListData[cart_index][index][j].pick_up_type
            }
            if (options.cartListData[cart_index][index][j].attrObj) {
              obj.attrObj = options.cartListData[cart_index][index][j].attrObj;
            }
            options.cartListData[cart_index][index][j].cart_id ? obj['id'] = options.cartListData[cart_index][index][j].cart_id : '';
            cart_info.push(obj);
          }
        }
      }
    }
    return cart_info;
  }

  _getAssessList = (pageInstance, compindex) => {
    let idx_value = 0;
    app.sendRequest({
      hideLoading: true, // 页面第一个请求才展示loading
      url: '/index.php?r=AppShop/getAssessList&idx_arr[0][idx]=goods_type&idx_arr[0][idx_value]=' + idx_value,
      data: {
        page: 1,
        page_size: 20,
        obj_name: 'app_id'
      },
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function (res) {
        let newdata = {},
          showAssess = [],
          hasImgAssessList = 0,
          goodAssess = 0,
          normalAssess = 0,
          badAssess = 0;
        for (let i = 0; i < res.data.length; i++) {
          res.data[i].assess_info.has_img == 1 ? (hasImgAssessList++ , showAssess.push(res.data[i])) : null;
          res.data[i].assess_info.level == 3 ? goodAssess++ : (res.data[i].assess_info.level == 1 ? badAssess++ : normalAssess++)
        }
        for (let j = 0; j < res.num.length; j++) {
          res.num[j] = parseInt(res.num[j])
        }
        newdata['eles[' + compindex + '].assessActive'] = 0;
        newdata['eles[' + compindex + '].assessList'] = res.data;
        newdata['eles[' + compindex + '].showAssess'] = showAssess;
        newdata['eles[' + compindex + '].assessNum'] = res.num;
        newdata['eles[' + compindex + '].moreAssess'] = res.is_more;
        newdata['eles[' + compindex + '].assessCurrentPage'] = res.current_page;
        pageInstance.setData(newdata);
      }
    })
  }

  vlSelectGoodsSameJourney = (e, compIndex) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = e ? e.currentTarget.dataset.compindex : compIndex;
    let selectSameJourney = pageInstance.data.eles.selectSameJourney;
    let franchiseeId = app.getPageFranchiseeId();
    pageInstance.returnToVerticalFlag = 1;
    app.turnToPage('/eCommerce/pages/goodsSameJourney/goodsSameJourney?sameJourneyId=' + (selectSameJourney ? selectSameJourney.id : '') + '&franchiseeId=' + franchiseeId + '&compindex=' + compindex + '&from=' + 'preview');
  }

  getCurrentLocation = (compindex, pageInstance) => {
    let newdata = {};
    app.getLocation({
      success(res) {
        const latitude = res.latitude;
        const longitude = res.longitude;
        app.sendRequest({
          url: '/index.php?r=Map/getAreaInfoByLatAndLng',
          method: 'post',
          data: {
            latitude: latitude,
            longitude: longitude
          },
          success: function (res) {
            newdata['eles[' + compindex + '].currentLocationData'] = res.data;
            pageInstance.setData(newdata);
          }
        });
      }
    })
  }

  getCartIdArray = (compindex, pageInstance) => {
    let compData = pageInstance.data.eles[compindex];
    let cartIds = [];
    for (let i = 0; i < compData.cartList.length; i++) {
      let userCart = compData.cartList[i];
      for (let k in userCart) {
        for (let j in userCart[k]) {
          for (let l in userCart[k][j].attrObj) {
            if (userCart[k][j].attrObj[l].num > 0) {
              cartIds.push(userCart[k][j].attrObj[l].cart_id);
            }
          }
        }
      }
    }
    return cartIds;
  }

  getMyCartIdArray = (compindex, pageInstance) => {
    let compData = pageInstance.data.eles[compindex];
    let cartIds = [];
    let userCart = compData.cartList[0];
    for (let k in userCart) {
      for (let j in userCart[k]) {
        for (let l in userCart[k][j].attrObj) {
          if (userCart[k][j].attrObj[l].num > 0) {
            cartIds.push(userCart[k][j].attrObj[l].cart_id);
          }
        }
      }
    }
    return cartIds;
  }

  verticalListSettlement = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = event.currentTarget.dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let franchiseeId = app.getPageFranchiseeId() || '';
    let cartIdArray = [];
    let that = this;
    this.saveFormId(event.target.formId);
    if (!compData.addCartComplete) {
      return;
    }
    if (compData.config_data.set_deliver_area_type == 1 && compData.pick_up_select == 2 && (+compData.config_data.deliver_rule_data.base_min_deliver_price > +compData.TotalPrice)) {   // 最低配送价
      return;
    }
    if (compData.config_data.set_deliver_area_type != 1 && compData.pick_up_select == 2 && (+compData.config_data.min_deliver_price > +compData.TotalPrice)) {   // 最低配送价
      return;
    }

    cartIdArray = this.getCartIdArray(compindex, pageInstance);
    if (!cartIdArray.length) {
      app.showModal({
        content: '请选择结算的商品'
      });
      return;
    }
    // 结算 选配送方式

    let currentLocationData = compData.currentLocationData;
    let selectSameJourney = compData.selectSameJourney;
    let data = {
      cart_id_arr: cartIdArray,
      filter_pick_up_type: compData.pick_up_type
    }
    if (!(compData.pick_up_type.length == 1 && compData.pick_up_type[0] == 4)) {
      if (compData.pick_up_select == 2) {
        if (!selectSameJourney && !currentLocationData) {
          app.turnToPage('/eCommerce/pages/goodsSameJourney/goodsSameJourney?sameJourneyId=' + (selectSameJourney ? selectSameJourney.id : '') + '&franchiseeId=' + franchiseeId + '&compindex=' + compindex + '&from=' + 'preview');
          return;
        }
        let lat = selectSameJourney ? selectSameJourney.latitude : currentLocationData.location.lat;
        let lng = selectSameJourney ? selectSameJourney.longitude : currentLocationData.location.lng;
        let regionId = selectSameJourney ? selectSameJourney.address_info.district.id : currentLocationData.region_id;
        data['latitude'] = lat;
        data['longitude'] = lng;
        data['region_id'] = regionId;
      }
    }
    let addressId = compData.selectSameJourneyId;
    let pagePath = '/eCommerce/pages/previewGoodsOrder/previewGoodsOrder?cart_arr=' + encodeURIComponent(cartIdArray);
    franchiseeId && (pagePath += '&franchisee=' + franchiseeId);
    addressId && (pagePath += '&addressId=' + addressId);
    compData.location_id && (pagePath += '&ec_location_id=' + compData.location_id);
    pagePath += '&type=' + compData.pick_up_select;
    pagePath += '&is_from=drink_vertical_list'; // 不让切换配送类型
    pageInstance.returnToVerticalFlag = 1;
    app.turnToPage(pagePath);
  }

  goodsPay = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = e.currentTarget.dataset;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let franchiseeId = app.getPageFranchiseeId(),
      cartIdArray = [],
      type = e.currentTarget.dataset.type,
      cartId = e.currentTarget.dataset.cartId,
      addressId = compData.selectSameJourneyId ? compData.selectSameJourneyId.id : undefined;
    cartIdArray = cartId;
    let pagePath = '/eCommerce/pages/previewGoodsOrder/previewGoodsOrder?type=' + type + '&cart_arr=' + encodeURIComponent(cartIdArray);
    franchiseeId && (pagePath += '&franchisee=' + franchiseeId);
    addressId && (pagePath += '&addressId=' + addressId);
    compData.location_id && (pagePath += '&ec_location_id=' + compData.location_id);
    compData.customFeature.is_together ? (pagePath += '&is_together=true') : (pagePath += '&is_together=false');
    pagePath += '&type=' + type;
    pageInstance.returnToVerticalFlag = 1;
    app.turnToPage(pagePath);
  }

  verticalListCloseVipDialog = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = e.currentTarget.dataset;
    let compindex = dataset.compindex;
    let newdata = {};
    newdata['eles[' + compindex + '].showVipDialog'] = false;
    pageInstance.setData(newdata);
  }

  getGoodsVipCondtionInfo = (compindex, goodsId) => {
    let pageInstance = app.getAppCurrentPage();
    let newdata = {};
    app.sendRequest({
      url: '/index.php?r=AppShop/getGoodsVipCondtionInfo',
      method: 'post',
      hideLoading: false,
      data: {
        goods_id: goodsId
      },
      success: function (res) {
        if (res.status == 0) {
          newdata['eles[' + compindex + '].vipCondtionInfo'] = res.data;
          pageInstance.setData(newdata);
        }
      }
    })
  }

  getMultiOrderingVerticalCart = (compindex, pageInstance, hideLoading, isFirst) => {
    let that = this;
    let compData = pageInstance.data.eles[compindex];
    let data = {
      get_user_list: 1,
      page: -1,
      page_size: 1000,
      sub_shop_app_id: app.getPageFranchiseeId() || ''
    };
    if (compData['location_id']) {
      data.location_id = compData['location_id'];
    }
    app.sendRequest({
      url: '/index.php?r=AppEcommerce/getMultiOrderingVerticalCart',
      method: 'get',
      data: data,
      hideLoading: hideLoading === false ? false : true,
      success: function (res) {
        compData.flag = false;
        if (!compData.loopRequest) {
          return;
        }
        compData.loopRequest = false;
        if (res.status == 0) {
          if (res.is_notice) {
            pageInstance.setData({
              ['eles[' + compindex + '].cartList']: [{}]
            })
            app.showModal({
              content: '您的同桌' + res.buyer_nickname + '已下单'
            })
          }
          if (!compData.user_list || res.user_list.length !== compData.user_list.length) {
            pageInstance.setData({
              ['eles[' + compindex + '].user_list']: res.user_list
            })
          }
          let buyer_info = res.buyer_info;
          let user_list = res.user_list;
          let my_info = {};
          for (let i = 0; i < user_list.length; i++) {
            if (user_list[i].is_myself) {
              my_info = user_list[i];
            }
          }
          let hasMyInfo = false;
          for (let j = 0; j < buyer_info.length; j++) {
            if (my_info.buyer_id === buyer_info[j].buyer_id) {
              hasMyInfo = true;
              buyer_info.unshift(buyer_info.splice(j, 1)[0]);
            }
          }
          if (!hasMyInfo) {
            buyer_info.unshift(my_info);
          }
          pageInstance.setData({
            ['eles[' + compindex + '].buyer_info']: buyer_info
          })
          if (res.is_reload || isFirst || compData.is_init) {
            compData.is_init = false;
            pageInstance.setData({
            }, function () {
              that._parseDinningCartListData(res, pageInstance, compindex);
            })
          }
        }
      },
      complete: function () {
        compData.loopRequest = true;
      },
      fail: function () {
        app.showModal({
          content: '购物车数据请求失败，点击确定重新加载',
          confirm: function () {
            that.getMultiOrderingVerticalCart(compindex, pageInstance, hideLoading, isFirst);
          }
        })
      }
    })
  }

  _parseDinningCartListData = (cartlist, pageInstance, compindex) => {
    let newdata = {},
      stockEmpty = false,
      compData = pageInstance.data.eles[compindex],
      totalNum = 0,
      totalPrice = 0.00;
    newdata['eles[' + compindex + '].cart_data'] = {};
    let goodsList = compData.goods_data_list || {};
    newdata['eles[' + compindex + '].cartGoodsIdList'] = [];
    compData.flag = false;
    for (let k in goodsList) {
      goodsList[k].totalNum = 0;
    }
    newdata['eles[' + compindex + '].goods_data_list'] = goodsList;
    if (cartlist.data.length) {
      newdata['eles[' + compindex + '].cartlistData'] = [];
      let buyer_info = cartlist.buyer_info;
      let data = cartlist.data;
      let cartlistArr = [];
      for (let i = 0; i < buyer_info.length; i++) {
        cartlistArr[i] = {};
        for (let j = 0; j < data.length; j++) {
          let item = data[j];
          newdata['eles[' + compindex + '].cartlistData'].push(item);
          if (item.goods_type == 0) {
            if (+item.num > +item.stock) {
              item.num = item.stock;
              stockEmpty = true;
            }
            newdata['eles[' + compindex + '].cart_data'][item.goods_id] ? null : newdata['eles[' + compindex + '].cart_data'][item.goods_id] = {};
            newdata['eles[' + compindex + '].cart_data'][item.goods_id][item.model_id] = {
              cart_id: item.id
            };
            if (compData.goods_data_list[item.goods_id] && i == 0) {
              newdata['eles[' + compindex + '].goods_data_list']['' + item.goods_id].totalNum += +item.num;
              if (pageInstance[compindex]['goods_model_list'][item.goods_id + '']) {
                if (pageInstance[compindex]['goods_model_list'][item.goods_id + ''].goods_model) {
                  pageInstance[compindex]['goods_model_list'][item.goods_id + ''].goods_model[item.model_id].totalNum = +item.num;
                } else {
                  pageInstance[compindex]['goods_model_list'][item.goods_id + ''][0].num += +item.num
                }
              }
            }
            if (!compData.goods_data_list[item.goods_id]) {
              newdata['eles[' + compindex + '].goods_data_list']['' + item.goods_id] = item;
            }
            if (newdata['eles[' + compindex + '].cartGoodsIdList'].indexOf(+item.goods_id) == -1) {
              newdata['eles[' + compindex + '].cartGoodsIdList'].push(+item.goods_id);
            }
            if (item.buyer_id === buyer_info[i].buyer_id) {
              cartlistArr[i][item.goods_id] = cartlistArr[i][item.goods_id] || {};
              cartlistArr[i][item.goods_id][item.model_id] = cartlistArr[i][item.goods_id][item.model_id] || {
                list: 'list',
                id: item.goods_id,
                modelName: item.model_value ? item.model_value.join(' | ') : '',
                modelId: item.model_id,
                num: +item.num,
                price: +item.price,
                gooodsName: item.title,
                totalPrice: Number(item.num * item.price).toFixed(2),
                stock: item.stock,
                cart_id: item.id,
                in_business_time: compData.goods_data_list[item.goods_id] && compData.goods_data_list[item.goods_id].in_business_time,
                pick_up_type: item.pick_up_type,
                is_vip_goods: (item.cart_vip_goods && item.original_price != item.price) || 0,
                is_package_goods: item.is_package_goods || 0
              }
              let packageArr = [];
              if (item.is_package_goods) {
                for (let i in item.attributes) {
                  packageArr.push(item.attributes[i]);
                }
              }
              let attrIdArr = [];
              let arrtStr = '';
              let attrNameArr = [];
              if (item.form_data && item.form_data.attributes) {
                for (let i = 0; i < item.form_data.attributes.length; i++) {
                  attrIdArr.push(item.form_data.attributes[i].id);
                }
                if (!item.is_package_goods) {
                  for (let j = 0; j < item.attributes.length; j++) {
                    if (item.attributes) {
                      let elem = item.attributes[j].elem;
                      for (let k = 0; k < elem.length; k++) {
                        attrNameArr.push({
                          pName: item.attributes[j].name,
                          name: elem[k].name,
                          price: elem[k].price
                        });
                      }
                    }
                  }
                }
                arrtStr = attrIdArr.join('_');
                if (item.is_package_goods) {
                  arrtStr = item.attributes_id;
                  attrIdArr = [item.attributes_id];
                  attrNameArr = [];
                }
                cartlistArr[i][item.goods_id][item.model_id].attrObj || (cartlistArr[i][item.goods_id][item.model_id].attrObj = {});
                cartlistArr[i][item.goods_id][item.model_id].attrArr ? cartlistArr[i][item.goods_id][item.model_id].attrArr.push(arrtStr) : cartlistArr[i][item.goods_id][item.model_id].attrArr = [].concat(arrtStr);
                cartlistArr[i][item.goods_id][item.model_id].attrObj[arrtStr] = {
                  num: +item.num,
                  price: +item.price,
                  totalPrice: Number(item.num * item.price).toFixed(2),
                  cart_id: item.id,
                  attrIdArr: attrIdArr,
                  attrNameArr: attrNameArr
                }
                if (item.is_package_goods) {
                  for (let a = 0; a < packageArr.length; a++) {
                    let goods_id_list = [];
                    for (let k in packageArr[a].goods_list) {
                      goods_id_list.push(k);
                    }
                    packageArr[a].goods_id_list = goods_id_list;
                  }
                  cartlistArr[i][item.goods_id][item.model_id].attrObj[arrtStr].packageArr = packageArr;
                }
              } else {
                cartlistArr[i][item.goods_id][item.model_id].attrObj || (cartlistArr[i][item.goods_id][item.model_id].attrObj = {});
                cartlistArr[i][item.goods_id][item.model_id].attrArr ? cartlistArr[i][item.goods_id][item.model_id].attrArr.push('0') : cartlistArr[i][item.goods_id][item.model_id].attrArr = [].concat('0');
                cartlistArr[i][item.goods_id][item.model_id].attrObj['0'] = {
                  num: +item.num,
                  price: +item.price,
                  totalPrice: Number(item.num * item.price).toFixed(2),
                  cart_id: item.id,
                  attrIdArr: attrIdArr
                }
              }
            }
          }
          if (i == 0) {
            totalNum += Number(item.num);
            totalPrice += Number(item.price) * item.num;
          }
        }
      }
      let userCart = cartlistArr[0];
      let myCartNum = 0;
      for (let k in userCart) {
        for (let j in userCart[k]) {
          for (let o in userCart[k][j].attrObj) {
            myCartNum += userCart[k][j].attrObj[o].num;
          }
        }
      }
      newdata['eles[' + compindex + '].myCartNum'] = myCartNum
      newdata['eles[' + compindex + '].cartList'] = cartlistArr;
      newdata['eles[' + compindex + '].TotalNum'] = totalNum;
      newdata['eles[' + compindex + '].TotalPrice'] = Number(+totalPrice).toFixed(2);
      newdata['eles[' + compindex + '].loadFirstCate'] = false;
      pageInstance.setData(newdata);
      if (stockEmpty) {
        app.showModal({
          content: '部分商品库存不足，购物车总数量已修改为最大库存'
        })
        let options = {
          goods_type: 0,
          cartListData: compData.cartList,
          thisPage: pageInstance,
          compindex: compindex
        }
        this._addTakeoutCart(options, this.eachCartList(options))
      }
    } else {
      newdata['eles[' + compindex + '].TotalNum'] = 0;
      newdata['eles[' + compindex + '].TotalPrice'] = 0.00;
      newdata['eles[' + compindex + '].loadFirstCate'] = false;
      pageInstance.setData(newdata);
    }
    pageInstance.setData(newdata);
  }

  getDiningCart = (pageInstance, compindex) => {
    let compData = pageInstance.data.eles[compindex];
    let that = this;
    clearInterval(compData.timer);
    compData.timer = setInterval(() => {
      that.getMultiOrderingVerticalCart(compindex, pageInstance, true);
    }, 4000)
  }

  verticalListDeleteBuyerCarts = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = e.currentTarget.dataset;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let that = this;
    let index = dataset.index;
    let cartIds = [];
    let buyerCartList = compData.cartList[index];
    for (let i in buyerCartList) {
      for (let j in buyerCartList[i]) {
        for (let k in buyerCartList[i][j].attrObj) {
          if (buyerCartList[i][j].attrObj[k].num > 0) {
            cartIds.push(buyerCartList[i][j].attrObj[k].cart_id);
          }
        }
      }
    }
    if (cartIds.length == 0) {
      app.showModal({
        content: '请先添加商品'
      });
      return;
    }
    this._removeFromCart(cartIds, () => {
      that._removeByerCartCallback({
        compData: compData,
        compindex: compindex,
        thisPage: pageInstance,
        index: index
      })
    }, compindex)
  }

  _removeByerCartCallback = (options) => {
    let n = {};
    let c = options.compindex;
    let goods_data_list = options.compData.goods_data_list;
    let pageInstance = app.getAppCurrentPage();
    let goods_model_list = pageInstance[c]['goods_model_list'];
    let index = options.index;
    n['eles[' + c + '].cartList' + '[' + index + ']'] = [{}];
    let buyerCartList = options.compData.cartList[index];
    let buyer_totalNum = 0;
    let buyer_totalPrice = 0;
    for (let goodsId in buyerCartList) {
      for (let i in buyerCartList[goodsId]) {
        for (let j in buyerCartList[goodsId][i].attrObj) {
          buyer_totalNum += Number(buyerCartList[goodsId][i].attrObj[j].num);
          buyer_totalPrice += Number((buyerCartList[goodsId][i].attrObj[j].num * buyerCartList[goodsId][i].attrObj[j].price).toFixed(2));
          if (goods_data_list[goodsId]) {
            goods_data_list[goodsId].totalNum -= buyerCartList[goodsId][i].attrObj[j].num;
          }
        }
      }
    }
    for (let i in goods_model_list) {
      for (let j in goods_model_list[i].goods_model) {
        goods_model_list[i].goods_model[j].totalNum = 0
      }
    }
    if (index === 0) {
      n['eles[' + c + '].myCartNum'] = 0;
    }
    n['eles[' + c + '].goods_data_list'] = goods_data_list;
    n['eles[' + c + '].TotalNum'] = options.compData.TotalNum - buyer_totalNum;
    n['eles[' + c + '].TotalPrice'] = Number(options.compData.TotalPrice - buyer_totalPrice).toFixed(2);
    options.compData.shopInfo.min_deliver_price ? n['eles[' + c + '].isDeliver'] = options.compData.shopInfo.min_deliver_price : '';
    n['eles[' + c + '].shoppingCartShow'] = true;
    options.thisPage.setData(n);
  }

  saveFormId = (form_id) => {
    let that = this;
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=api/AppMsgTpl/SaveUserFormId',
      data: {
        form_id: form_id
      },
      method: 'post',
      success: function (res) {

      }
    })
  }

  toSetMeal = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = e.currentTarget.dataset;
    let id = dataset.goodsid;
    let franchiseeId = app.getPageFranchiseeId();
    let franchiseeParam = franchiseeId ? ('&franchisee=' + franchiseeId) : '';
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    pageInstance.returnToVerticalFlag = 1;
    if (compData.goods_data_list[id].stock <= compData.goods_data_list[id].totalNum) {
      app.showModal({
        content: '库存不足'
      });
      return;
    }
    app.turnToPage('/eCommerce/pages/setMeal/setMeal?goods_id=' + id + franchiseeParam + '&listType=drink');
  }

  returnCateGoods = (goods, compData) => {
    return {
      app_id: goods.app_id,
      cover: goods.cover,
      description: goods.description,
      tags: goods.tags,
      goods_model: goods.goods_model ? goods.goods_model.length : 0,
      id: goods.id,
      price: goods.price,
      sales: goods.sales,
      title: goods.title,
      business_time: goods.business_time,
      is_in_business_time: goods.goods_in_business_time,
      stock: goods.stock,
      virtual_price: goods.virtual_price,
      corner_mark: goods.corner_mark,
      corner_url: goods.corner_url,
      vipGoods: (goods.paid_vip_card_condition || goods.paid_vip_level_condition || goods.vip_card_condition || goods.vip_level_condition) ? true : false,
      integral: goods.integral,
      img_urls: goods.img_urls || [],
      max_can_use_integral: Number(goods.max_can_use_integral),
      vip_price: goods.vip_min_price == goods.vip_max_price ? goods.vip_min_price : goods.vip_min_price + '~' + goods.vip_max_price,
      vip_goods_price: goods.vip_goods_price && goods.vip_goods_price !== 0 && !compData.customFeature.is_together ? Number(goods.vip_goods_price).toFixed(2) : null,
      calculationPrice: goods.vip_goods_price && goods.vip_goods_price !== 0 && !compData.customFeature.is_together ? Number(goods.vip_goods_price).toFixed(2) : goods.price,
      is_vip_goods: goods.is_vip_goods || 0,
      attributes: goods.attributes || null,
      is_package_goods: goods.is_package_goods || 0,
      min_sales_nums: goods.min_sales_nums || null,
      vip_min_price: goods.vip_min_price || 0,
      simple_description: goods.simple_description || ''
    }
  }

  returnGoodsDataList = (goods, compData) => {
    return {
      totalNum: 0,
      stock: goods.stock,
      name: goods.title,
      price: goods.price,
      in_business_time: goods.goods_in_business_time,
      model: {},
      goods_model: {},
      pick_up_type: goods.pick_up_type,
      paid_vip_card_condition: goods.paid_vip_card_condition,
      paid_vip_level_condition: goods.paid_vip_level_condition,
      vip_card_condition: goods.vip_card_condition,
      vip_level_condition: goods.vip_level_condition,
      vip_price: goods.vip_min_price == goods.vip_max_price ? goods.vip_min_price : goods.vip_min_price + '~' + goods.vip_max_price,
      vip_goods_price: goods.vip_goods_price && goods.vip_goods_price !== 0 && !compData.customFeature.is_together ? Number(goods.vip_goods_price).toFixed(2) : null,
      calculationPrice: goods.vip_goods_price && goods.vip_goods_price !== 0 && !compData.customFeature.is_together ? Number(goods.vip_goods_price).toFixed(2) : goods.price,
      is_vip_goods: goods.is_vip_goods || 0,
      attributes: goods.attributes || null,
      min_sales_nums: goods.min_sales_nums || null,
      vip_min_price: goods.vip_min_price || 0
    };
  }

  mealDetailTab = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = e.currentTarget.dataset;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let newdata = {};
    let that = this;
    let goodsid = dataset.goodsid;
    let modelid = dataset.modelid;
    let index = dataset.index;
    let it = dataset.it;
    newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid] = compData.cartList[index][goodsid];
    newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][modelid].attrObj[it].isShowMealDetail = !compData.cartList[index][goodsid][modelid].attrObj[it].isShowMealDetail;
    pageInstance.setData(newdata)
  }

  verticalListChooseAttr = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let pIndex = dataset.parentindex;
    let index = dataset.index;
    let compindex = dataset.compindex;
    let goodsid = dataset.goodsid;
    let compData = pageInstance.data.eles[compindex];
    let attrData = compData.goods_data_list[goodsid]['attributes'][pIndex];
    let newdata = {};
    let that = this
    newdata['eles[' + compindex + '].attrData'] = compData.attrData || {};
    let isModel = compData.goods_data_list[goodsid].model.modelData ? true : false;
    if (attrData.selected_type === "1") {
      for (let i in compData.attrData) {
        if (compData.attrData[i] && compData.attrData[i].attributes_id === attrData.id) {
          newdata['eles[' + compindex + '].attrData.' + attrData.id + '_' + compData.attrData[i].id] = null;
        }
      }
    }
    if (newdata['eles[' + compindex + '].attrData'][attrData.id + '_' + attrData.elem[index].id]) {
      newdata['eles[' + compindex + '].attrData.' + attrData.id + '_' + attrData.elem[index].id] = null;
    } else {
      attrData.elem[index].pName = attrData.name;
      newdata['eles[' + compindex + '].attrData.' + attrData.id + '_' + attrData.elem[index].id] = attrData.elem[index];
    }
    pageInstance.setData(newdata, function () {
      if (isModel) {
        that._ModelPirce(dataset, JSON.parse(JSON.stringify(compData.modelIdArr)));
      } else {
        that._AttrPirce(dataset, goodsid);
      }
    });
  }

  selectedAttrIdStr = (compData) => {
    let arr = [];
    for (let i in compData.attrData) {
      if (compData.attrData[i]) {
        arr.push(compData.attrData[i].id);
      }
    }
    if (arr.length > 0) {
      return arr.sort().join('_');
    } else {
      return '0';
    }
  }

  _AttrPirce = (dataset, goodsid) => {
    let pageInstance = app.getAppCurrentPage();
    let newdata = {};
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let attrPrice = 0;
    let attrName = '';
    let tempArr = []; 

    if (compData.attrData) {
      for (let i in compData.attrData) {
        if (compData.attrData[i]) {
          attrPrice += Number(compData.attrData[i].price);
          tempArr.push(compData.attrData[i].name);
        }
      }
    }
    attrName = tempArr.join(',');
    newdata['eles[' + compindex + '].modelVipPrice'] = Number(Number(compData.goods_data_list[goodsid].calculationPrice) + attrPrice).toFixed(2);
    newdata['eles[' + compindex + '].attrName'] = attrName;
    newdata['eles[' + compindex + '].attrPrice'] = attrPrice;
    newdata['eles[' + compindex + '].modelPrice'] = Number(Number(compData.goods_data_list[goodsid].price) + attrPrice).toFixed(2);
    if (compData.cartList[0][goodsid] && compData.cartList[0][goodsid][0] && compData.cartList[0][goodsid][0].attrObj) {
      let attrId = this.selectedAttrIdStr(compData);
      if (newdata['eles[' + compindex + '].modelNum'] = compData.cartList[0][goodsid]['0'].attrObj[attrId]) {
        newdata['eles[' + compindex + '].modelNum'] = compData.cartList[0][goodsid]['0'].attrObj[attrId].num;
      } else {
        newdata['eles[' + compindex + '].modelNum'] = 0;
      }
    } else {
      newdata['eles[' + compindex + '].modelNum'] = 0;
    }
    pageInstance.setData(newdata)
  }

  addAttrGoods = (event) => {
    clearTimeout(this.takeoutTimeout);
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let newdata = {};
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let goodsid = compData.modelGoodsId;
    let thisGoodsInfo = compData.goods_data_list[goodsid];
    let price = (Number(thisGoodsInfo.calculationPrice) + (Number(compData.attrPrice) || 0)).toFixed(2);
    if (thisGoodsInfo.stock <= thisGoodsInfo.totalNum) {
      app.showModal({
        content: '该规格库存不足'
      });
      return;
    }
    let attrIdArr = [];
    let attrNameArr = [];
    for (let i in compData.attrData) {
      if (compData.attrData[i]) {
        attrIdArr.push(compData.attrData[i].id);
        attrNameArr.push({
          pName: compData.attrData[i].pName,
          name: compData.attrData[i].name,
          price: compData.attrData[i].price
        });
      }
    }
    let attrIdStr = attrIdArr.sort().join('_');
    let attrObj = {};
    let attrNum = 0;
    attrIdStr || (attrIdStr = '0');
    compData.cartAttrId = attrIdStr || '0';
    let addNum = compData.hasAddNum;
    if (compData.cartList[0][goodsid] && compData.cartList[0][goodsid]['0'] && compData.cartList[0][goodsid]['0'].attrObj) {
              attrObj = compData.cartList[0][goodsid]['0'].attrObj;
              compData.cartList[0][goodsid]['0'].attrObj[attrIdStr] = compData.cartList[0][goodsid]['0'].attrObj[attrIdStr] || {};
              attrNum = compData.cartList[0][goodsid]['0'].attrObj[attrIdStr].num ? compData.cartList[0][goodsid]['0'].attrObj[attrIdStr].num + addNum : addNum
      } else {
        attrNum = addNum;
      }
    newdata['eles[' + compindex + '].cartGoodsIdList'] = compData.cartGoodsIdList;
    let goods_num = thisGoodsInfo.totalNum + addNum;
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = thisGoodsInfo;
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum = thisGoodsInfo.totalNum + addNum;
    newdata['eles[' + compindex + '].TotalPrice'] = (Number(compData.TotalPrice) + Number(price) * addNum).toFixed(2);
    newdata['eles[' + compindex + '].isDeliver'] = (+compData.shopInfo.min_deliver_price - newdata['eles[' + compindex + '].TotalPrice']).toFixed(2);
    newdata['eles[' + compindex + '].TotalNum'] = compData.TotalNum + addNum;
    newdata['eles[' + compindex + '].hideSearchInput'] = false;
    newdata['eles[' + compindex + '].cartList[0].' + goodsid] = compData.cartList[0][goodsid] || {};
    if (compData.cartList[0][goodsid] && compData.cartList[0][goodsid]['0'] && compData.cartList[0][goodsid]['0'].attrObj) {
      attrObj = compData.cartList[0][goodsid]['0'].attrObj;
      compData.cartList[0][goodsid]['0'].attrObj[attrIdStr] = compData.cartList[0][goodsid]['0'].attrObj[attrIdStr] || {};
      attrNum = compData.cartList[0][goodsid]['0'].attrObj[attrIdStr].num ? compData.cartList[0][goodsid]['0'].attrObj[attrIdStr].num + addNum : addNum
    } else {
      attrNum = addNum;
    }
    attrObj[attrIdStr] = {
      num: attrNum,
      price: Number(price),
      totalPrice: (attrNum * Number(price)).toFixed(2),
      attrIdArr: attrIdArr,
      attrNameArr: attrNameArr
    };
    let attrArr = [];
    if (compData.cartList[0][goodsid] && compData.cartList[0][goodsid]['0'] && compData.cartList[0][goodsid]['0'].attrArr) {
      attrArr = compData.cartList[0][goodsid]['0'].attrArr;
    }
    if (attrArr.indexOf(attrIdStr) == -1) {
      attrArr.push(attrIdStr);
    }
    newdata['eles[' + compindex + '].cartList[0].' + goodsid]['0'] = {
      modelId: '0',
      num: goods_num,
      price: price,
      id: goodsid,
      gooodsName: compData.goods_data_list[goodsid].name,
      totalPrice: (thisGoodsInfo.totalNum * price).toFixed(2),
      stock: thisGoodsInfo.stock,
      cart_id: 0,
      pick_up_type: compData.goods_data_list[goodsid].pick_up_type,
      attrObj: attrObj,
      attrArr: attrArr
    }
    if (!compData.customFeature.is_together && compData.goods_data_list[goodsid].is_vip_goods) {
      newdata['eles[' + compindex + '].cartList[0].' + goodsid]['0'].is_vip_goods = 1;
    }
    if (newdata['eles[' + compindex + '].cartGoodsIdList'].indexOf(+goodsid) == -1) {
      newdata['eles[' + compindex + '].cartGoodsIdList'].push(+goodsid);
    }
    if (compData['modelNum']) {
      newdata['eles[' + compindex + '].modelNum'] = +compData['modelNum'] + addNum;
    } else {
      newdata['eles[' + compindex + '].modelNum'] = addNum;
    }
    pageInstance.setData(newdata, function () {
      let userCart = compData.cartList[0];
      let myCartNum = 0;
      for (let k in userCart) {
        for (let j in userCart[k]) {
          for (let o in userCart[k][j].attrObj) {
            myCartNum += userCart[k][j].attrObj[o].num;
          }
        }
      }
      pageInstance.setData({
        ['eles[' + compindex + '].myCartNum']: myCartNum
      })
    });
    this.takeoutTimeout = setTimeout(() => {
      let options = {
        goods_type: 0,
        cartListData: compData.cartList,
        thisPage: pageInstance,
        compindex: compindex
      }
      this._addTakeoutCart(options, this.eachCartList(options), null, goodsid)
      this.drinkHideDetailPop(event);
      this.drinkAddCartAnimation(pageInstance,compindex);
    }, 0)
  }

  minuAttrGoods = (event) => {
    clearTimeout(this.takeoutTimeout);
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let newdata = {};
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let goodsid = compData.modelGoodsId;
    let thisGoodsInfo = compData.goods_data_list[goodsid];
    let price = thisGoodsInfo.calculationPrice;
    let modelid = '0';
    let attrIdArr = [];
    for (let i in compData.attrData) {
      if (compData.attrData[i]) {
        attrIdArr.push(compData.attrData[i].id);
      }
    }
    let attrIdStr = attrIdArr.sort().join('_');
    attrIdStr || (attrIdStr = '0');
    let minusNum = 1;   //起卖数
    if (compData.cartList[0][goodsid][modelid].attrObj[attrIdStr].num <= compData.goods_data_list[goodsid].min_sales_nums) {
      minusNum = compData.cartList[0][goodsid][modelid].attrObj[attrIdStr].num;
    }
    newdata['eles[' + compindex + '].cartList[0].' + goodsid] = compData.cartList[0][goodsid];
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = compData.goods_data_list[goodsid];
    newdata['eles[' + compindex + '].TotalNum'] = compData.TotalNum - minusNum;
    newdata['eles[' + compindex + '].TotalPrice'] = (Number(compData.TotalPrice) - Number(price) * minusNum).toFixed(2);
    newdata['eles[' + compindex + '].isDeliver'] = (+compData.shopInfo.min_deliver_price - newdata['eles[' + compindex + '].TotalPrice']).toFixed(2);
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].num -= minusNum;
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].totalPrice = Number(price * newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].num).toFixed(2);
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].attrObj[attrIdStr].num -= minusNum;
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].attrObj[attrIdStr].totalPrice = Number(price * newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].attrObj[attrIdStr].num).toFixed(2);
    newdata['eles[' + compindex + '].modelNum'] = compData.modelNum - minusNum;
    if (newdata['eles[' + compindex + '].goods_data_list.' + goodsid]) {
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum -= minusNum;
    }
    pageInstance.setData(newdata, function () {
      let userCart = compData.cartList[0];
      let myCartNum = 0;
      for (let k in userCart) {
        for (let j in userCart[k]) {
          for (let o in userCart[k][j].attrObj) {
            myCartNum += userCart[k][j].attrObj[o].num;
          }
        }
      }
      pageInstance.setData({
        ['eles[' + compindex + '].myCartNum']: myCartNum
      })
    });
    this.takeoutTimeout = setTimeout(() => {
      let options = {
        goods_type: 0,
        cartListData: pageInstance.data.eles[compindex].cartList,
        thisPage: pageInstance,
        compindex: compindex
      }
      this._addTakeoutCart(options, this.eachCartList(options), null, goodsid)
    }, 300);
  }

  checkedPickRadioFn = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let type = dataset.type;
    let newData = {};
    let compindex = dataset.compindex;
    newData['eles[' + compindex + '].pickUpType'] = type;
    pageInstance.setData(newData);
  }

  confirmGoodsPick = (event) => { // 跳转确认支付 type = compData.pickUpType
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let franchiseeId = app.getPageFranchiseeId();
    let addressId = compData.selectSameJourneyId ? compData.selectSameJourneyId.id : undefined;
    let type = compData.pickUpType;
    let cartIdArray = compData.canUsePickUpType[type].cart_list;
    var pagePath = '/eCommerce/pages/previewGoodsOrder/previewGoodsOrder?type=' + type + '&cart_arr=' + encodeURIComponent(cartIdArray);
    franchiseeId && (pagePath += '&franchisee=' + franchiseeId);
    addressId && (pagePath += '&addressId=' + addressId);
    app.turnToPage(pagePath);
  }

  drinkTurnToChainStoreList = (e) => {
    app.turnToPage('/franchisee/pages/chainStoreList/chainStoreList');
  }

  getMainStoreInfo = () => {
    let param = {};
    if (app.globalData.chainAppId) {
      param.app_id = app.globalData.chainAppId;
    } else {
      param = {};
    }
    app.sendRequest({
      url: '/index.php?r=AppShop/GetAppShopInfo',
      data: param,
      success: function (res) {
        let data = res.data;
        if (!data.app_id) {
          return;
        }
        let pageInstance = app.getAppCurrentPage();
        let inBusiness = app.businessTimeCompare(data.business_time || []);
        pageInstance.setData({
          currentChainStore: {
            name: data.name,
            phone: data.phone,
            address: data.province_name + data.city_name + data.county_name + data.address_detail,
            not_business: !inBusiness,
            is_open: data.is_open
          }
        })
      }
    })
  }

  selectPickUpType = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let compindex = dataset.compindex;
    let compData = pageInstance.data.eles[compindex];
    let categoryId = '';
    if (compData && compData.content && compData.content[compData.customFeature.selected]) {
      categoryId = compData.content[compData.customFeature.selected].source;
    }
    let pagination = compData.pagination["category" + categoryId];
    let param = pagination.param;
    let id = dataset.id;
    let newdata = {};
    pageInstance.setData({
      ['eles[' + compindex + '].pick_up_select']: id,
      ['eles[' + compindex + '].cartList']: [{}]
    });
    param.page = 1;
    param.page_size = 10;
    this._getPickUpLeft(compindex);
    this._getTakeoutStyleGoodsList(param, pageInstance, compindex, 1);
  }

  _getPickUpLeft = (compindex) => {
    let pageInstance = app.getAppCurrentPage();
    let compData = pageInstance.data.eles[compindex];
    let _index = compData.pick_up_type_new.indexOf(+compData.pick_up_select);
    // 防止dom未渲染时获取不到dom
    setTimeout(()=> {
      const $pickupItem = document.querySelector('.pickup-item');
      pageInstance.setData({
        ['eles[' + compindex + '].pick_up_select_left']: $pickupItem.offsetWidth * _index
      });
    }, 0)
    // web没有以下api 故使用上述offsetWidth获取
    // app.createSelectorQuery().select('.pickup-item').boundingClientRect(rect => {
    //   pageInstance.setData({
    //     ['eles[' + compindex + '].pick_up_select_left']: rect.width * _index
    //   })
    // }).exec();
  }

  //获取店铺广告位
  getShopAdvancedSetting = (pageInstance, compindex) => {
    let newdata = {};
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/getShopAdvancedSetting',
      data: {
        goods_type: 0,
        app_id: app.getPageFranchiseeId()
      },
      chain: true,
      success: function (res) {
        newdata['eles[' + compindex + "].advancedList"] = res.data.config_data;
        pageInstance.setData(newdata);
      }
    })
  }

  addCartAnimation = (pageInstance, compindex) => {
    let newdata = {};
    newdata['eles[' + compindex + '].addCarting'] = true;
    pageInstance.setData(newdata);
    setTimeout(()=> {
      newdata['eles[' + compindex + '].addCarting'] = false;
      pageInstance.setData(newdata);
    },500)
  }

  render() {
    const data = this.props.data;
    const isShowBottom = false;

    // 多商家配送方式
    const $merchatsPickup = () => {
      return <div className="merchants-and-pickup">
        <div className="merchants-box">
          { data.customFeature.multipleMerchants && 
            <div onClick={ this.drinkTurnToChainStoreList }>
              { currentChainStore.name || data.shopInfo.title } <label className="ico-moon icon-rightarrow" style={{ color: '#666' }}></label>
            </div>
          }
        </div>
        <div className="pickup-box" hidden={ !(data.pick_up_type && data.pick_up_type.length > 1) }>
          { price.hasPickUp(data.pick_up_type, 3) >= 0 &&
            <span className={`pickup-item ${data.pick_up_select == 3 ? 'active': ''}`}
              onClick={(e) => this.selectPickUpType(e) }
              data-compindex={ this.props.index } data-id="3">自提</span>
          }
          {
            price.hasPickUp(data.pick_up_type, 4) >= 0 &&
            <span className={`pickup-item ${data.pick_up_select == 4 ? 'active': ''}`}
              onClick={(e) => this.selectPickUpType(e) }
              data-compindex={ this.props.index } data-id="4">堂食</span>
          }
          {
            price.hasPickUp(data.pick_up_type, 2) >= 0 &&
            <span className={`pickup-item ${data.pick_up_select == 2 ? 'active': ''}`}
              onClick={(e) => this.selectPickUpType(e) }
              data-compindex={ this.props.index } data-id="2">配送</span>
          }
          <div className="active pickup-item-active"
               style={{
                        left:`${ data.pick_up_select_left / 50 || 0 }rem`,
                        width: `calc((100% / ${ data.pick_up_type.length }))`
                     }}></div>
        </div>
      </div>
    };

    // 顶部定位
    const $locationBox = () => {
      return <div className="goods-location-box" onClick={ this.drinkSelectGoodsSameJourney } data-compindex={ this.props.index }>
        <span className="ico-moon icon-goods-location"></span>
        <span className="address-box">{ data.selectSameJourney ? data.selectSameJourney.address_info.province.text + data.selectSameJourney.address_info.city.text + data.selectSameJourney.address_info.district.text + data.selectSameJourney.detail_address : ((data.currentLocationData && data.currentLocationData.formatted_addresses.recommend) || '暂无地址') }</span>
        <span className="ico-moon icon-downarrow" style={{ transform: 'translateY(.04rem)', color: '#999' }}></span>
      </div>
    };

    // tab切换栏
    const $tabsWrap = () => {
      return <div className="waimai-goods-evaluate-search">
        <div style={{width:`${data.customFeature.isShowSearch ? '25%' : '33%'}`}}>
          <div data-index="1" data-compindex={ this.props.index } onClick={ this.drinkVerticalListChangeEvaluate }
            className={ data.selected == 1 ? 'selected': '' }>商品</div>
        </div>
        <div style={{width:`${data.customFeature.isShowSearch ? '25%' : '33%'}`}}>
          <div className={`${data.selected == 2 ? 'selected': ''}`} data-index="2" data-compindex={ this.props.index }
            onClick={ this.drinkVerticalListChangeEvaluate }>评价</div>
        </div>
        <div style={{width:`${data.customFeature.isShowSearch ? '25%' : '33%'}`}}>
          <div className={`${data.selected == 3 ? 'selected': ''}`} data-index="3" data-compindex={ this.props.index }
            onClick={ this.drinkVerticalListChangeEvaluate }>店铺</div>
        </div>
        { data.customFeature.isShowSearch &&
          <div className='waimai-list-search'>
            <div onClick={ this.drinkVerticalListShowGoodsSearch } data-compindex={ this.props.index }>
              <label className='ico-moon icon-waimai-search'></label>
              <span>搜索</span>
            </div>
          </div>
        }
      </div>
    };

    // 搜索
    const $searchWrap = () => {
      return <div className="waimai-goods-evaluate-search-mode2">
        <div className='ico-moon icon-leftarrow' onClick={ this.drinkVerticalListHideGoodsSearch }
          data-compindex={ this.props.index }></div>
        <div className='waimai-goods-search-input'>
          <label className='ico-moon icon-waimai-search' style={{ float: 'left' }}></label>
          { !data.hideSearchInput &&
            <input placeholder='请输入商品名称' onInput={ this.drinkVerticalListBindSearchTitle }
              onKeyDown={ (e) => {e.keyCode === 13 && this.drinkVerticalListSearchByTitle }} data-compindex={ this.props.index } />
          }
        </div>
        <div className='evaluate-search-button' onClick={ this.drinkVerticalListSearchByTitle } data-compindex={ this.props.index }>
          搜索</div>
      </div>
    };

    // 分类 商品列表
    const $waimaiContainerWrap = () => {
      // 样式数据处理
      const styleObj = convertStyleData(data.style);
      return <div className="element waimai waimai-container-wrap"
                  style={{ display: `${ data.selected == 1 ? 'block' : 'none' }`,
                           height: `calc(${data.heightPx / 50}rem - .76rem - .1rem ${data.pick_up_select == 2 ?'- .68rem':''} ${data.pick_up_type.length > 1 || data.customFeature.multipleMerchants ? '- 1.1rem' : '- 0'}${isShowBottom ? ' - .98rem' : ''})`,
                           ...styleObj
                        }}
        onAnimationEnd={this.animationEnd} data-compindex={ this.props.index }>
        {/* 分类列表 */}
        <ScrollView className="typeList" scroll-y="true" style={{ width: "1.6rem", height: "100%", maxWidth: '1.6rem' }}>
          { data.content.map((item, index) => 
            <React.Fragment key={ index }>
              <div className="waimaiCategory"
                style={{
                  backgroundColor: `${data.customFeature.selected == index ? data.customFeature.selectedBackgroundColor : '' }`,
                  color: `${ data.customFeature.selected == index ? data.customFeature.selectedColor : '#333' }`,
                  borderLeft: `${data.customFeature.selected == index ? '.08rem solid #FA5A47': 'initial'}`,
                  width: '1.6rem',
                  maxWidth: '1.6rem',
                  fontSize: '.26rem',
                  padding: 0,
                  height: '.9rem',
                  lineHeight: '.9rem',
                  fontWeight: `${data.customFeature.selected == index ? '600' : 'normal'}`
                }}
                data-index={ index } data-id={item.source} data-compindex={ this.props.index }
                data-param={data.pagination && JSON.stringify(data.pagination['category'+item.source].param)} onClick={ this.drinkVerticalListClickCategory }
                data-cateindex={index}>
                { (item.pic && data.customFeature.directionLeft == 0 && data.customFeature.isShowListIcon && data.customFeature.databind)||(item.pic && data.customFeature.directionLeft == 0 && !data.customFeature.databind) &&
                  <img
                    src={item.pic}
                    style={{
                            display: 'inline-block',
                            verticalAlign: 'middle',
                            marginRight: '.1rem',
                            width: `${data.customFeature.typeImgWidth ? price.pxToRpx(data.customFeature.typeImgWidth) : '.3rem'}`,
                            height: `${data.customFeature.typeImgWidth ? price.pxToRpx(data.customFeature.typeImgWidth): '.3rem'}`,
                            borderRadius: `${price.pxToRpx(data.customFeature.iconRadius)}`
                          }} />
                }
                <span className="waimai-cate-text">{ item.text }</span>
                { (item.pic && data.customFeature.directionLeft == 1 && data.customFeature.isShowListIcon && data.customFeature.databind)||(item.pic && data.customFeature.directionLeft == 1 && !data.customFeature.databind) &&
                  <img
                    src={item.pic}
                    style={{
                            display: 'inline-block',
                            verticalAlign: 'middle',
                            marginLeft: '.1rem',
                            width: `${price.pxToRpx(data.customFeature.typeImgWidth)}`,
                            height: `${price.pxToRpx(data.customFeature.typeImgWidth)}`,
                            borderRadius: `${price.pxToRpx(data.customFeature.iconRadius)}`
                          }} />
                }
              </div>
            </React.Fragment>
          ) }
          <div style={{ height: '1.1rem' }}></div>
        </ScrollView>
        {/* 商品列表 分类加载 */}
        { (!data.customFeature.loadAllData || data.customFeature.loadAllData == '0') &&
          <div className='waimai-shoppingList'
            style={{ left: '1.6rem',
                     width: 'calc(100% - 1.6rem)',
                     display: 'inline-block',
                     verticalAlign: 'top',
                     height: '100%',
                     minWidth: 'calc(100% - 1.6rem)'
                  }}>
            { data.content.map((items, index) => 
              <React.Fragment key={ index }>
                <ScrollView hidden={ index != data.customFeature.selected } className="waimaigoodslist"
                  style={{ left: '1.6rem', verticalAlign: 'top', height: '100%' }} scroll-into-view={data.scrollId}
                  scroll-y={`${(data.customFeature.showShopInfo && !data.infoHeight && data.customFeature.selected == 0) ? false : true}`}
                  data-compindex={ this.props.index } data-curpage={data.curpage} data-categoryid={items.source}
                  data-param={ data.pagination && data.pagination['category'+items.source].param}
                  bindscrolltolower={ this.drinkVerticalListStyleScrollFunc } scroll-top={data.scrollTop}
                  bindscrolltoupper={ this.drinkVerticalListStyleScrollTop } upper-threshold=".2rem" lower-threshold=".5rem">
                  {/* 宣传位 */}
                  { data.customFeature.selected == 0 && data.advancedList && data.advancedList[0] !== 'none' &&
                    <div className='advance'>
                      { data.advancedList.map((item, index) => 
                        <React.Fragment key={index}>
                          { item.mark === 'img' && 
                            <div className='advanceItem'>
                              { item.img.map((imgItem, i) => 
                                <React.Fragment key={ i }>
                                  { item.Models[i].formData.action === 'turn-to-xcx'
                                    ? <React.Fragment>
                                      <img src={imgItem}
                                            style={{
                                                    width: `${item.type==1 ? '100%' : item.type==2 ? 'calc(50% - .08rem)' : item.type==3 ? 'calc(33% - .08rem)' : 'calc(25% - .1rem)' }`,
                                                    height: `${item.height / 50}rem`,
                                                    marginRight: `${item.type==1?'0':'initial'}`
                                                  }} />
                                    </React.Fragment>
                                    : <React.Fragment>
                                        <img src={imgItem}
                                             style={{
                                                     width: `${item.type==1 ? '100%' : item.type==2 ? 'calc(50% - .08rem)' : item.type==3 ? 'calc(33% - .08rem)' : 'calc(25% - .1rem)' }`,
                                                     height: `${item.height / 50}rem`,
                                                     marginRight: `${item.type==1?'0':'initial'}`
                                                   }}
                                          data-event-params={JSON.stringify(item.Models[i].formData)}
                                          data-compindex={ this.props.index } onClick={ item.Models[i].formData.action && item.Models[i].formData.action != 'none' ? this.tapEventCommonHandler : null } data-imgarr={imgItem} />
                                      </React.Fragment>
                                  }
                                </React.Fragment>
                              )}
                            </div>
                          }
                          { item.mark === 'carousel' &&
                            <div className='advanceItem' data-compindex={ this.props.index }>
                              { item.img.length > 0 &&
                                <Carousel
                                  dots={true}
                                  autoPlay={item.autoplay == 'false' ? false : true}
                                  autoplayInterval={item.auto*1000}
                                  speed={750}
                                  style={{ height: '2rem' }}
                                  dotActiveStyle={{ background: item.indicatorActiveColor }}
                                  >
                                    { item.img.map((imgItem, i) =>
                                      item.Models[i].formData.action == 'turn-to-xcx'
                                        ? <div key={i}>
                                            <img className="swiper-item" src={imgItem} style={{ height: '2rem' }} />
                                          </div>
                                        : <div key={i} data-event-params={JSON.stringify(item.Models[i].formData)} data-compindex={ this.props.index }
                                               onClick={item.Models[i].formData.action && item.Models[i].formData.action != 'none' ? this.tapEventCommonHandler : null} data-imgarr={imgItem}>
                                            <img className="swiper-item" src={imgItem} style={{ height: '2rem' }} />
                                          </div>
                                    )}
                                </Carousel>
                              }
                            </div>
                          }
                        </React.Fragment>
                      )}
                    </div>
                  }

                  <div className="takeoutCategory" data-source={items.source}>{ items.text }
                    {
                      data.customFeature.listType == '1' &&
                      <React.Fragment>
                        <div className='price' data-compindex={ this.props.index } data-curpage={data.curpage}
                          data-categoryid={items.source} data-param={data.pagination['category'+items.source].param}
                          data-sort_key="price" data-direction={data.categorySort['category'+items.source].sort_direction}
                          onClick={ this.drinkSortVerticalList }>
                          <span>价格</span>
                          <label className='ico-moon icon-news-up'
                            style={{color: `${(data.categorySort['category'+items.source].sort_direction == 1 && data.categorySort['category'+items.source].sortKey == 'price') ? '#666':'#ccc'}`}}></label>
                          <label className='ico-moon icon-news-down'
                            style={{color: `${(data.categorySort['category'+items.source].sort_direction == 0 && data.categorySort['category'+items.source].sortKey == 'price') ? '#666':'#ccc'}`}}></label>
                        </div>

                        <div className='sales' data-compindex={ this.props.index } data-curpage={data.curpage}
                          data-categoryid={items.source} data-param={data.pagination['category'+items.source].param}
                          data-sort_key="sales" data-direction={data.categorySort['category'+items.source].sort_direction}
                          onClick={ this.drinkSortVerticalList }>
                          <span>销量</span>
                          <label className='ico-moon icon-news-up'
                            style={{color: `${(data.categorySort['category'+items.source].sort_direction == 1 && data.categorySort['category'+items.source].sortKey == 'sales') ? '#666':'#ccc'}`}}></label>
                          <label className='ico-moon icon-news-down'
                            style={{color: `${(data.categorySort['category'+items.source].sort_direction == 0 && data.categorySort['category'+items.source].sortKey == 'sales') ? '#666':'#ccc'}`}}></label>
                        </div>
                      </React.Fragment>
                    }
                  </div>

                  { data.show_goods_data && data.show_goods_data['category'+items.source] && data.show_goods_data['category'+items.source].map((item, index) => 
                    (data.customFeature['listArrange'] == '0' &&
                      <div className="waimaigoods-list-item list-item" key={index}>
                        { !(!data.customFeature.showIntegral && item.integral === '1') &&
                          <div data-id={ item.id } data-compindex={ this.props.index }>
                            <div className="inner-content">
                              <div className="waimai-img">
                                <img src={ item.cover } onClick={ this.showDrinkVerticalListGoodsDetail }
                                  data-id={ item.id } data-compindex={ this.props.index } data-index={ index }
                                  data-category={items.source} data-attributes={ item.attributes } data-model={item.goods_model} />
                                  { data.customFeature.isShowStock && item.stock < 6 &&
                                    <label className='goods-stock'>仅剩{ item.stock }件</label>
                                  }
                              </div>
                              { !!+item.corner_mark && <img className='new-goods' src={item.corner_url} /> }
                              <div style={{width: 'initial', minHeight: '1.68rem'}} className="waimai-title">
                                <div className="waimai-title-text" onClick={ this.showDrinkVerticalListGoodsDetail } data-id={ item.id }
                                  data-compindex={ this.props.index } data-index={ index } data-category={items.source}
                                  data-model={item.goods_model}>
                                  { item.max_can_use_integral > 0 && <span className='jifen'>积</span> }
                                  <span className='text'>{ item.title }</span>
                                  { item.vipGoods && data.customFeature.vipShopping && <span className='vip-goods'>会员购</span> }
                                </div>
                                { data.customFeature.isShowTag && item.tags && item.tags.length &&
                                  <div className='waimai-title-dec drink-tags-box'>
                                    { item.tags.map((tagsItem, index) => 
                                      <span className='tag' key={index}>{ tagsItem }</span>
                                    ) }
                                  </div>
                                }
                                { data.customFeature.isShowDesc && item.simple_description &&
                                  <div className='waimai-title-dec'>{ item.simple_description || '' }</div>
                                }
                                <div className='waimai-title-dec'>
                                  { data.customFeature.sale !== false && <span>销量：{ item.sales }</span> }
                                  { item.min_sales_nums > 1 &&
                                    <span style={{ marginLeft: '.2rem' }}>起卖数:{ item.min_sales_nums }</span>
                                  }
                                </div>
                                { !!+item.is_vip_goods &&
                                  <div className='vip_goods_price'>
                                    {/* <span style='margin-right: .8rem;'><span style="font-size:.24rem;font-weight: normal;">¥</span>{{item.vip_price}}</span> */}
                                    <span className='vip_goods_tips'>会员价</span>
                                  </div>
                                }
                                <div className="waimai-item-bottom"
                                  style={{
                                          paddingTop: 0,
                                          marginTop: `${data.customFeature.isShowTag && data.customFeature.isShowDesc ? '0' : '.26rem'}`
                                        }}>
                                  <span className="waimai-price-per">
                                    <span
                                      style={{ fontSize: '.24rem' ,fontWeight: 'normal' }}>¥</span>{ item.is_vip_goods > 0 ? item.vip_min_price : item.price }<span
                                      style={{ fontSize: '.2rem', fontWeight: 'normal' }}>{ item.is_vip_goods > 0 ? "起" : "" }
                                    </span></span>
                                  { data.customFeature.isShowVirtualPrice && item.virtual_price && item.virtual_price!='0.00' &&
                                    <span style={{ textDecoration: 'line-through', fontSize: '.2rem', color: '#999', lineHeight: '.6rem' }}>¥{ item.virtual_price }</span>
                                  }
                                  <label className="waimai-number-change">
                                    {/* 减 */}
                                    { data.goods_data_list[item.id].totalNum > 0 && !data.customFeature.is_together&&!item.goods_model && (!item.attributes || !item.attributes.length) && !item.is_package_goods &&
                                      <label
                                        className="waimai-count-minus" data-goodsid={ item.id }
                                        onClick={ this.drinkVerticalListListMinus } data-stock={data.goods_data_list[item.id].stock}
                                        data-compindex={ this.props.index } data-model={item.goods_model}
                                        data-attributes={item.attributes} data-is-in-business={item.is_in_business_time}
                                        data-package={item.is_package_goods}></label>
                                    }
                                    {/* 数量 */}
                                    { data.goods_data_list[item.id].totalNum  > 0&&!item.goods_model && (!item.attributes || !item.attributes.length) && !item.is_package_goods &&
                                      <span
                                        className="waimai-number">{ data.goods_data_list[item.id].totalNum }</span>
                                    }
                                    {/* 加 */}
                                    { !item.goods_model && (!item.attributes || !item.attributes.length) && !item.is_package_goods &&
                                      <label
                                        className={`waimai-count-plus ${data.goods_data_list[item.id].totalNum >= data.goods_data_list[item.id].stock ? 'disabled' : ''}`}
                                        data-goodsid={ item.id } onClick={ this.drinkVerticalListListPlus }
                                        data-stock={data.goods_data_list[item.id].stock} data-compindex={ this.props.index }
                                        data-model={item.goods_model} data-categoryid={data.showCategory && data.showCategory.source}
                                        data-is-in-business={item.is_in_business_time}></label>
                                    }
                                    {/* 规格 */}
                                    { !!item.goods_model &&
                                      <label className="waimai-count-model-plus"
                                        data-goodsid={ item.id } onClick={ this.showDrinkVerticalListGoodsDetail }
                                        data-stock={data.goods_data_list[item.id].stock} data-compindex={ this.props.index }
                                        data-model={item.goods_model} data-attributes={item.attributes}
                                        data-categoryid={data.showCategory && data.showCategory.source}
                                        data-is-in-business={item.is_in_business_time} data-category={items.source} data-index={ index }>选规格</label>
                                    }
                                    {/* 属性 */}
                                    { !item.goods_model && item.attributes && item.attributes.length &&
                                      <label
                                        className="waimai-count-model-plus" data-goodsid={ item.id }
                                        onClick={ this.showDrinkVerticalListGoodsDetail } data-stock={ data.goods_data_list[item.id].stock }
                                        data-compindex={ this.props.index } data-attributes={item.attributes}
                                        data-categoryid={data.showCategory && data.showCategory.source}
                                        data-is-in-business={item.is_in_business_time} data-category={items.source} data-index={ index }>选属性</label>
                                    }
                                    {/* 套餐 */}
                                    { !!+item.is_package_goods &&
                                      <label
                                        className={`waimai-count-model-plus ${data.goods_data_list[item.id].totalNum >= data.goods_data_list[item.id].stock ? 'disabled' : ''}`}
                                        data-goodsid={ item.id } onClick={this.drinkToSetMeal}
                                        data-stock={data.goods_data_list[item.id].stock} data-compindex={ this.props.index }
                                        data-model={item.goods_model} data-categoryid={data.showCategory && data.showCategory.source}
                                        data-is-in-business={item.is_in_business_time}>选套餐</label>
                                    }
                                    {/* 数量dot */}
                                    { data.goods_data_list[item.id].totalNum  > 0 && (item.goods_model || (item.attributes && item.attributes.length) || !!+item.is_package_goods) &&
                                      <span className="waimai-number-dot">{ data.goods_data_list[item.id].totalNum }</span>
                                    }
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    )
                  )}

                  {/* 加载loading */}
                  { data.loading && <RequestStatus is="requestLoading" /> }
                  {/* 加载没有数据 */}
                  { data.pagination && data.pagination['category'+items.source].is_more == 0 && data.show_goods_data['category'+items.source] && data.show_goods_data['category'+items.source].length == 0 &&
                    <RequestStatus is="requestNone" data={{ data: "暂无数据~" }} />
                  }
                  {/* 加载失败 */}
                  { data.loadingFail &&
                    <RequestStatus is="requestFail" data={{ refreshEvent: 'drinkVerticalListStyleScrollFunc', compindex: data.compindex }} />
                  }
                  
                  <div style={{ height: '2rem' }}></div>
                </ScrollView>
              </React.Fragment>
            ) }
            {/* <div style="height:110rpx;"></div> */}
          </div>
        }
      </div>
    };

    // 搜索结果
    const $searchResult = () => {
      return <div className="element waimai waimai-container-wrap searchResult" onAnimationEnd={this.animationEnd}
        data-compindex={ this.props.index }>
        <ScrollView scroll-y="true" data-compindex={ this.props.index }
          style={{
                  height: `calc(${data.searchHeight / 50}rem ${data.customFeature.is_together ? '- .2rem' : '- 0'}${isShowBottom ? ' - .98rem' : ''})`,
                  paddingBottom:`${data.selected == 1 && data.TotalNum != 0 && !data.goodsDetailShow && !data.goodsAttrShow ? '1.3rem':''}`
                }}
          data-compindex={ this.props.index } bindscrolltolower={ this.drinkVerticalListSearchScrollFunc }>
          { data.show_goods_data && data.show_goods_data['searchResult'] && data.show_goods_data['searchResult'].map((item, index) => 
            <div key={index}>
              <div data-id={ item.id } data-compindex={ this.props.index } className='clearfix' style={{ padding: '.2rem' }}>
                <div className="inner-content">
                  <div className="waimai-img">
                    <img src={ item.cover } onClick={ this.showDrinkVerticalListGoodsDetail }
                      data-id={ item.id } data-compindex={ this.props.index } data-index={ index }
                      data-category={item.source} data-is_search='search' data-model={item.goods_model} />
                      { data.customFeature.isShowStock && item.stock < 6 && <label className='goods-stock'>仅剩{ item.stock }件</label> }
                  </div>
                  <div style={{ width: 'initial', minHeight: '1.68rem' }} className="waimai-title">
                    <div className="waimai-title-text" onClick={ this.showDrinkVerticalListGoodsDetail } data-id={ item.id }
                      data-id={ item.id } data-compindex={ this.props.index } data-index={ index }
                      data-category={item.source} data-is_search='search' data-model={item.goods_model}>
                      { item.max_can_use_integral > 0 && <span className='jifen'> 0}}">积</span> }
                      <span className='text'>{ item.title }</span>
                      { item.vipGoods && data.customFeature.vipShopping && <span className='vip-goods'>会员购</span> }
                    </div>
                    { data.customFeature.isShowTag && item.tags && item.tags.length &&
                      <div className='waimai-title-dec drink-tags-box'>
                        { item.tags.map((tagsItem, index) => 
                          <span className='tag' key={index}>{ tagsItem }</span>
                        )}
                      </div>
                    }
                    { data.customFeature.isShowDesc && item.simple_description &&
                      <div className='waimai-title-dec'> { item.simple_description || '' }</div>
                    }
                    <div className='waimai-title-dec'>
                      { data.customFeature.sale !== false && <span>销量：{ item.sales }</span> }
                      { item.min_sales_nums > 1 && <span style={{ marginLeft: '.2rem' }}>起卖数:{ item.min_sales_nums }</span> }
                    </div>
                    { !!+item.is_vip_goods &&
                      <div className='vip_goods_price'>
                        {/* <span style='margin-right: .08rem;'><span style="font-size:.24rem;font-weight: normal;">¥</span>{item.vip_price}</span> */}
                        <span className='vip_goods_tips'>会员价</span>
                      </div>
                    }
                    <div className="waimai-item-bottom"
                      style={{
                              paddingTop: 0,
                              marginTop: `${data.customFeature.isShowTag && data.customFeature.isShowDesc ? '0' : '.26rem'}`
                            }}>
                      <span className="waimai-price-per">
                        <span
                          style={{ fontSize: '.24rem', fontWeight: 'normal' }}>¥</span>{ item.is_vip_goods > 0 ? item.vip_min_price : item.price }<span
                          style={{ fontSize: '.24rem', fontWeight: 'normal' }}>{ item.is_vip_goods > 0 ? "起" : "" } </span></span>
                      { data.customFeature.isShowVirtualPrice && item.virtual_price && item.virtual_price!='0.00' &&
                        <span style={{ fontSize: '.28rem', color: '#666666', textDecoration: 'line-through', lineHeight: '.6rem' }}>¥{ item.virtual_price }</span>
                      }
                      <label className="waimai-number-change">
                        {/* 减 */}
                        {
                          data.goods_data_list[item.id].totalNum > 0 && !data.customFeature.is_together && !item.goods_model && (!item.attributes || !item.attributes.length) && !item.is_package_goods &&
                          <label
                            className="waimai-count-minus" data-goodsid={ item.id } onClick={ this.drinkVerticalListListMinus }
                            data-stock={data.goods_data_list[item.id].stock} data-compindex={ this.props.index }
                            data-model={item.goods_model} data-attributes={item.attributes}
                            data-is-in-business={item.is_in_business_time}
                            data-package={item.is_package_goods}></label>
                        }
                        {/* 数量 */}
                        { data.goods_data_list[item.id].totalNum  > 0 && !item.goods_model && (!item.attributes || !item.attributes.length) && !item.is_package_goods &&
                          <span className="waimai-number">{ data.goods_data_list[item.id].totalNum }</span>
                        }
                        {/* 加 */}
                        { !item.goods_model && (!item.attributes || !item.attributes.length) && !item.is_package_goods &&
                          <label
                            className={`waimai-count-plus ${data.goods_data_list[item.id].totalNum >= data.goods_data_list[item.id].stock ? 'disabled' : ''}`}
                            data-goodsid={ item.id } onClick={ this.drinkVerticalListListPlus }
                            data-stock={data.goods_data_list[item.id].stock} data-compindex={ this.props.index }
                            data-model={item.goods_model} data-categoryid={data.showCategory && data.showCategory.source}
                            data-is-in-business={item.is_in_business_time}></label>
                        }
                        {/* 规格 */}
                        { item.goods_model &&
                          <label className="waimai-count-model-plus" data-goodsid={ item.id }
                            onClick={ this.showDrinkVerticalListGoodsDetail } data-stock={data.goods_data_list[item.id].stock}
                            data-compindex={ this.props.index } data-model={item.goods_model}
                            data-attributes={item.attributes} data-categoryid={data.showCategory && data.showCategory.source}
                            data-is-in-business={item.is_in_business_time} data-category={item.source} data-index={ index } data-is_search="search">选规格</label>
                        }
                        {/* 属性 */}
                        { !item.goods_model && item.attributes && item.attributes.length &&
                          <label
                            className="waimai-count-model-plus" data-goodsid={ item.id }
                            onClick={ this.showDrinkVerticalListGoodsDetail } data-stock={data.goods_data_list[item.id].stock}
                            data-compindex={ this.props.index } data-attributes={item.attributes}
                            data-categoryid={data.showCategory && data.showCategory.source}
                            data-is-in-business={item.is_in_business_time} data-category={item.source} data-index={ index } data-is_search="search">选属性</label>
                        }
                        {/* 套餐 */}
                        { !!item.is_package_goods &&
                          <label className="waimai-count-model-plus"
                            data-goodsid={ item.id } onClick={ this.drinkToSetMeal }
                            data-stock={data.goods_data_list[item.id].stock} data-compindex={ this.props.index }
                            data-model={item.goods_model} data-categoryid={data.showCategory && data.showCategory.source}
                            data-is-in-business={item.is_in_business_time}>选套餐</label>
                        }
                        {/* 数量dot */}
                        { data.goods_data_list[item.id].totalNum  > 0 && (item.goods_model || (item.attributes && item.attributes.length) || item.is_package_goods) &&
                          <span className="waimai-number-dot">{ data.goods_data_list[item.id].totalNum }</span>
                        }
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* 加载loading */}
          { data.searchLoading && <RequestStatus is="requestLoading" /> }
          {/* 加载没有数据 */}
          { data.pagination['searchResult'] && data.pagination['searchResult'].is_more == 0 && data.show_goods_data['searchResult'].length == 0 &&
            <RequestStatus is="requestNone" data={{ data: "暂无数据~" }} />
          }
        </ScrollView>
      </div>
    };

    // 底部购物车
    const $bottomShoppingCart = () => {
      return <React.Fragment>
        { (data.selected == 1 || data.showSearch) && data.TotalNum != 0 && <div className="goods-bottom-background"></div> }
        { (data.selected == 1 || data.showSearch) && data.TotalNum != 0 &&
          <div className="goods-bottom-opt"
            style={{ bottom: `${isShowBottom ? 118 / 50 : 20 / 50}}rem` }}
            data-compindex={ this.props.index } onClick={ this.drinkShowShoppingCartPop }>
            <div className="shoppingcart-total-money">
              <div className={`shopping-cart-wrap ${ data.addCarting ? 'addCarting':''}`}>
                <label className="ico-moon icon-fn-cart" data-compindex={ this.props.index }
                  onClick={ this.drinkShowShoppingCartPop }></label>
                { data.TotalNum != 0 && <label className="waimai-count">{ data.TotalNum }</label> }
              </div>
              <div className="shopping-money-wrap">
                { data.TotalPrice != 0
                  ? <React.Fragment>
                      <div className={`shopping-money-price ${data.pick_up_select != 2 ? 'no-fee':''}`}><span style={{ marginRight: '.06rem' }}>¥</span>{ data.TotalPrice }</div>
                      <div className={`shopping-deliver-fee ${data.pick_up_select != 2 ? 'no-fee':''}`}>配送费 ¥{ data.config_data.set_deliver_area_type == 1 ? data.config_data.deliver_rule_data.base_deliver_fee : data.config_data.deliver_fee }</div>
                    </React.Fragment>
                  : <div className="classname" style={{ color: '#9b9b9d', lineHeight: '.88rem' }}>请选择商品</div>
                }
              </div>
            </div>
            <form>
              <button data-compindex={ this.props.index }
                      type="button"
                      onClick={ this.drinkSelectSettlement }
                      className={`sure-waimai-order ${data.pick_up_select == 2 && data.config_data && (price.getNumber(data.TotalPrice) < data.config_data.min_deliver_price) ? 'disabledBtn':'' }`}>
              { data.pick_up_select == 2 && data.config_data && (price.getNumber(data.TotalPrice) < data.config_data.min_deliver_price) 
              ? '￥' + data.config_data.min_deliver_price + ' 起送' 
              : '去结算' }
              </button>
            </form>
          </div>
        }
      </React.Fragment>
    };

    // 评价
    const $evaluationWrap = () => {
      return <div className="verticalList-shop-evaluate" style={{ display: `${data.selected == 2 ? 'block': 'none'}` }}>
        { (data.assessList && data.assessList.length > 0 || !!data.moreAssess) &&
          <ScrollView
            style={{
                    height: `calc(${data.heightPx / 50}rem ${data.infoHeight ? '' : '- ' +data.shopHeight / 50 + 'rem'} - .9rem)`
                  }}
            scroll-y="true">
            <div style={{ width: '100%', height: '.12rem', background: '#F3F3F3' }}></div>
            <div style={{ padding: '.3rem', display: 'flex', justifyContent: 'space-between' }}>
              <div className={`verticalList-assess-btn ${data.assessActive == 0? 'active' :''}`} data-active="0"
                data-compindex={ this.props.index } onClick={ this.drinkChangeAssessType }>有图({ data.assessNum[4]||0 })</div>
              <div className={`verticalList-assess-btn ${data.assessActive == 1? 'active' :''}`} data-active="1"
                data-compindex={ this.props.index } onClick={ this.drinkChangeAssessType }>好评({ data.assessNum[1]||0 })</div>
              <div className={`verticalList-assess-btn ${data.assessActive == 2? 'active' :''}`} data-active="2"
                data-compindex={ this.props.index } onClick={ this.drinkChangeAssessType }>中评({ data.assessNum[2]||0 })</div>
              <div className={`verticalList-assess-btn ${data.assessActive == 3? 'active' :''}`} data-active="3"
                data-compindex={ this.props.index } onClick={ this.drinkChangeAssessType }>差评({ data.assessNum[3]||0 })</div>
            </div>
            { data.showAssess.map((item, i) => 
              <React.Fragment key={i}>
                <div className="verticalListAssessList">
                  <img src={item.buyer_headimgurl} />
                  <div className="assessInfoTop">
                    <div className="verticalListNickname">
                      <span className="tackoutNickText">{ item.buyer_nickname }</span>
                      <span className=" pull-right">{ item.add_time }</span>
                    </div>
                    <div className="verticalListService">商家服务：
                      <label className={`ico-moon icon-satisfied ${item.assess_info.level == 1 ? 'active' :''}`}></label>
                      <span className={item.assess_info.level == 1 ? 'active' :''}> 满意</span>
                      <span style={{ color: '#9b9b9b', margin: '0 .09rem' }}>|</span>
                      <label className={`ico-moon icon-commonly ${item.assess_info.level == 2 ? 'active' :''}`}></label>
                      <span className={item.assess_info.level == 2 ? 'active' :''}> 一般</span>
                      <span style={{ color: '#9b9b9b', margin: '0 .09rem' }}>|</span>
                      <label className={`ico-moon icon-dissatisfied ${item.assess_info.level == 3 ? 'active' :''}`}></label>
                      <span className={item.assess_info.level == 3 ? 'active' :''}> 不满意</span>
                    </div>
                  </div>
                  <div className="verticalList-assess-title">
                    <span className="verticalList-assess-goodsTitle">{ item.goods_info.title }：</span>
                    <span className="verticalList-assess-goodsContent">{ item.assess_info.content }</span>
                  </div>
                  { !!item.assess_info.has_img &&
                    <React.Fragment>
                      <div style={{ marginLeft: '.74rem' }}>
                        { item.assess_info.img_arr.map((imgs, index) =>
                          <img key={index}
                            data-imgarr={JSON.stringify(item.assess_info.img_arr)} data-src={imgs} src={imgs}
                            onClick={this.previewImage} />
                        ) }
                      </div>
                    </React.Fragment>
                  }
                </div>
              </React.Fragment>
            ) }
            { !!data.moreAssess &&
              <div className="getMoreAssess" onClick={ this.drinkGetMoreAssess }
                data-compindex={ this.props.index } data-nextpage={data.assessCurrentPage + 1}>查看更多
                <label className="ico-moon icon-downarrow"></label>
              </div>
            }
            { !data.moreAssess &&
              <div className="getMoreAssess">{ data.assessList.length ? '已经到底啦' : '暂无评价' }</div>
            }
          </ScrollView>
        }
        { !data.moreAssess && !(data.assessList && data.assessList.length) &&
          <div className='noMoreAssess'>
            <img src='https://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/moreAssess.png' />
            <div className="getMoreAssess" style={{ background: '#fff' }}>暂无任何评价</div>
          </div>
        }
      </div>
    };

    // 店铺信息
    const $takeoutShopInfo = () => {
      return <div className="tokeout-shop-info" style={{
                                                        display: `${data.selected == 3 ? 'block': 'none'}`,
                                                        padding: 0
                                                      }}>
        <div style={{ fontSize: '.26rem', color: '#333333' }}>
          <div className="info-title" style={{ fontSize: '.3rem' }}>商家信息</div>
          <div className='info-shopInfo'>
            <div className="info-adress" onClick={ this.openDrinkLocation } data-name={data.shopInfo && data.shopInfo.title}
              data-address={data.shopInfo && data.shopInfo.address_detail} data-lat={ data.shopInfo && data.shopInfo.latitude}
              data-lng={data.shopInfo && data.shopInfo.longitude}>
              <label className="ico-moon icon-fesadress"></label>
              <span>{ data.shopInfo && data.shopInfo.address_detail }</span>
            </div>
            <div onClick={ this.callPhone } data-phone={ data.shopInfo && data.shopInfo.service_phone} className='info-takeout-phone'>
              <label className="ico-moon icon-fn-phone" style={{ marginRight: 0, fontSize: '.4rem', color: '#d2d2d2' }}></label>
            </div>
          </div>
          <div style={{ width: 'auto', overflow: 'hidden', margin: '0 .26rem', padding: '.26rem 0', borderBottom: '1px solid #F3F3F3' }}>
            <label className="ico-moon icon-tokeout-info" style={{ float: 'left', marginTop: '.08rem' }}></label>
            <span style={{ width: '6.5rem', whiteSpace: 'normal' }}>{ data.shopInfo && data.shopInfo.store_desc }</span>
          </div>
        </div>
        { data.shopInfo && data.shopInfo.shop_environment && data.shopInfo.shop_environment.length > 0 &&
          <div className="cutoffLine" style={{ backgroundColor: '#f3f3f3', marginBottom: 0, paddingBottom: 0, height: '.16rem' }}></div>
        }
        { data.shopInfo && data.shopInfo.shop_environment  && data.shopInfo.shop_environment.length > 0 &&
          <div>
            <div className="info-title">店铺风采</div>
            <div className='info-mien' style={{ whiteSpace: 'nowrap', overflowX: 'auto' }}>
              { data.shopInfo.shop_environment.map((imgs, index) => 
                <img key={index}
                  data-imgarr={JSON.stringify(data.shopInfo.shop_environment)} data-src={imgs} src={imgs}
                  onClick={ this.previewImage } />
                )
              }
            </div>
          </div>
        }
      </div>
    };

    // 商品详情弹窗
    const $goodsDetailDialog = () => {
      return <div className="takeout-goods-picture" data-compindex={ this.props.index }
        style={{ display: 'block' }}>
        <div className='takeout-goods-pic'>
          <label className="ico-moon icon-closes" data-compindex={ this.props.index } onClick={ this.drinkHideDetailPop}></label>
          { data.goodsDetail && data.goodsDetail.img_urls.length
            ? <Carousel dots={true}>
              {data.goodsDetail.img_urls.map((item, index) =>
                <React.Fragment key={index}>
                  <div>
                    <img src={item} />
                  </div>
                </React.Fragment>
              )}
            </Carousel>
            : <img src={data.goodsDetail && data.goodsDetail.cover} />
          }
        </div>
        <div className="goods-detail-box"> 
          <div className='goods-info'>
            <div className='goods-detail-title'>
              <span className='text'>{ data.goodsDetail && data.goodsDetail.title }</span>
              { data.goodsDetail && data.goodsDetail.vipGoods && data.customFeature.vipShopping && <span className='vip-goods'>会员购</span> }
            </div>
            {/* <div className='goods-sales-detail'>
              { data.customFeature.sale !== false &&
                <span style='margin-right:.16rem;'>销量{{data.goodsDetail.sales}}份</span>
              }
              { data.goodsDetail.min_sales_nums > 1 &&
                <span style="margin-left: .2rem;">起卖数: {{data.goodsDetail.min_sales_nums}}</span>
              }
            </div> */}
            <div>
              { data.goods_data_list[data.modelGoodsId] && data.goods_data_list[data.modelGoodsId].model.modelData && data.goods_data_list[data.modelGoodsId].model.modelData.map((goodsItems, index) => 
                <React.Fragment key={index}>
                  <div className="" style={{ paddingTop: '.3rem', paddingBottom: '.2rem', color: '#666', fontSize: '.26rem' }}>
                    { goodsItems.name }：</div>
                  <div className="model-btn">
                    { goodsItems.subModelName.map((item, i) => 
                      <span key={i}
                        className={`attr-btn ${goodsItems.subModelId[i] == data.modelIdArr[index] ? 'active' :'' }`}
                        data-id={goodsItems.subModelId[i]} data-goodsid={data.modelGoodsId} data-index={i}
                        data-parentindex={index} data-modelname={item} data-compindex={ this.props.index }
                        onClick={ this.drinkChooseModel }>{ item }</span>
                    ) }
                  </div>
                </React.Fragment>
              ) }
              { data.goods_data_list[data.modelGoodsId] && data.goods_data_list[data.modelGoodsId].attributes && data.goods_data_list[data.modelGoodsId].attributes.map((goodsItems, index) => 
                <React.Fragment key={index}>
                  <div className="" style={{ paddingTop: '.3rem', paddingBottom: '.2rem', color: '#666', fontSize: '.26rem' }}>
                    { goodsItems.name }：</div>
                  <div className="model-btn">
                    { goodsItems.elem.map((item, i) => 
                      <div key={ i }
                        className={`attr-btn ${item.id == (data.attrData && data.attrData[goodsItems.id + '_' + item.id] && data.attrData[goodsItems.id + '_' + item.id].id) ? 'active' :'' }`}
                        data-id={item.id} data-goodsid={data.modelGoodsId} data-index={i}
                        data-parentindex={index} data-modelname={item.name} data-compindex={ this.props.index }
                        onClick={ this.drinkChooseAttr } style={{ marginTop: '.1rem', marginBottom: '.1rem' }}>{ item.name }
                        <span className="atrr-price">+￥{ item.price }</span>
                      </div>
                    )}
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
          { data.goodsDetail && data.goodsDetail.description &&
            <div className='goods-desc'>
              <div style={{ color: '#323232', fontSize: '.26rem', marginBottom: '.16rem' }}>商品描述</div>
              <div dangerouslySetInnerHTML={{ __html: data.goodsDetail.des }}></div>
            </div>
          }
          { data.goodsDetail && data.goodsDetail.goodsAssess.count > 0 &&
            <div className='goods-evaluate'>
              <div className='evaluate-title'>
                <span>评价</span>
                <div className='evaluate-count pull-right' style={{ color: '#999999' }}>{ data.goodsDetail.goodsAssess.count }条评价
                </div>
              </div>
              { data.goodsDetail.goodsAssess.data.map((item, index) => 
                <div className='evaluate-info' key={index}>
                  <div className='evaluate-userInfo'>
                    <div className='evaluate-userInfo-pic'>
                      <img src={item.buyer_headimgurl} />
                    </div>
                    <div className='evaluate-userInfo-info'>
                      <div className='evaluate-userInfo-nickname'>{ item.buyer_nickname }</div>
                      <div className='evaluate-userInfo-time'>{ item.add_time }</div>
                    </div>
                  </div>
                  <div className='evaluate-desc'>
                    <div className='assess'>{ item.assess_info.content }</div>
                  </div>
                  <div className='evaluate-pics'>
                    {item.assess_info.img_arr && item.assess_info.img_arr.map((imgs, index) => 
                      <img key={index}
                        data-imgarr={JSON.stringify(item.assess_info.img_arr)} data-src={imgs} src={imgs} onClick={ this.previewImage } />
                    ) }
                  </div>
                </div>
              )}
              {
                data.goodsDetail.goodsAssess.is_more == 1 &&
                  <div className='request-all'
                    data-compindex={ this.props.index } onClick={ this.drinkGetMoreGoodsAssess }>点击加载更多</div>
              }
            </div>
          }
        </div>
        <div className="goods-add-cart">
          <div className="goods-addcart-top">
            <div>
              <div className='waimai-title clearfix'>
                { !(data.goodsDetail && data.goodsDetail.is_vip_goods)
                  ? <span style={{ marginRight: '.18rem', fontSize: '.32rem', fontWeight: 600 }}>¥{ data.modelPrice }</span>
                  : <div className='goodsDetail_vip_goods'>
                      <span className='detail_vip_price'>¥{ data.modelPrice }</span>
                      <span className='detail_vip_text'>会员价</span>
                      <span className='detail_price'>¥{ data.modelVipPrice }</span>
                    </div>
                }
                {/*
                 data.customFeature.isShowVirtualPrice && data.goodsDetail.virtual_price != '0.00' &&
                <span style='color: #666666;font-size:.28rem;text-decoration: line-through;'>¥{{data.goodsDetail.virtual_price}}</span> */}
              </div>
              <div className="goods-addcart_txt">{data.modelChoose.join(',')}{data.attrName ? data.modelChoose ? ','+data.attrName : data.attrName : ''}</div>
            </div>
              <div className="cart-btn" style={{ background: 'none' }}>
                <label className="takeout-count-minus" onClick={this.drinkMinusModelNum} data-modelprice={data.modelPrice}
                  data-goodsid={data.goodsDetail && data.goodsDetail.id} data-compindex={ this.props.index } data-isattr="true"></label>
                { data.hasAddNum > 0 &&
                  <input type="text" style={{ width: '.6rem', display: 'inline-block', verticalAlign: 'middle', color: '#000', textAlign: 'center', backgroundColor: 'transparent', border: 'none' }}
                    disabled="disabled" value={ data.hasAddNum } />
                }
                <label className="takeout-count-plus" data-modelprice={data.modelPrice}
                  data-goodsid={data.goodsDetail && data.goodsDetail.id} data-compindex={ this.props.index }
                  onClick={ this.drinkAddModelNum }></label>
              </div>
          </div>
          <div className="bottom-btn" data-modelprice={data.modelPrice} data-goodsid={data.clickGoodsId}
            data-compindex={ this.props.index } onClick={ this.drinkSureChooseModel }
            style={{ background: '#FA5A47' }}>
            { data.modelLength > 0 && (data.modelLength == data.modelIdArr.length) ? "加入购物车" : "请选择规格" }</div>
        </div>
      </div>
    };

    // 单规格属性弹窗
    const $takeoutModelChoose = () => {
      return <div className="takeout-model-choose" style={{
                                                            display: `${!data.goodsAttrShow ? 'none' : 'block'}`
                                                         }}
        data-compindex={ this.props.index } onClick={this.drinkHideModelPop}>
        <div onClick={ (e) => { e.stopPropagation() } } className="takeout-goods-picture">
          <div className='takeout-goods-pic'>
            <label className="ico-moon icon-closes" data-compindex={ this.props.index } onClick={this.drinkHideDetailPop}></label>
            { data.goodsDetail && data.goodsDetail.img_urls.length
              ? <Carousel dots={true}>
                  { data.goodsDetail.img_urls.map((item, index) =>
                    <React.Fragment key={index}>
                      <div>
                        <img src={item} />
                      </div>
                    </React.Fragment>
                  )}
                </Carousel>
              : <img src={data.goodsDetail && data.goodsDetail.cover} />
            }
          </div>
          <ScrollView style={{ paddingLeft: '.4rem', height: '4.84rem', width: '6.1rem' }} scroll-y="true">
            {data.goods_data_list && data.goods_data_list[data.modelGoodsId] && data.goods_data_list[data.modelGoodsId].attributes && data.goods_data_list[data.modelGoodsId].attributes.map((goodsItems, index) =>
              <React.Fragment key={index}>
                <div className="" style={{ paddingTop: '.3rem', paddingBottom: '.2rem', color: '#666', fontSize: '.26rem' }}>
                  { goodsItems.name }：</div>
                <div className="model-btn">
                  { goodsItems.elem.map((item, i) => 
                    <div
                      key={i}
                      className={`attr-btn ${item.id == (data.attrData && data.attrData[goodsItems.id + '_' + item.id] && data.attrData[goodsItems.id + '_' + item.id].id)? 'active' :'' }`}
                      data-id={item.id} data-goodsid={data.modelGoodsId} data-index={i}
                      data-parentindex={index} data-modelname={item.name} data-compindex={ this.props.index }
                      onClick={this.drinkChooseAttr} style={{ marginTop: '.1rem', marginBottom: '.1rem' }}>{ item.name }
                      <span className="atrr-price">+￥{ item.price }</span>
                    </div>
                  )}
                </div>
              </React.Fragment>
            )}
          { data.goodsDetail && data.goodsDetail.description &&
            <div className='goods-desc' style={{ padding: '.28rem 0 .32rem 0' }}>
              <div style={{ color: '#323232', fontSize: '.26rem', marginBottom: '.16rem' }}>商品描述</div>
              <div dangerouslySetInnerHTML={{ __html: data.goodsDetail.des }}></div>
            </div>
          }
          { data.goodsDetail && data.goodsDetail.goodsAssess.count > 0 &&
            <div className='goods-evaluate'>
              <div className='evaluate-title'>
                <span>评价</span>
                <div className='evaluate-count pull-right' style={{ color: '#999999' }}>{ data.goodsDetail.goodsAssess.count }条评价
                </div>
              </div>
              { data.goodsDetail.goodsAssess.data.map((item, index) =>
                <div className='evaluate-info' key={index}>
                  <div className='evaluate-userInfo'>
                    <div className='evaluate-userInfo-pic'>
                      <img src={item.buyer_headimgurl} />
                    </div>
                    <div className='evaluate-userInfo-info'>
                      <div className='evaluate-userInfo-nickname'>{ item.buyer_nickname }</div>
                      <div className='evaluate-userInfo-time'>{ item.add_time }</div>
                    </div>
                  </div>
                  <div className='evaluate-desc'>
                    <div className='assess'>{ item.assess_info.content }</div>
                  </div>
                  <div className='evaluate-pics'>
                    {item.assess_info.img_arr && item.assess_info.img_arr.map((imgs, index) =>
                      <img key={index}
                        data-imgarr={JSON.stringify(item.assess_info.img_arr)} data-src={imgs} src={imgs} onClick={ this.previewImage } />
                    )}
                  </div>
                </div>
              )}
              { data.goodsDetail.goodsAssess.is_more == 1 &&
                <div className='request-all'
                  data-compindex={ this.props.index } onClick={this.drinkGetMoreGoodsAssess}>点击加载更多
                </div>
              } 
            </div>
          }
          </ScrollView>
          <div className="goods-add-cart">
            <div className="goods-addcart-top">
              <div>
                <div className='waimai-title clearfix'>
                  { !( data.goodsDetail && data.goodsDetail.is_vip_goods)
                    ? <span style={{ marginRight: '.18rem', fontSize: '.32rem', fontWeight: 600 }}>¥{ data.modelPrice }</span>
                    : <div className='goodsDetail_vip_goods'>
                        <span className='detail_vip_price'>¥{ data.modelVipPrice }</span>
                        <span className='detail_vip_text'>会员价</span>
                        <span className='detail_price'>¥{ data.modelPrice }</span>
                      </div>
                  }
                </div>
                <div className="goods-addcart_txt">{ data.modelChoose && data.modelChoose.join(',') }{ data.attrName || '' }</div>
              </div>
              <div className="cart-btn" style={{ background: 'none' }}>
                <label className="takeout-count-minus" onClick={this.drinkMinusModelNum} data-modelprice={data.modelPrice}
                  data-goodsid={data.goodsDetail && data.goodsDetail.id} data-compindex={ this.props.index } data-isattr="true"></label>
                { data.hasAddNum > 0 &&
                  <input type="text" style={{ width: '.6rem', display: 'inline-block', verticalAlign: 'middle', color: '#000', textAlign: 'center' }}
                    disabled="disabled" value={ data.hasAddNum } />
                }
                <label className="takeout-count-plus" data-modelprice={data.modelPrice}
                  data-goodsid={data.goodsDetail && data.goodsDetail.id} data-compindex={ this.props.index }
                  onClick={ this.drinkAddModelNum }></label>
              </div>
            </div>
            <div className="bottom-btn" data-modelprice={data.modelPrice} data-goodsid={data.goodsDetail && data.goodsDetail.id}
              data-compindex={ this.props.index } onClick={ this.drinkAddAttrGoods }
              style={{ background: '#FA5A47' }}>加入购物车
            </div>
        </div>
        </div>
      </div>
    }

    // 单人购物车
    const $verticalListShoppingCartsList = () => {
      return <div className="verticalList-shopping-carts-list"
        style={{
                display: `${data.shoppingCartShow ? 'block': 'none'}`
              }}
        data-compindex={ this.props.index } onClick={(e) => { e.stopPropagation(); this.drinkHideShoppingCart(e) }}>
        <div onClick={(e) => e.stopPropagation()}
          style={{
                  maxHeight: `calc(${data.customFeature.showShopInfo ? (data.heightPx + 181) / 2 / 50 : (data.heightPx + 86) / 2 / 50}rem + .76rem)`,
                  height: 'auto'
                }}
          className='carts-content'>
          <div className="chosen-title" style={{ borderRadius: '.2rem .2rem 0 0' }}>
            <span className="pull-right" data-compindex={ this.props.index } onClick={(e) => { e.stopPropagation(); this.drinkDeleteAllCarts(e) } } style={{ display: 'inline-block', fontSize: '.26rem', fontWeight: 400, color: '#999', margin: '0 .3rem 0 .05rem' }}>清空</span>
            { !!data.TotalNum &&
              <div className="pull-right ico-moon icon-delete" onClick={ this.drinkDeleteAllCarts }
                data-compindex={ this.props.index }
                style={{ display: 'inline-block', fontSize: '.26rem', fontWeight: 400, color: '#999', transform: 'translateY(.02rem)' }}></div>
            }
          </div>
          { data.TotalNum === 0 && <div className='noGoods'>暂未选购商品</div> }
          <ScrollView
            style={{
                    maxHeight: `calc(${data.customFeature.showShopInfo ? ((data.heightPx + 181) / 2 - 37) / 50 : ((data.heightPx + 86) / 2 - 37) / 50}rem + .5rem)`
                  }}
            scroll-y="true">
            {data.cartGoodsIdList.map((items, index) =>
              <React.Fragment key={index}>
                {data.cartList[0][items] && Object.values(data.cartList[0][items]).map((item, i) => 
                  <React.Fragment key={i}>
                    { item.attrArr && item.attrArr.map((it, i) =>
                      <React.Fragment key={i}>
                        { item.modelId != 0 ?
                          <React.Fragment>
                            { !!item.attrObj[it].num &&
                              <div
                                className={`shopping-cart-list ${item.in_business_time == 0 ? 'gray' : ''}`} style={{ margin: '0 .3rem' }}
                                key={index}>
                                <div className="cart-info">
                                  <div className="cart-title" style={{ marginTop: '.3rem' }}>{ item.gooodsName }
                                  </div>
                                  <div className="cart-model">{ item.modelName }</div>
                                  { item.attrObj[it].attrNameArr && !!item.attrObj[it].attrNameArr.length &&
                                    <React.Fragment>
                                      { item.attrObj[it].attrNameArr.map((attrItem, attrIndex) =>
                                        <React.Fragment key={attrIndex}>
                                          <div className="cart-model">{ attrItem.pName } : { attrItem.name } <span
                                              style={{ color: '#F2303E' }}>+￥{ attrItem.price }</span></div>
                                        </React.Fragment>
                                      )}
                                    </React.Fragment>
                                  }
                                </div>
                                <div className="cart-price">
                                  {/* <span className='cart_vip_tips' if="{{item.is_vip_goods}}">会员</span> */}
                                  <span>¥{ item.attrObj[it].totalPrice }</span>
                                </div>
                                <div className="cart-btn">
                                  { item.in_business_time != 0
                                    ? <React.Fragment>
                                        <label className={`verticalList-count-minus ${item.in_business_time == 0 ? 'disabled': ''}`}
                                          onClick={(e) => { e.stopPropagation(); this.drinkCartListMinus(e) } } data-id={item.cart_id} data-modelid={item.modelId}
                                          data-is-in-business={item.in_business_time} data-compindex={ this.props.index }
                                          data-attrid={it} data-goodsid={item.id} data-stock={item.stock} data-index="0"
                                          data-num={ item.attrObj[it].num } data-price={item.attrObj[it].price}></label>
                                        <input type="text" style={{ width: '.5rem', display: 'inline-block', border: 'none', backgroundColor: 'transparent' }} disabled="disabled"
                                          value={ item.attrObj[it].num } />
                                        { (!data.customFeature.is_together || buyer_index == 0) &&
                                          <label
                                            className={`verticalList-count-plus ${item.in_business_time == 0 || (item.attrObj[it].num >= item.stock) ? 'disabled' : ''}`}
                                            onClick={(e) => { e.stopPropagation(); this.drinkCartListPlus(e) } } data-modelid={item.modelId} data-compindex={ this.props.index }
                                            data-is-in-business={item.in_business_time} data-goodsid={item.id} data-index="0"
                                            data-stock={item.stock} data-num={item.attrObj[it].num} data-id={item.cart_id}
                                            data-attrid={it}></label>
                                        }
                                      </React.Fragment>
                                    : <React.Fragment>
                                        <span className="delete-single-cart" onClick={this.drinkDeleteSingleCarts}
                                          data-modelid={item.modelId} data-compindex={ this.props.index }
                                          data-goodsid={item.id}>删除</span>
                                      </React.Fragment>
                                  }
                                </div>
                              </div>
                            }
                          </React.Fragment>
                          : 
                            <React.Fragment>
                              { !!item.attrObj[it].num &&
                                <div className="shopping-cart-list" style={{ margin: '0 .3rem' }}>
                                  <div className="cart-info">
                                    { item.in_business_time != 0 &&
                                      <div className="cart-title"
                                        style={{
                                                marginTop: `${(item.attrObj[it].attrName && item.attrObj[it].packageArr) ? '.3rem' : '.44rem'}`
                                              }}
                                        data-modelid={item.modelId} data-compindex={ this.props.index } data-goodsid={item.id}
                                        data-index="0" data-it={it} onClick={this.drinkMealDetailTab}
                                        data-ispackage={item.is_package_goods}><span className="goodsName"
                                          style={{ 
                                                  maxWidth: `${item.is_package_goods ? 'calc(100% - .6rem)' : '100%'}`
                                                }}>{ item.gooodsName }</span>
                                        { !item.attrObj[it].isShowMealDetail && !!+item.is_package_goods && item.attrObj[it].packageArr &&
                                          <label className="ico-moon icon-downarrow"></label>
                                        }
                                        { item.attrObj[it].isShowMealDetail && !!+item.is_package_goods && item.attrObj[it].packageArr &&
                                          <label className="ico-moon icon-uparrow"></label>
                                        }
                                        { item.attrObj[it].attrNameArr && !!item.attrObj[it].attrNameArr.length &&
                                          <React.Fragment>
                                            { item.attrObj[it].attrNameArr.map((attrItem, attrIndex) => 
                                              <React.Fragment key={attrIndex}>
                                                <div className="cart-model">{ attrItem.pName } : { attrItem.name } <span
                                                    style={{color: '#F2303E'}}>+￥{ attrItem.price }</span></div>
                                              </React.Fragment>
                                            )}
                                          </React.Fragment>
                                        }
                                      </div>
                                    }
                                    { item.in_business_time == 0 &&
                                      <React.Fragment>
                                        <div className="cart-title" style={{ marginTop: '.3rem' }}>{ item.gooodsName }</div>
                                        <div className="cart-model">(不在出售时间)</div>
                                      </React.Fragment>
                                    }
                                  </div>
                                  <div className="cart-price">
                                    {/* item.is_vip_goods &&
                                      <span className='cart_vip_tips'>会员</span>
                                    */}
                                    <span>¥{ item.attrObj[it].totalPrice }</span>
                                  </div>
                                  <div className="cart-btn">
                                    { item.in_business_time != 0 ?
                                      <React.Fragment>
                                        <label className={`verticalList-count-minus ${item.in_business_time == 0 ? 'disabled': ''}`}
                                          data-is-in-business={item.in_business_time} onClick={(e) => { e.stopPropagation(); this.drinkCartListMinus(e) }}
                                          data-modelid={item.modelId} data-compindex={ this.props.index } data-goodsid={item.id}
                                          data-stock={item.stock} data-attrid={it} data-id={item.cart_id} data-index="0"
                                          data-price={item.price} data-num={ item.attrObj[it].num}></label>
                                        <input type="text" style={{ width: '.5rem', display: 'inline-block', border: 'none', backgroundColor: 'initial' }} disabled="disabled"
                                          value={ item.attrObj[it].num } />
                                        { (!data.customFeature.is_together || buyer_index == 0) &&
                                          <label
                                            className={`verticalList-count-plus ${item.in_business_time == 0 || (item.attrObj[it].num >= item.stock) ? 'disabled': '' }`}
                                            onClick={(e) => { e.stopPropagation(); this.drinkCartListPlus(e) }} data-attrid={it} data-modelid={item.modelId}
                                            data-is-in-business={item.in_business_time} data-compindex={ this.props.index }
                                            data-goodsid={item.id} data-stock={item.stock} data-num={ item.attrObj[it].num }
                                            data-index="0" data-id={item.cart_id}></label>
                                        }
                                      </React.Fragment>
                                      :
                                      <React.Fragment>
                                        <span className="delete-single-cart" onClick={this.drinkDeleteSingleCarts}
                                          data-modelid={item.modelId} data-compindex={ this.props.index }
                                          data-goodsid={item.id}>删除</span>
                                      </React.Fragment>
                                    }
                                  </div>
                                  { item.attrObj[it].isShowMealDetail && item.is_package_goods &&
                                    <div className="cart-meal">
                                      <div>
                                        <div className="meal-detail">
                                          { item.attrObj[it].packageArr.map((packageItem, index) =>
                                            <React.Fragment key={index}>
                                              { packageItem.goods_id_list.map((skuId, index) => 
                                                <React.Fragment key={index}>
                                                  { packageItem.goods_list[skuId] &&
                                                    <div className="meal-item">
                                                      <div className="meal-info">
                                                        { packageItem.goods_list[skuId].is_require > 0 && packageItem.goods_list[skuId].is_multi_select > 0 && packageItem.goods_list[skuId].selected_num > packageItem.goods_list[skuId].min_sales_nums && packageItem.goods_list[skuId].selected_num > 1 ?
                                                          <React.Fragment>
                                                            <div className="item-title">
                                                              <span>{ packageItem.goods_list[skuId].title }</span>
                                                              <label>必</label>
                                                              <label>标配</label>
                                                            </div>
                                                            { packageItem.goods_list[skuId].model_name &&
                                                              <div className="item-info"> { packageItem.goods_list[skuId].model_name }</div>
                                                            }
                                                            <div className="item-title">
                                                              <span>{ packageItem.goods_list[skuId].title }</span>
                                                              { packageItem.goods_list[skuId].added_price > 0 &&
                                                                <div style={{ float: 'right' }} className="item-add-price">
                                                                  +￥{ packageItem.goods_list[skuId].added_price }</div>
                                                              }
                                                            </div>
                                                          </React.Fragment>
                                                          :
                                                          <React.Fragment>
                                                            <div className="item-title">
                                                              <span>{ packageItem.goods_list[skuId].title }</span>
                                                              { packageItem.goods_list[skuId].is_require > 0 && <label>必</label> }
                                                              { packageItem.goods_list[skuId].is_require > 0 && <label>标配</label> }
                                                              { !(packageItem.goods_list[skuId].is_require > 0) && packageItem.goods_list[skuId].added_price > 0 &&
                                                                <div style={{ float: 'right' }} className="item-add-price">+￥{ packageItem.goods_list[skuId].added_price }</div> }
                                                            </div>
                                                          </React.Fragment>
                                                        }
                                                        { packageItem.goods_list[skuId].model_name &&
                                                          <div className="item-info"> { packageItem.goods_list[skuId].model_name }</div>
                                                        }
                                                        { packageItem.goods_list[skuId]._attributes.map((_attr, index) =>
                                                          <React.Fragment key={index}>
                                                            { _attr.elem.map((elem, index) =>
                                                              <React.Fragment key={index}>
                                                                { elem.price > 0 &&
                                                                  <div className="item-info">{ _attr.name } : { elem.name }<span> +￥{ elem.price }</span></div>
                                                                }
                                                              </React.Fragment>
                                                            )}
                                                          </React.Fragment>
                                                        )}
                                                      </div>
                                                      <div style={{ display: 'inline-block', verticalAlign: 'top', float: 'right' }}>
                                                        { packageItem.goods_list[skuId].is_require > 0 && packageItem.goods_list[skuId].is_multi_select > 0 && packageItem.goods_list[skuId].selected_num > packageItem.goods_list[skuId].min_sales_nums && packageItem.goods_list[skuId].selected_num > 1 ?
                                                          <React.Fragment>
                                                            <div className="item-num">×{ packageItem.goods_list[skuId].min_sales_nums }</div>
                                                            <div className="item-num"
                                                              style={{
                                                                      float: 'none',
                                                                      paddingTop: `${packageItem.goods_list[skuId].model_name ? '.76rem' : ''}`
                                                                    }}>
                                                              ×{ packageItem.goods_list[skuId].selected_num - packageItem.goods_list[skuId].min_sales_nums }
                                                            </div>
                                                          </React.Fragment>
                                                          :
                                                          <React.Fragment>
                                                            <div className="item-num">×{ packageItem.goods_list[skuId].selected_num }</div>
                                                          </React.Fragment>
                                                        }
                                                      </div>
                                                    </div>
                                                  }
                                                </React.Fragment>
                                              ) }
                                            </React.Fragment>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  }
                                </div>
                              }
                            </React.Fragment>
                        }
                      </React.Fragment>
                    )}
                  </React.Fragment>
                )}
              </React.Fragment>
            )}
          </ScrollView>
        </div>
      </div>
    }

    // 优惠券弹窗
    const $couponsList = () => {
      return <div className='takeout-shopping-carts-list coupons-list'
        style={{
                display: `${!data.shoppingCouponsList ? 'none': 'block'}`
              }}>
        <div className='shop-info-detail'>
          <ScrollView scroll-y>
            <div className='shop-name'>{data.shopInfo && data.shopInfo.title }</div>
            <div className='shop-info-content'>
              <div className='content-text'>营业时间</div>
              <div className='info-deliver-content'>{data.shopInfo && data.shopInfo.business_time_str }</div>
            </div>
            <div className='shop-info-content'>
              <div className='content-text'>店铺地址</div>
              <div className='info-deliver-content'>{data.shopInfo && data.shopInfo.address }</div>
            </div>
            { data.customFeature.isShowNotice && data.shopInfo && data.shopInfo.shop_notice &&
              <div className='shop-info-content'>
                <div className='content-text'>公告</div>
                <div className='info-deliver-content'>
                  公告：{ data.shopInfo.shop_notice }
                </div>
              </div>
            }
          </ScrollView>
          <div className='detail-close' data-compindex={ this.props.index } onClick={this.drinkHideCouponsList}>
            <label className='ico-moon icon-closes'></label>
          </div>
        </div>
      </div>
    }

    // 会员购弹窗
    const $vipDialog = () => {
      return <div className='verticalList-vipDialog' style={{
                                                             display: `${!data.showVipDialog ? 'none': 'block'}`
                                                           }}
        data-compindex={ this.props.index } onClick={this.drinkCloseVipDialog}>
        <div onClick={e => e.stopPropagation()}>
          <label onClick={this.drinkCloseVipDialog} className="ico-moon icon-closes" data-compindex={this.props.index}></label>
          <div className='vipCardUp'>
            <img src='http://test.zhichiwangluo.com/zhichi_frontend/static/webapp/images/takeout/vip_card_up.png' />
          </div>
          <div className='cardTips'>
            <span>您当前的会员卡，暂无购买该商品权限，可升级会员卡</span>
          </div>
          <ScrollView scroll-y>
            { data.vipCondtionInfo && data.vipCondtionInfo.vip_card_data.length > 0 &&
              <React.Fragment>
                { data.vipCondtionInfo.vip_card_data.map((item, index) =>
                  <div className='cardContent' key={index}>
                    <div className='card-content-title'>{ item.title }会员卡(V{ item.level })达成条件：</div>
                    { item.trade_count > -1 && <div className='card-content-tips'>累计交易成功{ item.trade_count }笔</div> }
                    { item.consume_count > -1 && <div className='card-content-tips'>或累计消费金额{ item.consume_count }元</div>}
                    { item.integral_count > -1 && <div className='card-content-tips'>或累计积分达到{ item.integral_count }分</div> }
                  </div>
                )}
              </React.Fragment>
            }
            { data.vipCondtionInfo && data.vipCondtionInfo.paid_vip_card_data.length > 0 &&
              <React.Fragment>
                { data.vipCondtionInfo.paid_vip_card_data.map((item, index) => 
                  <div className='cardContent' key={index}>
                    <div className='card-content-title'>{ item.title }会员卡(V{ item.level })达成条件：</div>
                    <div className='card-content-tips'>价格：每月{ item.price }</div>
                  </div>
                )}
              </React.Fragment>
            }
          </ScrollView>
        </div>
      </div>
    }

    return (
      <div className="custom-component drink-vertical-list">
        <div className="drinkVerticalList-wrap" data-compindex={ this.props.index }>
          <div
            className={`zcdrink-box-shadow ${data.pick_up_type.length > 1 || data.customFeature.multipleMerchants ? 'margin':''}`}>
            {/* 多商家 配送方式 */}
            { $merchatsPickup() }
            {/* 顶部定位 */}
            { +data.pick_up_select === 2 && $locationBox() }
          </div>
          {/* tab切换栏 */}
          { !data.showSearch && $tabsWrap() }
          {/* 搜索 */}
          { data.showSearch && $searchWrap() }
          {/* 分类 商品列表 */}
          { !data.showSearch && $waimaiContainerWrap() }
          {/* 搜索结果列表 */}
          { data.showSearch && $searchResult() }
          {/* 底部购物车 */}
          { $bottomShoppingCart() }
          {/* 评价 */}
          { !data.showSearch && $evaluationWrap() }
          {/* 店铺 */}
          { !data.showSearch && $takeoutShopInfo() }
          {/* 商品详情弹窗 */}
          { data.goodsDetailShow && $goodsDetailDialog() }
          {/* 单规格属性弹窗 */}
          { $takeoutModelChoose() }
          {/* 单人购物车 */}
          { $verticalListShoppingCartsList() }
          {/* 多人购物车 */}
          { data.showGoodDetailMask &&
            <div className="settlement-mask" data-compindex={this.props.index} onClick={this.drinkHideDetailPop} onTouchMove={this.drinkStopMove}></div>
          }
          {/* 优惠券弹窗 */}
          { $couponsList() }
          {/* 会员购弹窗 */}
          { $vipDialog() }
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/custom-component/drink-vertical-list-custom-component/DrinkVerticalListCustomComponent.jsx